import React, { useEffect, useRef, useState, useMemo } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/management.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import "../assets/css/report.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//     faEdit,
//     faPlus,
//     faSort,
//     faTrash,
//     faPenToSquare,
//     faTimes,
//     faExclamationTriangle,
//     faDownload,
//     faEllipsisV,
//     faSearch,
//     faL,
// } from "@fortawesome/free-solid-svg-icons";
import clientlogo from "../assets/img/user1.jpg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate, Link } from "react-router-dom";
import ReactDOM from "react-dom";
// import { Wizard, Steps, Step, WithWizard } from "react-multistep-wizard";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Textarea } from "@material-tailwind/react";
import { Circle } from "@mui/icons-material";
// import { commonAPI } from "../services/CommonAPIService";
import { ErrorSource } from "../common/constants";
import { myFont } from "../common/fontBase64";
import Menus from "./menus";
import TextareaAutosize from 'react-textarea-autosize';
import noticeuserupload from '../assets/img/noticeuserupload.png';
import JoditEditor from 'jodit-react';
import Table from 'react-bootstrap/Table';
import { DownloadTableExcel } from 'react-export-table-to-excel';
// import { ExcelFile, ExcelSheet } from 'react-export-excel';
import { usePDF } from 'react-to-pdf';
import generatePDF, { Resolution, Margin } from 'react-to-pdf';
import { commonAPI } from "../services/CommonAPIService";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FlatIcon from '../assets/img/config-flat.png';
import curonext from '../assets/img/CuronextFinal.png';
import ExportToExcel from './ExportExcel';
import * as XLSX from 'xlsx';
import { Offline, Online } from "react-detect-offline";
import NoInternet from "./Nointernet";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Select from 'react-select';
import SelectSearch from "react-dropdown-select";
import { Badge } from "react-bootstrap";
import ServiceStaffInOutReport from "./ServiceStaffReport";
import {
    faEdit,
    faPlus,
    faSort,
    faTrash,
    faPenToSquare,
    faTimes,
    faExclamationTriangle,
    faDownload,
    faEllipsisV,
    faSearch,
    faCheck, // Add this,
    faPlay
} from "@fortawesome/free-solid-svg-icons";
// Add import at the top
import TowerReport from './TowerReport';





const CustomMultiSelect = ({ options, selected = [], onChange, reportName }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleToggle = (option) => {
        const newSelected = selected.includes(option)
            ? selected.filter(item => item !== option)
            : [...selected, option];
        onChange(newSelected);
    };

    const handleSelectAll = () => {
        onChange(selected.length === options.length ? [] : [...options]);
    };

    return (
        <div className="position-relative" ref={dropdownRef}>
            <div
                className="form-control d-flex justify-content-between align-items-center"
                style={{ cursor: 'pointer', minHeight: '38px' }}
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="d-flex flex-wrap gap-1 flex-grow-1">
                    {selected.length === 0 && <span className="text-muted">Select scheduling...</span>}
                    {selected.length > 0 && selected.length <= 2 &&
                        selected.map((item, idx) => (
                            <Badge key={idx} bg="primary" className="me-1">{item}</Badge>
                        ))
                    }
                    {selected.length > 2 && <Badge bg="primary">{selected.length} selected</Badge>}
                </div>
                <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`}></i>
            </div>

            {isOpen && (
                <div
                    className="border rounded bg-white shadow position-absolute w-100 mt-1"
                    style={{ maxHeight: '250px', overflowY: 'auto', zIndex: 1050 }}
                >
                    <div className="p-2 border-bottom">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`select-all-${reportName}`}
                                checked={selected.length === options.length}
                                onChange={handleSelectAll}
                            />
                            <label className="form-check-label fw-bold" htmlFor={`select-all-${reportName}`}>
                                Select All
                            </label>
                        </div>
                    </div>
                    <div className="p-2">
                        {options.map((option, idx) => (
                            <div key={idx} className="form-check mb-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`${reportName}-${idx}`}
                                    checked={selected.includes(option)}
                                    onChange={() => handleToggle(option)}
                                />
                                <label className="form-check-label" htmlFor={`${reportName}-${idx}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};





function Report() {
    const history = useNavigate();
    const [activeTab, setActiveTab] = useState("tab1");
    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };
    const [reset, setReset] = useState(0);
    // const [UserDataAysnc, setUserDataAysnc] = useState("");
    const [fullscreen, setFullscreen] = useState(true);
    const [activeStep, setActiveStep] = useState(0);
    const steps = ["Step 1", "Step 2", "Step 3"];
    const [show, setShow] = useState(false);
    const [ShowVisitor, setShowVisitor] = useState(false);
    const [ShowWalkIn, setShowWalkIn] = useState(false);
    const [ShowResidingResident, setShowResidingResident] = useState(false);
    const [ShowOwnerRepot, setShowOwnerRepot] = useState(false);
    const [ShowTenantRepot, setShowTenantRepot] = useState(false);
    const [ShowVehicleRepot, setShowVehicleRepot] = useState(false);
    const [ShowStaffRepot, setShowStaffRepot] = useState(false);
    const [ShowHelpDeskRepot, setShowHelpDeskRepot] = useState(false);
    const [ActiveRepot, setActiveRepot] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [GateList, setGateList] = useState("");
    const [StartDate, setStartDate] = useState("");
    const [StartTime, setStartTime] = useState("");
    const [EndDate, setEndDate] = useState("");
    const [EndTime, setEndTime] = useState("");
    const [WheeleType, setWheeleType] = useState("");
    const [EntryGate, setEntryGate] = useState("");
    const [ExitGate, setExitGate] = useState("");
    const [ResidentData, setResidentData] = useState([]);
    const [VehicleData, setVehicleData] = useState([]);
    const [OldVehicleData, setOldVehicleData] = useState([]);
    const [OldResidentData, setOldResidentData] = useState([]);
    const [VisitorData, setVisitorData] = useState("");
    const [OldVisitorData, setOldVisitorData] = useState([]);
    const [WalkInData, setWalkInData] = useState("");
    const [SearchData, setSearchData] = useState("");
    const [OldWalkInData, setOldWalkInData] = useState([]);
    const [selectedImageTwo, setSelectedImageTwo] = useState(null);
    const [selectedImageTwoShow, setSelectedImageTwoShow] = useState(null);
    const [firstSectionButton, setFirstSectionButton] = useState(false);
    const [UserData, setUserData] = useState("");
    const [HeaderShow, setHeaderShow] = useState(false);
    const [TowerList, setTowerList] = useState(false);
    const [BuildingList, setBuildingList] = useState([]);
    const [SelectedTower, setSelectedTower] = useState();
    const [SelectedTowerName, setSelectedTowerName] = useState();
    const [FlatList, setFlatList] = useState(false);
    const [SelectedFlat, setSelectedFlat] = useState();
    const [SelectedFlatName, setSelectedFlatName] = useState();
    const [ResidentResidingData, setResidentResidingData] = useState();
    const [OldResidingData, setOldResidingData] = useState();
    const [VehicleTypeSelect, setVehicleTypeSelect] = useState();
    const [SecurityLockSelect, setSecurityLockSelect] = useState();
    const [DepartmentList, setDepartmentList] = useState("")
    const [DepartmentId, setDepartmentId] = useState("")
    const [RoleList, setRoleList] = useState("")
    const [RoleId, setRoleId] = useState("")
    const [RoleName, setRoleName] = useState("")
    const [JobType, setJobType] = useState("")
    const [ImageLogo, setImageLogo] = useState("")
    const [Oldlogo, setOldImageLogo] = useState("")
    const [DepartmentName, setDepartmentName] = useState("")
    const [UrgentStatus, setUrgentStatus] = useState("")
    const [FamilyMember, setFamilyMember] = useState(false);
    const [StatusList, setStatusList] = useState([])
    const [StatusName, setStatusName] = useState("")
    const [StatusId, setStatusId] = useState("")
    const [ComplainList, setComplainList] = useState("")
    const [OldComplainList, setOldComplainList] = useState("")
    const [CategoryList, setCategoryList] = useState([])
    const [CategoryName, setCategoryName] = useState("")
    const [CategoryId, setCategoryId] = useState("")
    const [StaffList, setStaffList] = useState([])
    const [StaffName, setStaffName] = useState("")
    const [BuildingId, setBuildingId] = useState("")
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState([]);
    const [slideshowHeight, setSlideshowHeight] = useState(0);
    const [IsResiding, setIsResiding] = useState(true);
    const [GetActiveUser, setGetActiveUser] = useState([]);
    // Scheduling Report States
    const [showResidentSchedulingReport, setShowResidentSchedulingReport] = useState(false);
    const [showAddReportMasterModal, setShowAddReportMasterModal] = useState(false);
    const [residentSchedulingData, setResidentSchedulingData] = useState([]);
    const [scheduleLoading, setScheduleLoading] = useState(false);
    const [scheduleError, setScheduleError] = useState(null);
    const [editingRow, setEditingRow] = useState(null);
    const [runningRows, setRunningRows] = useState({});
    const [schedulingSelections, setSchedulingSelections] = useState({});
    const [reportRecipients, setReportRecipients] = useState({});
    const [runManuallyPeriods, setRunManuallyPeriods] = useState({});
    // Report Master List States
    const [reportMasterList, setReportMasterList] = useState([]);
    const [reportMasterLoading, setReportMasterLoading] = useState(false);
    const [editingReportMaster, setEditingReportMaster] = useState(null);
    // Add these states at the beginning with other states
    const [refreshReportMaster, setRefreshReportMaster] = useState(0);
    const [refreshReportScheduling, setRefreshReportScheduling] = useState(0);
    // Add these states at the beginning with other states
    const [DeleteShow, setDeleteShow] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null); // To store what to delete
    const [deleteType, setDeleteType] = useState(""); // "reportSchedule" or "reportMaster"
const [showServiceStaffInOutReport, setShowServiceStaffInOutReport] = useState(false);
const ServiceStaffInOutModal = () => {
    setShowServiceStaffInOutReport(true);
};
    // Add state in your component
    const [ShowTowerReport, setShowTowerReport] = useState(false);

    // For adding new report master
    const [newReportMaster, setNewReportMaster] = useState({
        reportName: "",
        reportShortName: "",
    });



    const [showAddRow, setShowAddRow] = useState(false);
    const [newReportData, setNewReportData] = useState({
        reportName: "",
        reportMasterId: "",
    });

    const schedulingOptions = ["Daily", "Weekly", "Monthly", "Quarterly", "Half Yearly", "Yearly"];
    const periodOptions = ["Daily", "Weekly", "Monthly", "Quarterly", "Half Yearly", "Yearly"];

    // Add this at the beginning of your Report function, right after your existing state declarations
    const [scheduleRows, setScheduleRows] = useState([]);

    // Helper to get logged-in user ID
    const getLoggedUserId = () => {
        const auth = localStorage.getItem("userData");
        return auth ? JSON.parse(auth).userId : "";
    };

    // Complete clearFilter function
    const clearFilter = (filterType) => {
        if (filterType === "residentScheduling") {
            setSchedulingSelections({});
            setReportRecipients({});
            setRunManuallyPeriods({});
        }
    };

    const handleSaveReportSchedule = async (reportData) => {
        const loggedUserId = getLoggedUserId();

        if (!loggedUserId) {
            toast.error("User not logged in");
            return;
        }

        const reportName = reportData.reportName;
        const selectedScheduling = schedulingSelections[reportName] || [];
        const recipients = reportRecipients[reportName] || "";

        // Check if this is an add or update
        const hasExistingData =
            selectedScheduling.length > 0 || recipients.trim() !== "";

        if (!hasExistingData) {
            toast.warning("Please configure Scheduling or Report Recipients");
            return;
        }

        if (!recipients.trim().endsWith(';')) {
            toast.warning("Please add a semicolon after the last entry of the recipient mail ID.");
            return;
        }

        try {
            setRunningRows((prev) => ({ ...prev, [reportName]: true }));

            const schedulePrimeFactor = schedulingToPrimeFactor(selectedScheduling);
            const period = runManuallyPeriods[reportName] || "";

            // Get buildingId from localStorage
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);

            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId,
            };

            let response;

            // Check if schedule exists
            if (reportData.scheduleId) {
                // Update existing schedule
                const payload = {
                    scheduleId: reportData.scheduleId,
                    modifiedUserId: loggedUserId.toString(),
                    schedulePrimeFactor: schedulePrimeFactor,
                    reportRecipients: recipients,
                    // runManuallyPeriod: period,
                };

                response = await commonAPI("UpdateReportScheduling", payload, endPointVariableKey);
            } else {
                // Add new schedule
                const payload = {
                    createdUserId: loggedUserId.toString(),
                    reportMasterId: reportData.reportMasterId,
                    reportName: reportName,
                    schedulePrimeFactor: schedulePrimeFactor,
                    reportRecipients: recipients,
                    runManuallyPeriod: period,
                };

                response = await commonAPI("AddReportScheduling", payload, endPointVariableKey);
            }

            if (response?.success) {
                toast.success(
                    reportData.scheduleId
                        ? `${reportName} updated successfully`
                        : `${reportName} added successfully`
                );

                // Refresh data
                const refreshResponse = await commonAPI("GetReportScheduling", null, endPointVariableKey);
                if (refreshResponse?.success) {
                    const schedules = refreshResponse.data || [];
                    const reportMap = {};
                    schedules.forEach((schedule) => {
                        reportMap[schedule.reportName] = schedule;
                    });
                    setResidentSchedulingData(Object.values(reportMap));
                }

                setEditingRow(null);
            } else {
                toast.error(response?.message?.[0] || "Failed to save schedule");
            }
        } catch (error) {
            console.error("Error saving schedule:", error);
            toast.error("Error saving schedule");
        } finally {
            setRunningRows((prev) => ({ ...prev, [reportName]: false }));
        }
    };



    // Handle delete report schedule - Show modal
    const handleDeleteReportClick = (reportName, scheduleId) => {
        if (!scheduleId) {
            toast.warning("No schedule to delete");
            return;
        }

        setDeleteTarget({ reportName, scheduleId });
        setDeleteType("reportSchedule");
        setDeleteShow(true);
    };

    // Actual delete function called from modal
    const handleDeleteReport = async () => {
        if (!deleteTarget) return;

        const { reportName, scheduleId } = deleteTarget;

        try {
            setRunningRows((prev) => ({ ...prev, [reportName]: true }));

            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);

            const payload = {
                modifiedUserId: getLoggedUserId().toString(),
                scheduleId: scheduleId,
            };

            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId,
            };

            const response = await commonAPI("DeleteReportScheduling", payload, endPointVariableKey);

            if (response?.success) {
                toast.success(`${reportName} schedule deleted successfully`);

                // Close modal
                setDeleteShow(false);
                setDeleteTarget(null);

                // Trigger refresh
                setRefreshReportScheduling((prev) => prev + 1);

                // Clear form data for deleted report
                setSchedulingSelections((prev) => {
                    const newState = { ...prev };
                    delete newState[reportName];
                    return newState;
                });
                setReportRecipients((prev) => {
                    const newState = { ...prev };
                    delete newState[reportName];
                    return newState;
                });
                setRunManuallyPeriods((prev) => {
                    const newState = { ...prev };
                    delete newState[reportName];
                    return newState;
                });
            } else {
                toast.error(response?.message?.[0] || "Failed to delete schedule");
            }
        } catch (error) {
            console.error("Error deleting schedule:", error);
            toast.error("Error deleting schedule");
        } finally {
            setRunningRows((prev) => ({ ...prev, [reportName]: false }));
        }
    };




    // Helper function to calculate date range based on period
    const calculateDateRange = (period) => {
        const endDate = new Date();
        const startDate = new Date();

        switch (period) {
            case "Weekly":
                startDate.setDate(endDate.getDate() - 7);
                break;
            case "Monthly":
                startDate.setMonth(endDate.getMonth() - 1);
                break;
            case "Quarterly":
                startDate.setMonth(endDate.getMonth() - 3);
                break;
            case "Half Yearly":
                startDate.setMonth(endDate.getMonth() - 6);
                break;
            case "Yearly":
                startDate.setFullYear(endDate.getFullYear() - 1);
                break;
            default:
                return null;
        }

        // Format dates as YYYY-MM-DDTHH:mm
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}T00:00`;
        };

        const formatEndDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}T23:59`;
        };

        return {
            startDate: formatDate(startDate),
            endDate: formatEndDate(endDate),
        };
    };

    const handleRunManually = async (reportData) => {
        const reportName = reportData.reportName;
        const selectedScheduling = schedulingSelections[reportName];
        const recipients = reportRecipients[reportName];
        const period = runManuallyPeriods[reportName];

        if (!period) {
            toast.warning("Please select a period before running");
            return;
        }

        if (selectedScheduling?.length === 0 || !recipients) {
            toast.warning("Please configure Scheduling or Report Recipients before running");
            return;
        }

        try {
            setRunningRows((prev) => ({ ...prev, [reportName]: true }));

            const auth = localStorage.getItem("userData");
            if (!auth) {
                toast.error("User data not found");
                return;
            }

            const myUserData = JSON.parse(auth);
            const buildingId = myUserData?.buildingId;

            if (!buildingId) {
                toast.error("Building ID not found");
                return;
            }

            const scheduleId = reportData.scheduleId;
            if (!scheduleId) {
                toast.error("Schedule ID is missing");
                return;
            }

            // Map period to prime number values
            const periodToPrimeFactor = {
                "Daily": 2,
                "Weekly": 3,
                "Monthly": 5,
                "Quarterly": 7,
                "Half Yearly": 11,
                "Yearly": 13,
            };

            const schedulePrimeFactor = periodToPrimeFactor[period];

            if (!schedulePrimeFactor) {
                toast.error("Invalid period selected");
                return;
            }

            const endPointVariableKey = { urlVariable: null, buildingId: buildingId };

            const payload = {
                scheduleId: scheduleId,
                schedulePrimeFactor: schedulePrimeFactor,
            };

            const response = await commonAPI("ReportSchedulingRunNow", payload, endPointVariableKey);

            if (response?.success) {
                toast.success(`${reportName} executed successfully for ${period} period`);
            } else {
                toast.error(response?.message?.[0] || `Failed to run ${reportName}`);
            }
        } catch (error) {
            console.error("Error running report manually", error);
            toast.error("Error running report");
        } finally {
            setRunningRows((prev) => ({ ...prev, [reportName]: false }));
        }
    };






    // Fetch scheduling data when modal opens OR when refresh is triggered
    useEffect(() => {
        if (!showResidentSchedulingReport) return;

        const fetchSchedulingData = async () => {
            try {
                setScheduleLoading(true);
                setScheduleError(null);

                const auth = localStorage.getItem("userData");
                const myUserData = JSON.parse(auth);
                const endPointVariableKey = {
                    urlVariable: null,
                    buildingId: myUserData?.buildingId,
                };

                // Fetch report scheduling data
                const response = await commonAPI("GetReportScheduling", null, endPointVariableKey);

                if (response?.success) {
                    const schedules = response.data || [];

                    // Set the scheduling data directly
                    setResidentSchedulingData(schedules);

                    // Populate form fields
                    const newSchedulingSelections = {};
                    const newReportRecipients = {};
                    const newRunManuallyPeriods = {};

                    schedules.forEach((schedule) => {
                        const reportName = schedule.reportName;
                        newSchedulingSelections[reportName] = primeFactorToScheduling(
                            schedule.schedulePrimeFactor || 0
                        );
                        newReportRecipients[reportName] = schedule.reportRecipients || "";
                        newRunManuallyPeriods[reportName] = schedule.runManuallyPeriod || "";
                    });

                    setSchedulingSelections(newSchedulingSelections);
                    setReportRecipients(newReportRecipients);
                    setRunManuallyPeriods(newRunManuallyPeriods);
                } else {
                    setScheduleError(response?.message?.[0] || "Failed to load schedules");
                    toast.error(response?.message?.[0] || "Failed to load schedules");
                }
            } catch (err) {
                setScheduleError(err?.message || "Network error");
                toast.error("Error loading report schedules");
                console.error(err);
            } finally {
                setScheduleLoading(false);
            }
        };

        fetchSchedulingData();
    }, [showResidentSchedulingReport, refreshReportScheduling]); // Add refreshReportScheduling as dependency



    // Fetch report master list when "Add Report Master" modal opens OR when refresh is triggered
    useEffect(() => {
        if (!showAddReportMasterModal) return;

        const fetchReportMasterList = async () => {
            try {
                setReportMasterLoading(true);

                const auth = localStorage.getItem("userData");
                const myUserData = JSON.parse(auth);
                const endPointVariableKey = {
                    urlVariable: null,
                    buildingId: myUserData?.buildingId,
                };

                // GetReportMaster is a POST API
                const response = await commonAPI("GetReportMaster", undefined, endPointVariableKey);

                if (response?.success) {
                    setReportMasterList(response.data || []);
                } else {
                    toast.error(response?.message?.[0] || "Failed to load report masters");
                }
            } catch (error) {
                console.error("Error loading report masters:", error);
                toast.error("Error loading report masters");
            } finally {
                setReportMasterLoading(false);
            }
        };

        fetchReportMasterList();
    }, [showAddReportMasterModal, refreshReportMaster]); // Add refreshReportMaster as dependency


    // Handle add new report master
    const handleAddReportMaster = async () => {
        if (!newReportMaster.reportName || !newReportMaster.reportShortName) {
            toast.warning("Please fill all fields");
            return;
        }

        try {
            setReportMasterLoading(true);

            const loggedUserId = getLoggedUserId();
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);

            const payload = {
                reportName: newReportMaster.reportName,
                reportShortName: newReportMaster.reportShortName,
                createdUserId: loggedUserId.toString(),
            };

            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId,
            };

            const response = await commonAPI("AddReportMaster", payload, endPointVariableKey);

            if (response?.success) {
                toast.success("Report master added successfully");

                // Reset form
                setNewReportMaster({ reportName: "", reportShortName: "" });
                setEditingReportMaster(null);

                // Trigger refresh for BOTH lists by updating state
                setRefreshReportMaster(prev => prev + 1);
                setRefreshReportScheduling(prev => prev + 1);
            } else {
                toast.error(response?.message?.[0] || "Failed to add report master");
            }
        } catch (error) {
            console.error("Error adding report master:", error);
            toast.error("Error adding report master");
        } finally {
            setReportMasterLoading(false);
        }
    };






    // Handle update report master
    const handleUpdateReportMaster = async (reportMasterId) => {
        if (!newReportMaster.reportName || !newReportMaster.reportShortName) {
            toast.warning("Please fill all fields");
            return;
        }

        try {
            setReportMasterLoading(true);

            const loggedUserId = getLoggedUserId();
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);

            const payload = {
                reportMasterId: reportMasterId,
                reportName: newReportMaster.reportName,
                reportShortName: newReportMaster.reportShortName,
                modifiedUserId: loggedUserId.toString(),
            };

            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId,
            };

            const response = await commonAPI("UpdateReportMaster", payload, endPointVariableKey);

            if (response?.success) {
                toast.success("Report master updated successfully");

                // Reset form
                setNewReportMaster({ reportName: "", reportShortName: "" });
                setEditingReportMaster(null);

                // Trigger refresh for BOTH lists
                setRefreshReportMaster(prev => prev + 1);
                setRefreshReportScheduling(prev => prev + 1);
            } else {
                toast.error(response?.message?.[0] || "Failed to update report master");
            }
        } catch (error) {
            console.error("Error updating report master:", error);
            toast.error("Error updating report master");
        } finally {
            setReportMasterLoading(false);
        }
    };

    // Universal delete handler for the modal
    const handleConfirmDelete = () => {
        if (deleteType === "reportSchedule") {
            handleDeleteReport();
        } else if (deleteType === "reportMaster") {
            handleDeleteReportMaster();
        }
    };




    // Handle delete report master - Show modal
    const handleDeleteReportMasterClick = (reportMasterId, reportName) => {
        setDeleteTarget({ reportMasterId, reportName });
        setDeleteType("reportMaster");
        setDeleteShow(true);
    };

    // Actual delete function called from modal
    const handleDeleteReportMaster = async () => {
        if (!deleteTarget) return;

        const { reportMasterId, reportName } = deleteTarget;

        try {
            setReportMasterLoading(true);

            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);

            const payload = {
                reportMasterId: reportMasterId,
                modifiedUserId: getLoggedUserId().toString(),
            };

            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId,
            };

            const response = await commonAPI("DeleteReportMaster", payload, endPointVariableKey);

            if (response?.success) {
                toast.success("Report master deleted successfully");

                // Close modal
                setDeleteShow(false);
                setDeleteTarget(null);

                // Trigger refresh for BOTH lists
                setRefreshReportMaster((prev) => prev + 1);
                setRefreshReportScheduling((prev) => prev + 1);
            } else {
                toast.error(response?.message?.[0] || "Failed to delete report master");
            }
        } catch (error) {
            console.error("Error deleting report master:", error);
            toast.error("Error deleting report master");
        } finally {
            setReportMasterLoading(false);
        }
    };






    // Convert scheduling selections to prime factor
    const schedulingToPrimeFactor = (selectedScheduling) => {
        let factor = 1; // Start with 1 (multiplicative identity)

        if (selectedScheduling.includes("Daily")) factor *= 2;
        if (selectedScheduling.includes("Weekly")) factor *= 3;
        if (selectedScheduling.includes("Monthly")) factor *= 5;
        if (selectedScheduling.includes("Quarterly")) factor *= 7;
        if (selectedScheduling.includes("Half Yearly")) factor *= 11;
        if (selectedScheduling.includes("Yearly")) factor *= 13;

        return factor;
    };


    const primeFactorToScheduling = (primeFactor) => {
        const schedulingArray = [];

        if (primeFactor % 2 === 0) schedulingArray.push("Daily");
        if (primeFactor % 3 === 0) schedulingArray.push("Weekly");
        if (primeFactor % 5 === 0) schedulingArray.push("Monthly");
        if (primeFactor % 7 === 0) schedulingArray.push("Quarterly");
        if (primeFactor % 11 === 0) schedulingArray.push("Half Yearly");
        if (primeFactor % 13 === 0) schedulingArray.push("Yearly");

        return schedulingArray;
    };








    /* ------------------- clearFilter (used in two places) ------------------- */
    //   const clearFilter = () => {
    //     setSchedulingSelections(empty.scheduling);
    //     setReportRecipients(empty.recipients);
    //     setRunManuallyPeriods(empty.runManually);
    //   };


    const tableRef = useRef(null);
    console.log("SelectedGate", EntryGate, ExitGate)

    // const options = {
    //     backgroundColor: '#FFFFFF',
    //     scale: 1, // Increase scale if canvas size is an issue
    //     useCORS: true // Enable CORS if there are any image resources
    // };

    const updateSlideshowHeight = () => {
        const winHeight = window.innerHeight; // Get the window height
        setSlideshowHeight(winHeight - 320); // Set the slideshow height
    };

    useEffect(() => {
        updateSlideshowHeight();
        window.addEventListener('resize', updateSlideshowHeight);

        return () => {
            window.removeEventListener('resize', updateSlideshowHeight);
        };
    }, []);

    const sortData = (data, sortBy) => {
        return data.sort((a, b) => {
            if (a[sortBy] < b[sortBy]) return -1;
            if (a[sortBy] > b[sortBy]) return 1;
            return 0;
        });
    };


    useEffect(() => {
        const storedUsername = localStorage.getItem('userData');
        const myUserData = JSON.parse(storedUsername);
        console.log("useEffect Local storage name", storedUsername)
        if (storedUsername) {
            // If the username is present, redirect to the dashboard
            if (myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Support Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator" || myUserData?.roleName == "Society HelpDesk") {
                if (myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator" || myUserData?.roleName == "Society HelpDesk") {
                    history('/Report');
                    return
                } else {
                    history('/Dashboard');
                    return
                }

            } else {
                history('/Dashboard');
                console.log("useEffect Local storage Yes")
                return
            }
        }
        else if (storedUsername === null) {
            history('/');
            console.log("useEffect Local storage No")
        }
    }, [history]);

    const setInputValue = () => {
        setShow(true);
        setStartDate("")
        setEndDate("")
        setWheeleType("")
        setEntryGate("0")
        setExitGate("0")
        setResidentData("")
        setStartTime("")
        setEndTime("")
        setSearchData("")
    };

    const VisitorModal = () => {
        setShowVisitor(true);
        setStartDate("")
        setEndDate("")
        setWheeleType("")
        setEntryGate("0")
        setExitGate("0")
        setVisitorData("")
        setStartTime("")
        setEndTime("")
        setSearchData("")
    };

    const WalkInModal = () => {
        setShowWalkIn(true);
        setStartDate("")
        setEndDate("")
        setWheeleType("")
        setEntryGate("0")
        setExitGate("0")
        setWalkInData("")
        setStartTime("")
        setEndTime("")
        setSearchData("")
    };

    const ServiceStaffModal = () => {
        setShowStaffRepot(true);
        setDepartmentName("");
        setDepartmentId("");
        setRoleId("");
        setRoleName("")
        setJobType("")
        setSearchData("")
        setImageLogo("")
    };

    const ResidingResidentModal = () => {
        setShowResidingResident(true);
        setSelectedTower("");
        setSelectedTowerName("")
        setSelectedFlat("");
        setSelectedFlatName("")
        setFamilyMember(false)
        setResidentResidingData("")
    };

    const ActiveUserModal = () => {
        setActiveRepot(true);
        setTowerList([])
        setSelectedTower("");
        setSelectedTowerName("")
        setSelectedFlat("");
        setSelectedFlatName("")
        setIsResiding(true)
        setGetActiveUser([])
    };
    const ResetActiveUserModal = () => {
        setBuildingId("")
        setTowerList([])
        setSelectedTower("");
        setSelectedTowerName("")
        setSelectedFlat("");
        setSelectedFlatName("")
        setIsResiding(false)
        setGetActiveUser([])
    };

    const OwnerModal = () => {
        setShowOwnerRepot(true);
        setSelectedTower("");
        setSelectedTowerName("")
        setSelectedFlat("");
        setSelectedFlatName("")
        setFamilyMember(false)
        setResidentResidingData("")
    };

    const TenantModal = () => {
        setShowTenantRepot(true);
        setSelectedTower("");
        setSelectedTowerName("")
        setSelectedFlat("");
        setSelectedFlatName("")
        setFamilyMember(false)
        setResidentResidingData("")
    };


    const HelpDeskModal = () => {
        setShowHelpDeskRepot(true);
        setStartDate("")
        setEndDate("")
        setSelectedTower("");
        setSelectedTowerName("")
        setSelectedFlat("");
        setSelectedFlatName("")
        setUrgentStatus("")
        setComplainList([]);
        setCategoryName("")
        setStatusName("")
        setStaffName("")
        setSelectedOptions([])
        setSelectedCategories([])
        setSelectedStaff([])
        setSearchData("")
    };

    const VehicleModal = () => {
        setShowVehicleRepot(true);
        setSelectedTower("");
        setSelectedTowerName("")
        setSelectedFlat("");
        setSelectedFlatName("")
        setSecurityLockSelect("")
        setVehicleTypeSelect("")
        setVehicleData("")
    };

    const GetGateList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        //   setUserData(myUserData)
        try {

            setLoading(true);
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId

            }
            let response = await commonAPI("Gate", undefined, endPointVariableKey)
            if (response?.success === true) {
                console.log("Gate List", response);
                setGateList(response?.data);
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "api/Master/Gate",
                "errorNumber": "GL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Report.js",
                "functionName": "GetGateList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };

    const GetBuildingList = async () => {
        try {
            setLoading(true);
            const auth = localStorage.getItem("primeProductCode");
            const ProductfactorKey = JSON.parse(auth);
            const endPointVariableKey = {
                ProductId: ProductfactorKey?.primeProductCode,
            }
            let response = await commonAPI("Building", undefined, endPointVariableKey);
            if (response?.success === true) {
                // Assuming response.data is the building list
                setBuildingList(response?.data); // Uncomment if you have a state for building list
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": "",
                "mobileNumber": "",
                "requestJSON": null,
                "uri": "api/Master/Building",
                "errorNumber": "BL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Report.js",
                "functionName": "GetBuildingList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
            } else {
                toast.error("Something went wrong");
            }
        }
    };

    const GetTowerListAcive = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            setLoading(true)
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.roleName === "Super Admin" ? BuildingId : myUserData?.buildingId
            }
            let response = await commonAPI("Tower", undefined, endPointVariableKey)
            console.log("response tower", response, BuildingId)
            if (response?.success === true) {
                setTowerList(response?.data);
                setLoading(false);
            } else {
                toast.error(response?.message[0]);
                setTowerList([])
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "api/Master/Tower",
                "errorNumber": "TL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Report.js",
                "functionName": "GetTowerList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };


    useEffect(() => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        if (myUserData?.roleName === "Super Admin") {
            if (BuildingId) {
                GetTowerListAcive();
            }
        } else if (myUserData) {
            GetTowerListAcive();
        }
    }, [BuildingId, ActiveRepot]);

    useEffect(() => {
        if (SelectedTower) {
            GetFlatList();

        } else {
            setSelectedFlat("");
            setFlatList("")
        }
    }, [SelectedTower]);

    useEffect(() => {
        GetBuildingList()
    }, [])

    const GetTowerList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {

            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId

            }
            let response = await commonAPI("Tower", undefined, endPointVariableKey)
            if (response?.success === true) {
                setTowerList(response?.data);
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "api/Master/Tower",
                "errorNumber": "TL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Report.js",
                "functionName": "GetTowerList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };


    const GetFlatList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        //   setUserData(myUserData)
        try {

            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId

            }
            let response = await commonAPI("Flat", undefined, endPointVariableKey)
            if (response?.success === true) {
                const tempData = response?.data.filter((item) => item?.towerId == SelectedTower)
                setFlatList(tempData);
                setLoading(false);
                setSelectedFlat("");
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "api/Master/Gate",
                "errorNumber": "GL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Report.js",
                "functionName": "GetGateList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };

    useEffect(() => {
        GetTowerList();
    }, [ShowResidingResident]);

    useEffect(() => {
        if (SelectedTower) {
            GetFlatList();

        } else {
            setSelectedFlat("");
            setFlatList("")
        }
    }, [SelectedTower]);

    const GetDepartmentList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            // let myBuildingId;

            // setLoading(true);
            const endPointVariableKey = {
                // urlVariable: CategoryIdSelected,
                buildingId: myUserData?.buildingId
            }

            let response = await commonAPI("Department", undefined, endPointVariableKey);
            if (response?.success === true) {
                console.log("Table Department", response)
                setDepartmentList(response?.data);
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "Department",
                "errorNumber": "DL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "ServiceStaff.js",
                "functionName": "GetDepartmentList",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    const GetRoleList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {

            // setLoading(true);
            const endPointVariableKey = {
                urlVariable: DepartmentId,
                buildingId: myUserData?.buildingId
            }

            let response = await commonAPI("SocietyRole", undefined, endPointVariableKey);
            if (response?.success === true) {
                console.log("Table RoleList", response)
                setRoleList(response?.data[0].roles);
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "SocietyRole",
                "errorNumber": "SRL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "ServiceStaff.js",
                "functionName": "GetSocietyRoleList",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    useEffect(() => {
        if (ShowStaffRepot) {
            GetDepartmentList();
        }
    }, [ShowStaffRepot]);

    useEffect(() => {
        if (DepartmentId) {
            GetRoleList();
        } else {
            setRoleList([])
        }
    }, [DepartmentId]);

    const fetchDataServiceStaff = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);

        const bodyReq = {
            "userName": null,
            "jobType": JobType ? JobType : null,
            "departmentId": DepartmentId ? DepartmentId : null,
            "roleId": RoleId ? RoleId : null
        }
        console.log("bodyReq", bodyReq)
        // setLoading(true);
        const endPointVariableKey = {
            buildingId: myUserData?.buildingId,
        }
        setLoading(true)
        try {
            let response = await commonAPI("ServiceStaff", bodyReq, endPointVariableKey);
            if (response?.success == true) {
                console.log("ServiceStaff", response);
                setImageLogo(response?.data)
                setOldImageLogo(response?.data)
                setLoading(false)
            }
            else {
                toast.error("Something went wrong")
                setLoading(false)
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyReq,
                "uri": "ServiceStaff",
                "errorNumber": "SSL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "ServiceStaff.js",
                "functionName": "GetServiceStaff",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };


    const GetFilterList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId
            }
            const statusPromise = commonAPI("ComplaintStatus", undefined, endPointVariableKey);
            const ComplaintCategoryPromise = commonAPI("ComplaintCategory", undefined, endPointVariableKey)
            const staffPromise = commonAPI("GetServiceStaff", {}, endPointVariableKey);

            const [statusResponse, ComplaintCategoryResponse, staffResponse] = await Promise.all([
                statusPromise,
                ComplaintCategoryPromise,
                staffPromise,
            ]);
            console.log("statusPromise GetServiceStaff", statusResponse, ComplaintCategoryResponse, staffResponse)
            if (statusResponse?.success === true) {
                setStatusList(statusResponse?.data)
                setCategoryList(ComplaintCategoryResponse?.data)
                setStaffList(staffResponse?.data)
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "api/Master/Gate",
                "errorNumber": "GL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Report.js",
                "functionName": "GetGateList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };

    useEffect(() => {
        GetFilterList();
    }, [ShowHelpDeskRepot]);

    const handleChangeStatus = (selected) => {
        setSelectedOptions(selected);
        const statusIds = selected.map(option => option.label).join(',') || null;
        setStatusName(statusIds)
    };

    const options = StatusList.map(item => ({
        value: item.statusId,
        label: item.statusName
    }));

    const optionsCategory = CategoryList.map(item => ({
        value: item.categoryId,
        label: item.categoryName,
    }));

    const optionsStaff = StaffList.map(item => ({
        value: item.staffId,
        label: item.userName,
    }));

    const handleChangeCategory = (selected) => {
        setSelectedCategories(selected);
        const statusCategory = selected.map(option => option.label).join(',') || null;
        setCategoryName(statusCategory)
    };

    const handleChangeStaff = (selected) => {
        setSelectedStaff(selected);
        const statusStaff = selected.map(option => option.label).join(',') || null;
        setStaffName(statusStaff)
    };

    async function SearchComplaint() {
        let buildingId;
        let userData = localStorage.getItem("userData");
        if (userData) {
            userData = JSON.parse(userData);
            buildingId = userData.buildingId;
        }
        let endPointVariableKey = { buildingId };

        if (!StartDate) {
            toast.warning("Please select Start Date");
            setLoading(false);
            return;
        }
        if (!EndDate) {
            toast.warning("Please select End Date");
            setLoading(false);
            return;
        }

        const statusIds = selectedOptions.map(option => option.value).join(',') || null;
        const statusCategory = selectedCategories.map(option => option.value).join(',') || null;
        const statusStaff = selectedStaff.map(option => option.value).join(',') || null;
        const JSONRequest = {
            "flatId": SelectedFlat ? SelectedFlat : null,
            "towerId": SelectedTower ? SelectedTower : null,
            "categoryId": statusCategory || null,
            "statusId": statusIds || null,
            "assignedTo": statusStaff || null,
            "isUrgent": UrgentStatus ? UrgentStatus == "true" ? true : false : null,
            "startDate": StartDate ? StartDate + "T00:00" : null,
            "endDate": EndDate ? EndDate + "T23:59" : null,
            "applicableLevel": null
        }
        console.log("JSON REQ", JSONRequest);
        try {
            setLoading(true);
            const response = await commonAPI("GetComplaintPOST", JSONRequest, endPointVariableKey);
            console.log("response GetComplaintPOST", response);
            if (response?.success && !response.message.length) {
                setComplainList(response.data);
                setOldComplainList(response.data)
            } else if (!response?.success && response.message.length) {
                toast.error(response.message[0]);
                setComplainList([])
                setOldComplainList([])
            }
        } catch (error) {

            toast.error("Something went wrong, Please try again after some time");
        } finally {
            setLoading(false);
        }
    }

    function filterHelpdeskData(text) {
        setSearchData(text);

        const newData = OldComplainList?.filter(item => {
            return (
                item?.complaintTitle?.toLowerCase().includes(text?.toLowerCase())
            );
        });

        setComplainList(newData);
    }



    useEffect(() => {
        GetGateList();
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        setUserData(myUserData)
    }, []);

    const GetResidentReport = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "startDate": StartTime ? StartDate + "T" + StartTime : StartDate + "T00:00",
            "endDate": EndTime ? EndDate + "T" + EndTime : EndDate + "T23:59",
            "entryGateId": Array.isArray(EntryGate) && EntryGate.length > 0 ? EntryGate.sort((a, b) => a - b).join(",") : null,
            "exitGateId": Array.isArray(ExitGate) && ExitGate.length > 0 ? ExitGate.sort((a, b) => a - b).join(",") : null,
            // "entryGateId": 0,
            // "exitGateId": 0,
            "vehicleType": WheeleType
        };
        try {

            setLoading(true);
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData.buildingId

            }
            if (!StartDate) {
                toast.warning("Please select Start Date");
                setLoading(false);
            } else if (!EndDate) {
                toast.warning("Please select End Date");
                setLoading(false);
                //   }else if(!EntryGate){
                //     toast.warning("Please select Entry Gate");
                //     setLoading(false);
                //   }else if(!ExitGate){
                //     toast.warning("Please select Exit Gate");
                //     setLoading(false);
                //   }else if(!WheeleType){
                //     toast.warning("Please select Vehicle Type");
                //     setLoading(false);
            } else {
                let response = await commonAPI("ResidentInOutReport", bodyData, endPointVariableKey)
                console.log("Table", response?.data, bodyData)
                if (response?.success === true) {
                    if (response?.success === true && response?.data?.length == 0) {
                        setResidentData("");
                        setOldResidentData("");
                        toast.warning("No data found");
                        setLoading(false);
                    } else {
                        setResidentData(response?.data);
                        setOldResidentData(response?.data)
                        setLoading(false);
                    }
                    console.table("setResidentData", response?.data);

                } else {
                    toast.warning(response?.message[0]);
                    setResidentData("");
                    setOldResidentData("");
                    setLoading(false);
                }
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Report/ResidentInOutReport",
                "errorNumber": "RR01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Report.js",
                "functionName": "GetGateList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };


    function filterResidentData(text) {
        setSearchData(text)
        //console.log(filterImg)
        const oldData = ResidentData
        // console.log(oldLogo,"LOGO")
        console.log(text.toLowerCase())
        let newData = OldResidentData?.filter(item => {

            // Check if the search text exists in any property of the object
            return Object?.values(item).some(value =>
                value?.toString()?.toLowerCase()?.includes(text?.toLowerCase())
            );
        });
        setResidentData(newData)
        // console.log(logo)
    }

    const GetVisitorReport = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "startDate": StartTime ? StartDate + "T" + StartTime : StartDate + "T00:00",
            "endDate": EndTime ? EndDate + "T" + EndTime : EndDate + "T23:59",
            "entryGateId": Array.isArray(EntryGate) && EntryGate.length > 0 ? EntryGate.sort((a, b) => a - b).join(",") : null,
            "exitGateId": Array.isArray(ExitGate) && ExitGate.length > 0 ? ExitGate.sort((a, b) => a - b).join(",") : null,
            // "entryGateId": 0,
            // "exitGateId": 0,
            "vehicleType": WheeleType ? WheeleType : null
        };
        try {

            setLoading(true);
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData.buildingId

            }
            console.log("setVisitorData", bodyData);
            if (!StartDate) {
                toast.warning("Please select Start Date");
                setLoading(false);
            } else if (!EndDate) {
                toast.warning("Please select End Date");
                setLoading(false);
                //   }else if(!EntryGate){
                //     toast.warning("Please select Entry Gate");
                //     setLoading(false);
                //   }else if(!ExitGate){
                //     toast.warning("Please select Exit Gate");
                //     setLoading(false);

            } else {

                let response = await commonAPI("VisitorInOutReport", bodyData, endPointVariableKey)
                if (response?.success === true) {
                    console.log("setVisitorData", response, bodyData);
                    if (response?.success === true && response?.data?.length == 0) {
                        setVisitorData("");
                        setOldVisitorData("");
                        toast.warning("No data found");
                        setLoading(false);
                    } else {
                        setVisitorData(response?.data);
                        setOldVisitorData(response?.data);
                        setLoading(false);
                    }
                } else {
                    toast.warning(response?.message[0]);
                    setVisitorData("");
                    setOldVisitorData("");
                    setLoading(false);
                }
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Report/VisitorInOutReport",
                "errorNumber": "VR01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Report.js",
                "functionName": "GetGateList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };

    function filterVisitorData(text) {
        setSearchData(text)
        //console.log(filterImg)
        const oldData = VisitorData
        // console.log(oldLogo,"LOGO")
        console.log(text.toLowerCase())
        let newData = OldVisitorData?.filter(item => {

            // Check if the search text exists in any property of the object
            return Object.values(item).some(value =>
                value?.toString()?.toLowerCase()?.includes(text?.toLowerCase())
            );
        });
        // console.log(newLogo)
        setVisitorData(newData)
        // console.log(logo)
    }

    const GetWalkInReport = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "startDate": StartTime ? StartDate + "T" + StartTime : StartDate + "T00:00",
            "endDate": EndTime ? EndDate + "T" + EndTime : EndDate + "T23:59",
            "entryGateId": Array.isArray(EntryGate) && EntryGate.length > 0 ? EntryGate.sort((a, b) => a - b).join(",") : null,
            "exitGateId": Array.isArray(ExitGate) && ExitGate.length > 0 ? ExitGate.sort((a, b) => a - b).join(",") : null,
            // "entryGateId": 0,
            // "exitGateId": 0,
        };
        try {

            setLoading(true);
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId

            }
            if (!StartDate) {
                toast.warning("Please select Start Date");
                setLoading(false);
            } else if (!EndDate) {
                toast.warning("Please select End Date");
                setLoading(false);
            } else {
                console.log("BodyData", bodyData);
                let response = await commonAPI("WalkinVisitorInOutReport", bodyData, endPointVariableKey)
                console.log("setWalkInData", response, bodyData);
                if (response?.success === true) {

                    if (response?.success === true && response?.data?.length == 0) {
                        setWalkInData("");
                        setOldWalkInData("");
                        toast.warning("No data found");
                        setLoading(false);
                    } else {
                        setWalkInData(response?.data);
                        setOldWalkInData(response?.data);
                        setLoading(false);
                    }
                    setLoading(false);
                } else {
                    toast.warning(response?.message[0]);
                    setLoading(false);
                    setVisitorData("");
                    setOldVisitorData("");
                }
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Report/WalkinVisitorInOutReport",
                "errorNumber": "WR01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Report.js",
                "functionName": "GetGateList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };

    function filterWalkinData(text) {
        setSearchData(text)
        //console.log(filterImg)
        const oldData = WalkInData
        // console.log(oldLogo,"LOGO")
        console.log(text.toLowerCase())
        let newData = OldWalkInData?.filter(item => {

            // Check if the search text exists in any property of the object
            return Object.values(item).some(value =>
                value?.toString()?.toLowerCase()?.includes(text?.toLowerCase())
            );
        });
        // console.log(newLogo)
        setWalkInData(newData)
        // console.log(logo)
    }


    const GetResidingResident = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "buildingId": myUserData?.buildingId,
            "towerId": SelectedTower ? SelectedTower : null,
            "flatId": SelectedFlat ? SelectedFlat : null,
            "isParent": FamilyMember ? null : true,
            "isResiding": true,
            "maskedData": true,
        }
        try {

            setLoading(true);

            //   if(!SelectedTower){
            //     toast.warning("Please select Tower");
            //     setLoading(false);
            //   }else{
            console.log("BodyData", bodyData);
            let response = await commonAPI("GetCuroNextUserMapping", bodyData)
            console.log("GetCuroNextUserMapping", response, bodyData);
            if (response?.success === true) {

                if (response?.success === true && response?.data?.length == 0) {
                    toast.warning("No data found");
                    setResidentResidingData("")
                    setOldResidingData("")
                    setLoading(false);
                } else {

                    setResidentResidingData(sortData(response?.data, 'towerName'));
                    setOldResidingData(sortData(response?.data, 'towerName'))
                    console.log("Resident Data", response?.data)
                    setLoading(false);
                }
                setLoading(false);
            } else {
                toast.warning(response?.message[0]);
                setResidentResidingData("")
                setOldResidingData("")
                setLoading(false);
            }
            //   }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Report/WalkinVisitorInOutReport",
                "errorNumber": "WR01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Report.js",
                "functionName": "GetGateList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };

    const GetOwnerReport = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "buildingId": myUserData?.buildingId,
            "towerId": SelectedTower ? SelectedTower : null,
            "flatId": SelectedFlat ? SelectedFlat : null,
            "roleName": "Owner",
            "isResiding": null,
            "maskedData": true,
        }
        try {

            setLoading(true);
            //   if(!SelectedTower){
            //     toast.warning("Please select Tower");
            //     setLoading(false);
            //   }else{
            console.log("BodyData", bodyData);
            let response = await commonAPI("GetCuroNextUserMapping", bodyData)
            console.log("GetCuroNextUserMapping", response, bodyData);
            if (response?.success === true) {

                if (response?.success === true && response?.data?.length == 0) {
                    toast.warning("No data found");
                    setResidentResidingData("")
                    setOldResidingData("")
                    setLoading(false);
                } else {
                    setResidentResidingData(response?.data, 'towerName');
                    setOldResidingData(response?.data, 'towerName')
                    setLoading(false);
                }
                setLoading(false);
            } else {
                toast.warning(response?.message[0]);
                setResidentResidingData("")
                setLoading(false);
            }
            //   }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Report/WalkinVisitorInOutReport",
                "errorNumber": "WR01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Report.js",
                "functionName": "GetGateList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };

    const GetTenantReport = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "buildingId": myUserData?.buildingId,
            "towerId": SelectedTower ? SelectedTower : null,
            "flatId": SelectedFlat ? SelectedFlat : null,
            "roleName": "Tenant",
            "isParent": null,
            "isResiding": true,
            "maskedData": true,
        }
        try {

            setLoading(true);
            //   if(!SelectedTower){
            //     toast.warning("Please select Tower");
            //     setLoading(false);
            //   }else{
            console.log("BodyData", bodyData);
            let response = await commonAPI("GetCuroNextUserMapping", bodyData)
            if (response?.success === true) {

                if (response?.success === true && response?.data?.length == 0) {
                    toast.warning("No data found");
                    setResidentResidingData("")
                    setOldResidingData("")
                    setLoading(false);
                } else {
                    setResidentResidingData(response?.data, 'towerName');
                    setOldResidingData(response?.data, 'towerName')
                    setLoading(false);
                }
                setLoading(false);
            } else {
                toast.warning(response?.message[0]);
                setResidentResidingData("")
                setLoading(false);
            }
            //   }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Report/WalkinVisitorInOutReport",
                "errorNumber": "WR01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Report.js",
                "functionName": "GetGateList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };

    function filterReportData(text) {
        setSearchData(text)
        //console.log(filterImg)
        const oldData = WalkInData
        // console.log(oldLogo,"LOGO")
        console.log(text.toLowerCase())
        let newData = OldResidingData?.filter(item => {

            // Check if the search text exists in any property of the object
            return Object.values(item).some(value =>
                value?.toString()?.toLowerCase()?.includes(text?.toLowerCase())
            );
        });
        // console.log(newLogo)
        setResidentResidingData(newData)
        // console.log(logo)
    }

    const GetVehicleReport = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "towerId": SelectedTower ? SelectedTower : null,
            "flatId": SelectedFlat ? SelectedFlat : null,
            "securityLock": SecurityLockSelect ? SecurityLockSelect == "YES" ? true : false : null,
            "vehicleType": VehicleTypeSelect ? VehicleTypeSelect : null,
            "currentStatus": "APPROVED"
        }
        try {

            setLoading(true);
            const endPointVariableKey = {
                // urlVariable:null,
                buildingId: myUserData?.buildingId

            }
            //   if(!SelectedTower){
            //     toast.warning("Please select Tower");
            //     setLoading(false);
            //   }else{
            console.log("BodyData", bodyData);
            let response = await commonAPI("GetResidentVehicle", bodyData, endPointVariableKey)
            // console.log("GetCuroNextUserMapping", response, bodyData);
            if (response?.success === true) {

                if (response?.success === true && response?.data?.length == 0) {
                    toast.warning("No data found");
                    setVehicleData("")
                    setOldVehicleData("")
                    setLoading(false);
                } else {
                    setVehicleData(response?.data, 'towerName');
                    setOldVehicleData(response?.data, 'towerName')
                    console.log("Vehicle Data", response?.data)
                    setLoading(false);
                }
                setLoading(false);
            } else {
                toast.warning(response?.message[0]);
                setVehicleData("")
                setOldVehicleData("")
                setLoading(false);
            }
            //   }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Report/WalkinVisitorInOutReport",
                "errorNumber": "WR01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Report.js",
                "functionName": "GetGateList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };

    function filterVehicleReportData(text) {
        setSearchData(text)
        //console.log(filterImg)
        // const oldData = WalkInData
        // console.log(oldLogo,"LOGO")
        console.log(text.toLowerCase())
        let newData = OldVehicleData?.filter(item => {

            // Check if the search text exists in any property of the object
            return Object.values(item).some(value =>
                value?.toString()?.toLowerCase()?.includes(text?.toLowerCase())
            );
        });
        // console.log(newLogo)
        setVehicleData(newData)
        // console.log(logo)
    }

    function filterServiceStaffData(text) {
        setSearchData(text);

        const newData = Oldlogo?.filter(item => {
            return (
                item?.userName?.toLowerCase().includes(text?.toLowerCase())
            );
        });

        setImageLogo(newData);
    }


    const getActiveNextAppUser = async () => {
        // Only check for BuildingId if user is Super Admin
        if (UserData?.roleName === "Super Admin" && !BuildingId) {
            toast.warning("Please select Building");
            return [];
        }
        try {
            const response = await commonAPI("ActiveNextAppUser", undefined, { urlVariable: UserData?.roleName === "Super Admin" ? BuildingId : UserData?.buildingId });
            console.log("ActiveNextAppUser", response)
            if (response?.success) {
                const users = response.data;

                // Validate users is an array and not empty
                if (!Array.isArray(users) || users.length === 0) {
                    setGetActiveUser([]);
                    toast.warning("No data found");
                    return [];
                }

                // Apply filters based on provided criteria
                let filteredUsers = users;

                // Filter by tower if SelectedTower is provided
                if (SelectedTower) {
                    filteredUsers = filteredUsers.filter(user => user.towerId === parseInt(SelectedTower));
                }

                // Filter by flat if SelectedFlat is provided
                if (SelectedFlat) {
                    filteredUsers = filteredUsers.filter(user => user.flatId === parseInt(SelectedFlat));
                }

                // Filter by isResiding if provided (assuming boolean)
                if (IsResiding !== undefined) {
                    filteredUsers = filteredUsers.filter(user => user.isResiding === IsResiding);
                }

                // Log and set the filtered users
                console.log("ActiveNextAppUserfiltered", filteredUsers);
                if (filteredUsers.length === 0) {
                    toast.warning("No data found");
                    setGetActiveUser([]);
                    return [];
                }
                setGetActiveUser(filteredUsers);
                return filteredUsers;
            } else {
                toast.error("Failed to fetch active users");
                return [];
            }
        } catch (error) {
            // Log error to backend
            const bodyError = {
                userId: "",
                mobileNumber: "",
                requestJSON: null,
                uri: "ActiveNextAppUser",
                errorNumber: "ANU01",
                errorSource: ErrorSource,
                errorSummary: error?.message,
                errorDescription: error?.message,
                fileClassName: "Report.js",
                functionName: "getActiveNextAppUser",
            };
            await commonAPI("ErrorLogMaster", bodyError);
            toast.error("Error fetching active users");
            return [];
        }
    };

    function filterActiveUserData(text) {
        setSearchData(text);
        if (!OldResidingData || !Array.isArray(OldResidingData)) {
            setGetActiveUser([]);
            return;
        }
        const newData = OldResidingData.filter(item =>
            Object.values(item).some(value =>
                value?.toString()?.toLowerCase().includes(text?.toLowerCase())
            )
        );
        setGetActiveUser(newData);
    }


    const convertISTTime = (date) => {
        if (date != null || date != "" || date != undefined) {
            const [datePart, TimePart] = date.split("T");
            const [yyyy, mm, dd] = datePart.split("-");
            // const [hh, mn, ss] = TimePart.split(':')
            const formatedTime = `${dd}-${mm}-${yyyy}`;
            return formatedTime;
        } else {
            console.warn("input date string may be null, empty string or undefined");
        }
    };

    const convertISTDateTime = (date) => {

        if (date && date !== "") { // Better check for null, undefined, and empty string
            const [datePart, timePart] = date.split("T"); // Correct casing for 'timePart'
            const [yyyy, mm, dd] = datePart.split("-");
            const [hh, mn] = timePart.split(":"); // No need for 'ss' if you are not using seconds
            const formattedTime = `${dd}-${mm}-${yyyy} ${hh}:${mn}`;
            return formattedTime;
        } else {
            console.warn("Input date string may be null, empty string or undefined");
            return null; // It's better to return a value or handle the case
        }
    };

    function calculateDuration(entryDt, exitDt) {
        const entryDate = new Date(entryDt);
        const exitDate = new Date(exitDt);

        const duration = exitDate - entryDate; // in milliseconds

        const hours = Math.floor(duration / 3600000);
        const minutes = Math.floor((duration % 3600000) / 60000);
        const seconds = Math.floor((duration % 60000) / 1000);

        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = seconds.toString().padStart(2, '0');

        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }

    const handleExport = () => {
        // if (data != null || data != "" || data != undefined) {
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.table_to_sheet(targetPDFRef.current);
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'Report.xlsx');
        // }  
    };
    const targetRef = useRef(null);
    const targetPDFRef = useRef();


    // PDF Download Function
    const ResidentPdfFunction = () => {
        setLoading(true);
        setHeaderShow(false);

        const doc = new jsPDF('p', 'mm', 'a4');  // 'p' for portrait mode, 'a4' paper size
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        doc.addFileToVFS("SourceSans3.ttf", myFont);
        doc.addFont("SourceSans3.ttf", "SourceSans3", "normal");
        doc.setFont("SourceSans3");  // Set the custom font

        // Get the current date and format it as DD-MM-YYYY
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? '0' + currentDate.getMinutes() : currentDate.getMinutes()}`;

        // Add logos
        const leftLogoWidth = 30;  // Adjust size based on your need
        const leftLogoHeight = 10;
        const rightLogoWidth = 20;
        const rightLogoHeight = 10;

        // Add the right logo (which was previously on the left)
        if (UserData?.logo) {
            doc.addImage('data:image/jpeg;base64,' + UserData?.logo, 'JPEG', 5, 10, rightLogoWidth, rightLogoHeight);
        }

        // Add the left logo (which was previously on the right)
        doc.addImage(curonext, 'PNG', pageWidth - leftLogoWidth - 5, 10, leftLogoWidth, leftLogoHeight);

        // Building Name and Address
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(8);
        doc.text(`${UserData?.buildingName}`, 40, 10);  // Adjust Y positioning for spacing
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(`${UserData?.addressLine1} ${UserData?.addressLine2}`, 40, 15);
        doc.text(`${UserData?.city}, ${UserData?.state}`, 40, 20);

        // Center the report title
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(10);
        doc.text('Resident Report', pageWidth / 2, 30, { align: 'center' });

        // Add Criteria Info below the title
        doc.setFont("SourceSans3", 'normal');
        doc.setFontSize(8);
        const criteriaText = `Start Date: ${convertISTTime(StartDate)} | End Date: ${convertISTTime(EndDate)} | Vehicle Type: ${WheeleType ? WheeleType : 'All'} | Entry Gate: ${EntryGate[1] ? EntryGate[1] : 'All'} | Exit Gate: ${ExitGate[1] ? ExitGate[1] : 'All'}`;
        doc.text(criteriaText, pageWidth / 2, 36, { align: 'center' });

        // Table headers and rows
        const tableHeaders = [
            ['S.No', 'Resident Name', 'Flat #', 'Vehicle #', 'Entry', 'Gate', 'Exit', 'Gate', 'Transit Remark'],
        ];

        const tableRows = ResidentData?.map((item, index) => [
            index + 1,  // This adds the serial number (S.No)
            item?.personName,
            `${item?.towerName} - ${item?.flatName}`,
            item?.lpNumber,
            convertISTDateTime(item?.entryDt),
            item?.entryGateName,
            item?.exitGateName ? convertISTDateTime(item?.exitDt) : "",
            item?.exitGateName ? item?.exitGateName : "",
            item?.transitRemark,
        ]);

        // Render the table starting below the header
        doc.autoTable({
            startY: 45,  // Adjust startY to fit below the criteria text
            head: tableHeaders,
            body: tableRows,
            headStyles: {
                fillColor: [245, 245, 245],  // Set header background color (RGB values for a blue shade)
                textColor: [0, 0, 0],  // Set text color to white
                fontSize: 6,  // Adjust font size of header
                fontStyle: 'bold',  // Make the header text bold
            },
            bodyStyles: {
                fillColor: [255, 255, 255],  // Default background color for all rows (white)
                textColor: [0, 0, 0],        // Text color (black)
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255],  // Color for alternate rows (light gray)
                textColor: [0, 0, 0],        // Text color for alternate rows
            },
            styles: { fontSize: 6, cellPadding: 1 },  // Adjust font size and padding
            theme: 'striped',
            margin: { top: 10, left: 10, right: 10 },
            didDrawPage: function (data) {
                // Page Number Logic
                const pageCount = doc.internal.getNumberOfPages();  // Total page count
                const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;  // Current page number

                // Add the generated date at the footer
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Generated on: ${formattedDate} ${formattedTime}`, 10, pageHeight - 5);  // Add date to the left

                // Add the page number at the bottom of each page (centered)
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Page ${pageCurrent}`, pageWidth - 20, pageHeight - 5, { align: 'right', textColor: "#000" });
            },
            // margin: { top: 20 },
        });

        // Save the PDF
        doc.save('Resident-InOut-Report.pdf');

        // Stop loading and hide the header
        setLoading(false);
        setHeaderShow(false);
    };

    // PDF Download Function
    const VisitiorPdfFunction = () => {
        setLoading(true);
        setHeaderShow(false);

        const doc = new jsPDF('p', 'mm', 'a4');  // 'p' for portrait mode, 'a4' paper size
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Load custom font if needed
        doc.addFileToVFS("SourceSans3.ttf", myFont);
        doc.addFont("SourceSans3.ttf", "SourceSans3", "normal");
        doc.setFont("SourceSans3");  // Set the custom font

        // Get the current date and format it as DD-MM-YYYY
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? '0' + currentDate.getMinutes() : currentDate.getMinutes()}`;

        // Add logos
        const leftLogoWidth = 30;  // Adjust size based on your need
        const leftLogoHeight = 10;
        const rightLogoWidth = 20;
        const rightLogoHeight = 10;

        // Add the right logo (which was previously on the left)
        if (UserData?.logo) {
            doc.addImage('data:image/jpeg;base64,' + UserData?.logo, 'JPEG', 5, 10, rightLogoWidth, rightLogoHeight);
        }

        // Add the left logo (which was previously on the right)
        doc.addImage(curonext, 'PNG', pageWidth - leftLogoWidth - 5, 10, leftLogoWidth, leftLogoHeight);

        // Building Name and Address
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'bold');
        doc.text(`${UserData?.buildingName}`, 40, 10);  // Adjust Y positioning for spacing
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(`${UserData?.addressLine1} ${UserData?.addressLine2}`, 40, 15);
        doc.text(`${UserData?.city}, ${UserData?.state}`, 40, 20);

        // Center the report title
        doc.setFontSize(10);
        doc.setFont("SourceSans3", 'bold');
        doc.text('Visitor Report', pageWidth / 2, 30, { align: 'center' });

        // Add Criteria Info below the title
        doc.setFont("SourceSans3", 'normal');
        const criteriaText = `Start Date: ${convertISTTime(StartDate)} | End Date: ${convertISTTime(EndDate)} | Vehicle Type: ${WheeleType ? WheeleType : 'All'} | Entry Gate: ${EntryGate[1] ? EntryGate[1] : 'All'} | Exit Gate: ${ExitGate[1] ? ExitGate[1] : 'All'}`;
        doc.setFontSize(8);
        doc.text(criteriaText, pageWidth / 2, 36, { align: 'center' });

        // Define Table headers (from your HTML table)
        const tableHeaders = [
            ['S.No', 'Visitor Name', 'Visitor Type', 'Flat #', 'Vehicle #', 'Entry', 'Gate', 'Exit', 'Gate', 'Duration', 'Transit Remark'],
        ];

        // Map table rows from your VisitorData (same data used in your HTML table)
        const tableRows = VisitorData.map((item, index) => [
            index + 1,  // This adds the serial number (S.No)
            item?.personName,
            item?.visitorType,
            `${item?.towerName} - ${item?.flatName}`,
            item?.lpNumber,
            convertISTDateTime(item?.entryDt),
            item?.entryGateName,
            item?.exitGateName ? convertISTDateTime(item?.exitDt) : "",
            item?.exitGateName ? item?.exitGateName : "",
            item?.entryDt && item?.exitDt ? calculateDuration(item?.entryDt, item?.exitDt) : "",
            item?.transitRemark,
        ]);

        // Generate the PDF table
        doc.autoTable({
            startY: 45,  // Adjust startY to fit below the criteria text
            head: tableHeaders,
            body: tableRows,
            headStyles: {
                fillColor: [245, 245, 245],  // Set header background color
                textColor: [0, 0, 0],        // Set text color for header
                fontSize: 6,                 // Adjust font size of header
                fontStyle: 'bold',           // Make the header text bold
            },
            bodyStyles: {
                fillColor: [255, 255, 255],  // Default background color for rows
                textColor: [0, 0, 0],        // Text color for rows
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255],  // Light gray color for alternate rows
                textColor: [0, 0, 0],        // Text color for alternate rows
            },
            styles: {
                fontSize: 6,                 // Font size for the table
                cellPadding: 1,              // Padding inside cells
            },
            theme: 'striped',
            margin: { top: 10, left: 10, right: 10 },
            didDrawPage: function (data) {
                // Page Number Logic
                const pageCount = doc.internal.getNumberOfPages();  // Total page count
                const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;  // Current page number

                // Add the generated date at the footer
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Generated on: ${formattedDate} ${formattedTime}`, 10, pageHeight - 5);  // Add date to the left

                // Add the page number at the bottom of each page (centered)
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Page ${pageCurrent}`, pageWidth - 20, pageHeight - 5, { align: 'right', textColor: "#000" });
            },
        });

        // Save the PDF
        doc.save('Visitor-InOut-Report.pdf');

        // Stop loading and hide the header
        setLoading(false);
        setHeaderShow(false);
    };

    // PDF Download Function
    const WalkinReportPdfFunction = () => {
        setLoading(true);
        setHeaderShow(false);

        const doc = new jsPDF('p', 'mm', 'a4');  // 'p' for portrait mode, 'a4' paper size
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Load custom font if needed
        doc.addFileToVFS("SourceSans3.ttf", myFont);
        doc.addFont("SourceSans3.ttf", "SourceSans3", "normal");
        doc.setFont("SourceSans3");  // Set the custom font

        // Get the current date and format it as DD-MM-YYYY
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? '0' + currentDate.getMinutes() : currentDate.getMinutes()}`;

        // Add logos
        const leftLogoWidth = 30;
        const leftLogoHeight = 10;
        const rightLogoWidth = 20;
        const rightLogoHeight = 10;

        // Add the right logo (which was previously on the left)
        if (UserData?.logo) {
            doc.addImage('data:image/jpeg;base64,' + UserData?.logo, 'JPEG', 5, 10, rightLogoWidth, rightLogoHeight);
        }

        // Add the left logo (which was previously on the right)
        doc.addImage(curonext, 'PNG', pageWidth - leftLogoWidth - 5, 10, leftLogoWidth, leftLogoHeight);

        // Building Name and Address
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(8);
        doc.text(`${UserData?.buildingName}`, 40, 10);  // Adjust Y positioning for spacing
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(`${UserData?.addressLine1} ${UserData?.addressLine2}`, 40, 15);
        doc.text(`${UserData?.city}, ${UserData?.state}`, 40, 20);

        // Center the report title
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(10);
        doc.text('Walkin Report', pageWidth / 2, 30, { align: 'center' });

        // Add Criteria Info below the title
        const criteriaText = `Start Date: ${convertISTTime(StartDate)} | End Date: ${convertISTTime(EndDate)}  | Entry Gate: ${EntryGate[1] ? EntryGate[1] : 'All'} | Exit Gate: ${ExitGate[1] ? ExitGate[1] : 'All'}`;
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(criteriaText, pageWidth / 2, 36, { align: 'center' });

        // Define Table headers for Walkin Report
        const tableHeaders = [
            ['S.No', 'Walk-in Visitor Name', 'Visitor Type', 'Flat #', 'Entry', 'Gate', 'Exit', 'Gate', 'Transit Remark'],
        ];

        // Map table rows from WalkInData
        const tableRows = WalkInData.map((item, index) => [
            index + 1,  // This adds the serial number (S.No)
            item?.personName,
            item?.visitorType,
            `${item?.towerName} - ${item?.flatName}`,
            convertISTDateTime(item?.entryDt),
            item?.entryGateName,
            item?.exitDt ? convertISTDateTime(item?.exitDt) : "",
            item?.exitGateName ? item?.exitGateName : "",
            item?.transitRemark,
        ]);

        // Generate the PDF table
        doc.autoTable({
            startY: 45,  // Adjust startY to fit below the criteria text
            head: tableHeaders,
            body: tableRows,
            headStyles: {
                fillColor: [245, 245, 245],  // Set header background color
                textColor: [0, 0, 0],        // Set text color for header
                fontSize: 6,                 // Adjust font size of header
                fontStyle: 'bold',           // Make the header text bold
            },
            bodyStyles: {
                fillColor: [255, 255, 255],  // Default background color for rows
                textColor: [0, 0, 0],        // Text color for rows
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255],  // Light gray color for alternate rows
                textColor: [0, 0, 0],        // Text color for alternate rows
            },
            styles: {
                fontSize: 6,                 // Font size for the table
                cellPadding: 1,              // Padding inside cells
            },
            theme: 'striped',
            margin: { top: 10, left: 10, right: 10 },
            didDrawPage: function (data) {
                // Page Number Logic
                const pageCount = doc.internal.getNumberOfPages();  // Total page count
                const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;  // Current page number

                // Add the generated date at the footer
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Generated on: ${formattedDate} ${formattedTime}`, 10, pageHeight - 5);  // Add date to the left

                // Add the page number at the bottom of each page (centered)
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Page ${pageCurrent}`, pageWidth - 20, pageHeight - 5, { align: 'right', textColor: "#000" });
            },
        });

        // Save the PDF
        doc.save('Walkin-Report.pdf');

        // Stop loading and hide the header
        setLoading(false);
        setHeaderShow(false);
    };

    // PDF Download Function
    const ResidingResidentPdf = () => {
        setLoading(true);
        setHeaderShow(false);

        const doc = new jsPDF('p', 'mm', 'a4');  // 'p' for portrait mode, 'a4' paper size
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Load custom font if needed
        doc.addFileToVFS("SourceSans3.ttf", myFont);
        doc.addFont("SourceSans3.ttf", "SourceSans3", "normal");
        doc.setFont("SourceSans3");  // Set the custom font

        // Get the current date and format it as DD-MM-YYYY
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? '0' + currentDate.getMinutes() : currentDate.getMinutes()}`;

        // Add logos
        const leftLogoWidth = 30;
        const leftLogoHeight = 10;
        const rightLogoWidth = 20;
        const rightLogoHeight = 10;

        // Add the right logo (which was previously on the left)
        if (UserData?.logo) {
            doc.addImage('data:image/jpeg;base64,' + UserData?.logo, 'JPEG', 5, 10, rightLogoWidth, rightLogoHeight);
        }

        // Add the left logo (which was previously on the right)
        doc.addImage(curonext, 'PNG', pageWidth - leftLogoWidth - 5, 10, leftLogoWidth, leftLogoHeight);

        // Building Name and Address
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(8);
        doc.text(`${UserData?.buildingName}`, 40, 10);  // Adjust Y positioning for spacing
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(`${UserData?.addressLine1} ${UserData?.addressLine2}`, 40, 15);
        doc.text(`${UserData?.city}, ${UserData?.state}`, 40, 20);

        // Center the report title
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(10);
        doc.text('Residing Resident Report', pageWidth / 2, 30, { align: 'center' });

        // Add Criteria Info below the title
        const criteriaText = `Tower: ${SelectedTowerName ? SelectedTowerName : "All"} | Flat: ${SelectedFlatName ? SelectedFlatName : "All"} | Include Family Member: ${FamilyMember ? "Yes" : 'No'} `;
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(criteriaText, pageWidth / 2, 36, { align: 'center' });

        // Define Table headers for Walkin Report
        const tableHeaders = [
            ['S.No', 'Flat Owner', 'Flat #', 'Primary User', 'Mobile #', 'Email Id', 'Resident Type'],
        ];

        // Map table rows from WalkInData
        const tableRows = ResidentResidingData.map((item, index) => [
            index + 1,  // This adds the serial number (S.No)
            item?.userName,
            `${item?.towerName} - ${item?.flatName}`,
            item?.isParent ? "Yes" : "No",
            item?.mobileNumber,
            item?.emailId,
            item?.roleName,
        ]);

        // Generate the PDF table
        doc.autoTable({
            startY: 45,  // Adjust startY to fit below the criteria text
            head: tableHeaders,
            body: tableRows,
            headStyles: {
                fillColor: [245, 245, 245],  // Set header background color
                textColor: [0, 0, 0],        // Set text color for header
                fontSize: 6,                 // Adjust font size of header
                fontStyle: 'bold',           // Make the header text bold
            },
            bodyStyles: {
                fillColor: [255, 255, 255],  // Default background color for rows
                textColor: [0, 0, 0],        // Text color for rows
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255],  // Light gray color for alternate rows
                textColor: [0, 0, 0],        // Text color for alternate rows
            },
            styles: {
                fontSize: 6,                 // Font size for the table
                cellPadding: 1,              // Padding inside cells
            },
            theme: 'striped',
            margin: { top: 10, left: 10, right: 10 },
            didDrawPage: function (data) {
                // Page Number Logic
                const pageCount = doc.internal.getNumberOfPages();  // Total page count
                const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;  // Current page number

                // Add the generated date at the footer
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Generated on: ${formattedDate} ${formattedTime}`, 10, pageHeight - 5);  // Add date to the left

                // Add the page number at the bottom of each page (centered)
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Page ${pageCurrent}`, pageWidth - 20, pageHeight - 5, { align: 'right', textColor: "#000" });
            },
        });

        // Save the PDF
        doc.save('Residing-Resident-Report.pdf');

        // Stop loading and hide the header
        setLoading(false);
        setHeaderShow(false);
    };

    // PDF Download Function
    const OwnerResidentPdf = () => {
        setLoading(true);
        setHeaderShow(false);

        const doc = new jsPDF('p', 'mm', 'a4');  // 'p' for portrait mode, 'a4' paper size
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Load custom font if needed
        doc.addFileToVFS("SourceSans3.ttf", myFont);
        doc.addFont("SourceSans3.ttf", "SourceSans3", "normal");
        doc.setFont("SourceSans3");  // Set the custom font

        // Get the current date and format it as DD-MM-YYYY
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? '0' + currentDate.getMinutes() : currentDate.getMinutes()}`;

        // Add logos
        const leftLogoWidth = 30;
        const leftLogoHeight = 10;
        const rightLogoWidth = 20;
        const rightLogoHeight = 10;

        // Add the right logo (which was previously on the left)
        if (UserData?.logo) {
            doc.addImage('data:image/jpeg;base64,' + UserData?.logo, 'JPEG', 5, 10, rightLogoWidth, rightLogoHeight);
        }

        // Add the left logo (which was previously on the right)
        doc.addImage(curonext, 'PNG', pageWidth - leftLogoWidth - 5, 10, leftLogoWidth, leftLogoHeight);

        // Building Name and Address
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(8);
        doc.text(`${UserData?.buildingName}`, 40, 10);  // Adjust Y positioning for spacing
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(`${UserData?.addressLine1} ${UserData?.addressLine2}`, 40, 15);
        doc.text(`${UserData?.city}, ${UserData?.state}`, 40, 20);

        // Center the report title
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(10);
        doc.text('Owner Resident Report', pageWidth / 2, 30, { align: 'center' });

        // Add Criteria Info below the title
        const criteriaText = `Tower: ${SelectedTowerName ? SelectedTowerName : "All"}  | Flat: ${SelectedFlatName ? SelectedFlatName : "All"} `;
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(criteriaText, pageWidth / 2, 36, { align: 'center' });

        // Define Table headers for Walkin Report
        const tableHeaders = [
            ['S.No', 'Flat Owner', 'Flat #', 'Primary User', 'Mobile #', 'Email Id', 'Resident Type'],
        ];

        // Map table rows from WalkInData
        const tableRows = ResidentResidingData.map((item, index) => [
            index + 1,  // This adds the serial number (S.No)
            item?.userName,
            `${item?.towerName} - ${item?.flatName}`,
            item?.isParent ? "Yes" : "No",
            item?.mobileNumber,
            item?.emailId,
            item?.roleName,
        ]);

        // Generate the PDF table
        doc.autoTable({
            startY: 45,  // Adjust startY to fit below the criteria text
            head: tableHeaders,
            body: tableRows,
            headStyles: {
                fillColor: [245, 245, 245],  // Set header background color
                textColor: [0, 0, 0],        // Set text color for header
                fontSize: 6,                 // Adjust font size of header
                fontStyle: 'bold',           // Make the header text bold
            },
            bodyStyles: {
                fillColor: [255, 255, 255],  // Default background color for rows
                textColor: [0, 0, 0],        // Text color for rows
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255],  // Light gray color for alternate rows
                textColor: [0, 0, 0],        // Text color for alternate rows
            },
            styles: {
                fontSize: 6,                 // Font size for the table
                cellPadding: 1,              // Padding inside cells
            },
            theme: 'striped',
            margin: { top: 10, left: 10, right: 10 },
            didDrawPage: function (data) {
                // Page Number Logic
                const pageCount = doc.internal.getNumberOfPages();  // Total page count
                const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;  // Current page number

                // Add the generated date at the footer
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Generated on: ${formattedDate} ${formattedTime}`, 10, pageHeight - 5);  // Add date to the left

                // Add the page number at the bottom of each page (centered)
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Page ${pageCurrent}`, pageWidth - 20, pageHeight - 5, { align: 'right', textColor: "#000" });
            },
        });

        // Save the PDF
        doc.save('Flat-Owner-Report.pdf');

        // Stop loading and hide the header
        setLoading(false);
        setHeaderShow(false);
    };

    // PDF Download Function
    const TenantResidentPdf = () => {
        setLoading(true);
        setHeaderShow(false);

        const doc = new jsPDF('p', 'mm', 'a4');  // 'p' for portrait mode, 'a4' paper size
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Load custom font if needed
        doc.addFileToVFS("SourceSans3.ttf", myFont);
        doc.addFont("SourceSans3.ttf", "SourceSans3", "normal");
        doc.setFont("SourceSans3");  // Set the custom font

        // Get the current date and format it as DD-MM-YYYY
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? '0' + currentDate.getMinutes() : currentDate.getMinutes()}`;

        // Add logos
        const leftLogoWidth = 30;
        const leftLogoHeight = 10;
        const rightLogoWidth = 20;
        const rightLogoHeight = 10;

        // Add the right logo (which was previously on the left)
        if (UserData?.logo) {
            doc.addImage('data:image/jpeg;base64,' + UserData?.logo, 'JPEG', 5, 10, rightLogoWidth, rightLogoHeight);
        }

        // Add the left logo (which was previously on the right)
        doc.addImage(curonext, 'PNG', pageWidth - leftLogoWidth - 5, 10, leftLogoWidth, leftLogoHeight);

        // Building Name and Address
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(8);
        doc.text(`${UserData?.buildingName}`, 40, 10);  // Adjust Y positioning for spacing
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(`${UserData?.addressLine1} ${UserData?.addressLine2}`, 40, 15);
        doc.text(`${UserData?.city}, ${UserData?.state}`, 40, 20);

        // Center the report title
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(10);
        doc.text('Flat Tenant Report', pageWidth / 2, 30, { align: 'center' });

        // Add Criteria Info below the title
        const criteriaText = `Tower: ${SelectedTowerName ? SelectedTowerName : "All"}  | Flat: ${SelectedFlatName ? SelectedFlatName : "All"}  `;
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(criteriaText, pageWidth / 2, 36, { align: 'center' });

        // Define Table headers for Walkin Report
        const tableHeaders = [
            ['S.No', 'Flat Tenant', 'Flat #', 'Primary User', 'Mobile #', 'Email Id', 'Resident Type'],
        ];

        // Map table rows from WalkInData
        const tableRows = ResidentResidingData.map((item, index) => [
            index + 1,  // This adds the serial number (S.No)
            item?.userName,
            `${item?.towerName} - ${item?.flatName}`,
            item?.isParent ? "Yes" : "No",
            item?.mobileNumber,
            item?.emailId,
            item?.roleName,
        ]);

        // Generate the PDF table
        doc.autoTable({
            startY: 45,  // Adjust startY to fit below the criteria text
            head: tableHeaders,
            body: tableRows,
            headStyles: {
                fillColor: [245, 245, 245],  // Set header background color
                textColor: [0, 0, 0],        // Set text color for header
                fontSize: 6,                 // Adjust font size of header
                fontStyle: 'bold',           // Make the header text bold
            },
            bodyStyles: {
                fillColor: [255, 255, 255],  // Default background color for rows
                textColor: [0, 0, 0],        // Text color for rows
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255],  // Light gray color for alternate rows
                textColor: [0, 0, 0],        // Text color for alternate rows
            },
            styles: {
                fontSize: 6,                 // Font size for the table
                cellPadding: 1,              // Padding inside cells
            },
            theme: 'striped',
            margin: { top: 10, left: 10, right: 10 },
            didDrawPage: function (data) {
                // Page Number Logic
                const pageCount = doc.internal.getNumberOfPages();  // Total page count
                const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;  // Current page number

                // Add the generated date at the footer
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Generated on: ${formattedDate} ${formattedTime}`, 10, pageHeight - 5);  // Add date to the left

                // Add the page number at the bottom of each page (centered)
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Page ${pageCurrent}`, pageWidth - 20, pageHeight - 5, { align: 'right', textColor: "#000" });
            },
        });

        // Save the PDF
        doc.save('Flat-Tenant-Report.pdf');

        // Stop loading and hide the header
        setLoading(false);
        setHeaderShow(false);
    };

    // PDF Download Function
    const VehiclePdf = () => {
        setLoading(true);
        setHeaderShow(false);

        const doc = new jsPDF('p', 'mm', 'a4');  // 'p' for portrait mode, 'a4' paper size
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Load custom font if needed
        doc.addFileToVFS("SourceSans3.ttf", myFont);
        doc.addFont("SourceSans3.ttf", "SourceSans3", "normal");
        doc.setFont("SourceSans3");  // Set the custom font

        // Get the current date and format it as DD-MM-YYYY
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? '0' + currentDate.getMinutes() : currentDate.getMinutes()}`;

        // Add logos
        const leftLogoWidth = 30;
        const leftLogoHeight = 10;
        const rightLogoWidth = 20;
        const rightLogoHeight = 10;

        // Add the right logo (which was previously on the left)
        if (UserData?.logo) {
            doc.addImage('data:image/jpeg;base64,' + UserData?.logo, 'JPEG', 5, 10, rightLogoWidth, rightLogoHeight);
        }

        // Add the left logo (which was previously on the right)
        doc.addImage(curonext, 'PNG', pageWidth - leftLogoWidth - 5, 10, leftLogoWidth, leftLogoHeight);

        // Building Name and Address
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(8);
        doc.text(`${UserData?.buildingName}`, 40, 10);  // Adjust Y positioning for spacing
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(`${UserData?.addressLine1} ${UserData?.addressLine2}`, 40, 15);
        doc.text(`${UserData?.city}, ${UserData?.state}`, 40, 20);

        // Center the report title
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(10);
        doc.text('Vehicle Report', pageWidth / 2, 30, { align: 'center' });

        // Add Criteria Info below the title
        const criteriaText = `Tower: ${SelectedTowerName ? SelectedTowerName : "All"}  | Flat: ${SelectedFlatName ? SelectedFlatName : "All"} | Security Lock: ${SecurityLockSelect === "YES" ? "Yes" : (SecurityLockSelect === "NO" ? "No" : "None")} |  Vehicle Type: ${VehicleTypeSelect ? VehicleTypeSelect : "All"}  `;
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(criteriaText, pageWidth / 2, 36, { align: 'center' });

        // Define Table headers for Walkin Report
        const tableHeaders = [
            ['S.No', 'Resident Name', 'Flat #', 'Vehicle #', 'Vehicle Type', 'Tag Serial #', "Fuel Type", "Brand", "Security Lock"],
        ];

        // Map table rows from WalkInData
        const tableRows = VehicleData.map((item, index) => [
            index + 1,  // This adds the serial number (S.No)
            item?.ownerName,
            `${item?.towerName} - ${item?.flatName}`,
            item?.lpNumber,
            item?.vehicleType,
            item?.tagSerialNumber,
            item?.fuelType,
            item?.brand,
            item?.securityLock ? "Yes" : "No",
        ]);

        // Generate the PDF table
        doc.autoTable({
            startY: 45,  // Adjust startY to fit below the criteria text
            head: tableHeaders,
            body: tableRows,
            headStyles: {
                fillColor: [245, 245, 245],  // Set header background color
                textColor: [0, 0, 0],        // Set text color for header
                fontSize: 6,                 // Adjust font size of header
                fontStyle: 'bold',           // Make the header text bold
            },
            bodyStyles: {
                fillColor: [255, 255, 255],  // Default background color for rows
                textColor: [0, 0, 0],        // Text color for rows
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255],  // Light gray color for alternate rows
                textColor: [0, 0, 0],        // Text color for alternate rows
            },
            styles: {
                fontSize: 6,                 // Font size for the table
                cellPadding: 1,              // Padding inside cells
            },
            theme: 'striped',
            margin: { top: 10, left: 10, right: 10 },
            didDrawPage: function (data) {
                // Page Number Logic
                const pageCount = doc.internal.getNumberOfPages();  // Total page count
                const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;  // Current page number

                // Add the generated date at the footer
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Generated on: ${formattedDate} ${formattedTime}`, 10, pageHeight - 5);  // Add date to the left

                // Add the page number at the bottom of each page (centered)
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Page ${pageCurrent}`, pageWidth - 20, pageHeight - 5, { align: 'right', textColor: "#000" });
            },
        });

        // Save the PDF
        doc.save('Vehicle-Report.pdf');

        // Stop loading and hide the header
        setLoading(false);
        setHeaderShow(false);
    };

    // PDF Download Function
    const ServiceStaffPdf = () => {
        setLoading(true);
        setHeaderShow(false);

        const doc = new jsPDF('p', 'mm', 'a4');  // 'p' for portrait mode, 'a4' paper size
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Load custom font if needed
        doc.addFileToVFS("SourceSans3.ttf", myFont);
        doc.addFont("SourceSans3.ttf", "SourceSans3", "normal");
        doc.setFont("SourceSans3");  // Set the custom font

        // Get the current date and format it as DD-MM-YYYY
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? '0' + currentDate.getMinutes() : currentDate.getMinutes()}`;

        // Add logos
        const leftLogoWidth = 30;
        const leftLogoHeight = 10;
        const rightLogoWidth = 20;
        const rightLogoHeight = 10;

        // Add the right logo (which was previously on the left)
        if (UserData?.logo) {
            doc.addImage('data:image/jpeg;base64,' + UserData?.logo, 'JPEG', 5, 10, rightLogoWidth, rightLogoHeight);
        }

        // Add the left logo (which was previously on the right)
        doc.addImage(curonext, 'PNG', pageWidth - leftLogoWidth - 5, 10, leftLogoWidth, leftLogoHeight);

        // Building Name and Address
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(8);
        doc.text(`${UserData?.buildingName}`, 40, 10);  // Adjust Y positioning for spacing
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(`${UserData?.addressLine1} ${UserData?.addressLine2}`, 40, 15);
        doc.text(`${UserData?.city}, ${UserData?.state}`, 40, 20);

        // Center the report title
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(10);
        doc.text('Service Staff Report', pageWidth / 2, 30, { align: 'center' });

        // Add Criteria Info below the title
        const criteriaText = `Job Type: ${JobType ? JobType : "All"}  | Department: ${DepartmentName ? DepartmentName : "All"} | Role: ${RoleName ? RoleName : "All"}  `;
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(criteriaText, pageWidth / 2, 36, { align: 'center' });

        // Define Table headers for Walkin Report
        const tableHeaders = [
            ['S.No', 'Staff Name', 'Mobile #', 'Date of Birth', 'Gender', 'Father Name', "Department (Role)", "Job Type", "Date of Join"],
        ];

        // Map table rows from WalkInData
        const tableRows = ImageLogo.map((item, index) => [
            index + 1,  // This adds the serial number (S.No)
            item?.userName,
            item?.mobileNumber,
            item?.dob ? convertISTTime(item?.dob) : null,
            item?.gender,
            item?.fatherName,
            `${item?.departmentName}:- ${item?.roleName}`,
            item?.jobType,
            item?.doj ? convertISTTime(item?.doj) : null,
        ]);

        // Generate the PDF table
        doc.autoTable({
            startY: 45,  // Adjust startY to fit below the criteria text
            head: tableHeaders,
            body: tableRows,
            headStyles: {
                fillColor: [245, 245, 245],  // Set header background color
                textColor: [0, 0, 0],        // Set text color for header
                fontSize: 6,                 // Adjust font size of header
                fontStyle: 'bold',           // Make the header text bold
            },
            bodyStyles: {
                fillColor: [255, 255, 255],  // Default background color for rows
                textColor: [0, 0, 0],        // Text color for rows
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255],  // Light gray color for alternate rows
                textColor: [0, 0, 0],        // Text color for alternate rows
            },
            styles: {
                fontSize: 6,                 // Font size for the table
                cellPadding: 1,              // Padding inside cells
            },
            theme: 'striped',
            margin: { top: 10, left: 10, right: 10 },
            didDrawPage: function (data) {
                // Page Number Logic
                const pageCount = doc.internal.getNumberOfPages();  // Total page count
                const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;  // Current page number

                // Add the generated date at the footer
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Generated on: ${formattedDate} ${formattedTime}`, 10, pageHeight - 5);  // Add date to the left

                // Add the page number at the bottom of each page (centered)
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Page ${pageCurrent}`, pageWidth - 20, pageHeight - 5, { align: 'right', textColor: "#000" });
            },
        });

        // Save the PDF
        doc.save('Service-Staff-Report.pdf');

        // Stop loading and hide the header
        setLoading(false);
        setHeaderShow(false);
    };

    // PDF Download Function
    const ServiceComplaintPdf = () => {
        setLoading(true);
        setHeaderShow(false);

        const doc = new jsPDF('p', 'mm', 'a4');  // 'p' for portrait mode, 'a4' paper size
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Load custom font if needed
        doc.addFileToVFS("SourceSans3.ttf", myFont);
        doc.addFont("SourceSans3.ttf", "SourceSans3", "normal");
        doc.setFont("SourceSans3");  // Set the custom font

        // Get the current date and format it as DD-MM-YYYY
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? '0' + currentDate.getMinutes() : currentDate.getMinutes()}`;

        // Add logos
        const leftLogoWidth = 30;
        const leftLogoHeight = 10;
        const rightLogoWidth = 20;
        const rightLogoHeight = 10;

        // Add the right logo (which was previously on the left)
        if (UserData?.logo) {
            doc.addImage('data:image/jpeg;base64,' + UserData?.logo, 'JPEG', 5, 10, rightLogoWidth, rightLogoHeight);
        }

        // Add the left logo (which was previously on the right)
        doc.addImage(curonext, 'PNG', pageWidth - leftLogoWidth - 5, 10, leftLogoWidth, leftLogoHeight);

        // Building Name and Address
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(8);
        doc.text(`${UserData?.buildingName}`, 40, 10);  // Adjust Y positioning for spacing
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(`${UserData?.addressLine1} ${UserData?.addressLine2}`, 40, 15);
        doc.text(`${UserData?.city}, ${UserData?.state}`, 40, 20);

        // Center the report title
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(10);
        doc.text('Help Desk Report', pageWidth / 2, 30, { align: 'center' });

        // Add Criteria Info below the title
        const criteriaText = `Start Date: ${convertISTTime(StartDate)} | End Date: ${convertISTTime(EndDate)} | Tower: ${SelectedTowerName ? SelectedTowerName : "All"}  | Flat: ${SelectedFlatName ? SelectedFlatName : "All"} | Urgent: ${UrgentStatus === null || UrgentStatus === "" ? "All" : (UrgentStatus === "true" ? "Yes" : "No")} | Category: ${CategoryName ? CategoryName : "All"} | Assigned to: ${StaffName ? StaffName : "All"} | Status: ${StatusName ? StatusName : "All"}`;
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(criteriaText, pageWidth / 2, 36, { align: 'center' });

        // Define Table headers for Walkin Report
        const tableHeaders = [
            ['S.No', 'Req#', 'Type', 'Category / Sub-Category', 'Tower - flat', 'Urgent', 'Created Date', "Closure Date", "Status", "Assigned to", "Aging", "ETA"],
        ];


        // Map table rows from WalkInData
        const tableRows = ComplainList.map((item, index) => [
            index + 1,  // This adds the serial number (S.No)
            item?.complaintId,
            item?.applicableLevel,
            item.subCategoryName ? `${item.categoryName}/${item.subCategoryName}` : item.categoryName,
            item?.towerName ? `${item?.towerName} - ${item?.flatName}` : item?.flatName,
            item.isUrgent ? "Yes" : "No",
            item.createdDt ? convertISTDateTime(item.createdDt) : null,
            item?.resolvedDt ? convertISTDateTime(item?.resolvedDt) : null,
            item.statusName,
            item.ssName,
            item.aging,
            item.eta ? convertISTTime(item.eta) : null,
        ]);


        // Generate the PDF table
        doc.autoTable({
            startY: 45,  // Adjust startY to fit below the criteria text
            head: tableHeaders,
            body: tableRows,
            headStyles: {
                fillColor: [245, 245, 245],  // Set header background color
                textColor: [0, 0, 0],        // Set text color for header
                fontSize: 6,                 // Adjust font size of header
                fontStyle: 'bold',           // Make the header text bold
            },
            bodyStyles: {
                fillColor: [255, 255, 255],  // Default background color for rows
                textColor: [0, 0, 0],        // Text color for rows
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255],  // Light gray color for alternate rows
                textColor: [0, 0, 0],        // Text color for alternate rows
            },
            styles: {
                fontSize: 6,                 // Font size for the table
                cellPadding: 1,              // Padding inside cells
            },
            theme: 'striped',
            margin: { top: 10, left: 10, right: 10 },
            didDrawPage: function (data) {
                // Page Number Logic
                const pageCount = doc.internal.getNumberOfPages();  // Total page count
                const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;  // Current page number

                // Add the generated date at the footer
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Generated on: ${formattedDate} ${formattedTime}`, 10, pageHeight - 5);  // Add date to the left

                // Add the page number at the bottom of each page (centered)
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Page ${pageCurrent}`, pageWidth - 20, pageHeight - 5, { align: 'right', textColor: "#000" });
            },
        });

        // Save the PDF
        doc.save('Help-Desk-Report.pdf');

        // Stop loading and hide the header
        setLoading(false);
        setHeaderShow(false);
    };

    // PDF Download Function
    const ActiveUserPdf = () => {
        setLoading(true);
        setHeaderShow(false);

        const doc = new jsPDF('p', 'mm', 'a4');
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        doc.addFileToVFS("SourceSans3.ttf", myFont);
        doc.addFont("SourceSans3.ttf", "SourceSans3", "normal");
        doc.setFont("SourceSans3");

        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? '0' + currentDate.getMinutes() : currentDate.getMinutes()}`;

        // Add logos
        const leftLogoWidth = 30;
        const leftLogoHeight = 10;
        const rightLogoWidth = 20;
        const rightLogoHeight = 10;

        if (UserData?.logo) {
            doc.addImage('data:image/jpeg;base64,' + UserData?.logo, 'JPEG', 5, 10, rightLogoWidth, rightLogoHeight);
        }
        doc.addImage(curonext, 'PNG', pageWidth - leftLogoWidth - 5, 10, leftLogoWidth, leftLogoHeight);

        // Building Name and Address
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(8);
        doc.text(`${UserData?.buildingName}`, 40, 10);
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(`${UserData?.addressLine1} ${UserData?.addressLine2}`, 40, 15);
        doc.text(`${UserData?.city}, ${UserData?.state}`, 40, 20);

        // Center the report title
        doc.setFont("SourceSans3", 'bold');
        doc.setFontSize(10);
        doc.text('Active User Report', pageWidth / 2, 30, { align: 'center' });

        // Add Criteria Info below the title
        const criteriaText = UserData?.roleName === "Super Admin"
            ? `Building: ${BuildingList.find(b => b.buildingId === BuildingId)?.buildingName || "All"} | Tower: ${SelectedTowerName || "All"} | Flat: ${SelectedFlatName || "All"} | Is Residing: ${IsResiding ? "Yes" : "No"}`
            : `Tower: ${SelectedTowerName || "All"} | Flat: ${SelectedFlatName || "All"} | Is Residing: ${IsResiding ? "Yes" : "No"}`;
        doc.setFontSize(8);
        doc.setFont("SourceSans3", 'normal');
        doc.text(criteriaText, pageWidth / 2, 36, { align: 'center' });

        // Define Table headers for Active User Report
        const tableHeaders = [
            ['S.No', 'User Name', 'Mobile #', 'Email Id', 'Tower - Flat #', 'Role', 'Parent User', 'Residing', 'Current Status'],
        ];

        // Map table rows from GetActiveUser
        const tableRows = GetActiveUser.map((item, index) => [
            index + 1,
            item?.userName,
            item?.mobileNumber,
            item?.emailId,
            `${item?.towerName} - ${item?.flatName}`,
            item?.roleName,
            item?.isParent === true ? "Yes" : "No",
            item?.isResiding === true ? "Yes" : "No",
            item?.currentStatus,
        ]);

        doc.autoTable({
            startY: 45,
            head: tableHeaders,
            body: tableRows,
            headStyles: {
                fillColor: [245, 245, 245],
                textColor: [0, 0, 0],
                fontSize: 6,
                fontStyle: 'bold',
            },
            bodyStyles: {
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
            },
            styles: {
                fontSize: 6,
                cellPadding: 1,
            },
            theme: 'striped',
            margin: { top: 10, left: 10, right: 10 },
            didDrawPage: function (data) {
                const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Generated on: ${formattedDate} ${formattedTime}`, 10, pageHeight - 5);
                doc.setFontSize(8);
                doc.setFont("SourceSans3", 'bold');
                doc.text(`Page ${pageCurrent}`, pageWidth - 20, pageHeight - 5, { align: 'right', textColor: "#000" });
            },
        });

        doc.save('Active-User-Report.pdf');
        setLoading(false);
        setHeaderShow(false);
    };








    const handleNext = () => {
        setActiveStep((prevActiveStep) => {
            if (prevActiveStep >= steps.length - 1) {
                // Assuming 'steps' is your array of step labels
                setFirstSectionButton(false);
                console.log(prevActiveStep);
                return 0; // Reset to first step
            } else {
                // console.log(inpRef.current.value)
                setFirstSectionButton(true);
                console.log(prevActiveStep);
                return prevActiveStep + 1;
            }
        });
    };

    const handleBack = () => {
        setFirstSectionButton(false);
        setActiveStep((prevActiveStep) => {
            if (prevActiveStep == 1) {
                setFirstSectionButton(false);
                console.log(prevActiveStep);
                return prevActiveStep - 1;
            } else {
                setFirstSectionButton(true);
                return prevActiveStep - 1;
            }
        });
    };

    const [file, setFile] = useState();
    function handleChange(e) {
        console.log(e.target.files);
        setFile(URL.createObjectURL(e.target.files[0]));
    }






    // const datetimeRef = useRef(null);

    // useEffect(() => {
    //     const handleChange = () => {
    //         console.log("this is run");
    //         // Uncomment and customize the following line if needed
    //         if (datetimeRef.current.value.length === 10) { // Only date selected (YYYY-MM-DD)
    //             datetimeRef.current.value += 'T00:00';
    //         }
    //     };

    //     const inputElement = datetimeRef.current;
    //     if (inputElement) {
    //         inputElement.addEventListener('change', handleChange);
    //     }

    //     return () => {
    //         if (inputElement) {
    //             inputElement.removeEventListener('change', handleChange);
    //         }
    //     };
    // }, []);


    const handleFileInputChangeTwo = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                // atob(item?.logo)
                const encodedString = btoa(reader.result);
                console.log("btoa", encodedString);
                setSelectedImageTwo(reader.result);
                setSelectedImageTwoShow(encodedString);
            };
            reader.readAsDataURL(file);
        }
    };


    const [content, setContent] = useState('');



    return (
        <>

            {Loading ?
                <div className="loaderDiv">
                    <div className="loader"></div>
                </div>
                : null}
            <style>
                {`.table-responsive {
                        height: ${slideshowHeight}px;
                        overflow-y: auto;
                        background-color: #f8f9fa;
                    }
                    
                    
                    
                    // .css-wmy1p7-ReactDropdownSelect{
                    //     font-size: 15px;
                    //     border-color: #ccc;
                    //     border-radius: 4px;
                    //     height: 44px;
                    //     width: 130px;
                    //     background-color: #fff;
                    //     text-align: left;
                    // }
                    //     .css-lnmdiq5-menu{
                    //         z-Index: 9999999 !Important;
                    //     }
                    `}
            </style>

            <Menus />
            <ToastContainer />
            <section className="ToptoBottom">
                <div className="container-fluid mt-5">
                    <div className="row mb-0" style={{ alignItems: 'center' }}>
                        <div className="col-md-5">
                            <div className="HeadingTop" style={{ height: 65 }}>
                                <h3> Reports </h3>
                                <span> Detailed view of various transactions within the application</span>
                            </div>
                        </div>
                        <div className="col-md-7 text-right">
                            <Button onClick={() => {
                                setShowResidentSchedulingReport(true);
                                setFullscreen(true);
                            }} className="createClr">
                                {" "}
                                Schedule Reports
                            </Button>{" "}
                            {/* <Button onClick={() => setShowVisitor(true)} className="createClr">
                            {" "}
                            Create New +
                            </Button>{" "}
                            <Button onClick={() => setShowWalkIn(true)} className="createClr">
                            {" "}
                            Create New +
                            </Button>{" "} */}
                        </div>
                    </div>
                    <Modal scrollable
                        fullscreen={fullscreen}
                        show={show}
                        onHide={() =>
                            setShow(false)}
                        dialogclassName="modal-100w clientmodal"
                        class="modal-dialog modal-fullscreen"
                    >
                        <Modal.Header className="headerMDL" closeButton>
                            <Modal.Title>Resident In/Out Report</Modal.Title>
                        </Modal.Header>
                        <div className="textFromBehind">
                            <p> Efficiently track and review the entry and exit activities of residents, ensuring comprehensive monitoring of daily movements within the building.</p>
                        </div>
                        <Modal.Body>
                            <div className="row" id="validation">
                                <div className="col-12">
                                    <form
                                        action="#"
                                        className="validation-wizard wizard-circle wizard clearfix"
                                        role="application"
                                        id="steps-uid-0"
                                        novalidate="novalidate"
                                    >
                                        <div className="container-fluid mt-3">
                                            <div className="row">
                                                <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                                                    <div className="row">
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0">
                                                            <div className="rior">
                                                                {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                                <span className="syntax"> Start Date</span>
                                                                <input type="date" className="rior__btn" value={StartDate} onChange={(e) => setStartDate(e.target.value)} id="datetime" name="birthday" />
                                                                <input type="time" className="rior__btn" id="birthday" value={StartTime} onChange={(e) => setStartTime(e.target.value)} name="birthday" />
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 ml-1">
                                                            <div className="rior">
                                                                {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                                <span className="syntax"> End Date</span>
                                                                <input type="date" className="rior__btn" value={EndDate} onChange={(e) => setEndDate(e.target.value)} id="datetime" name="birthday" />
                                                                <input type="time" className="rior__btn" id="birthday" value={EndTime} onChange={(e) => setEndTime(e.target.value)} name="birthday" />
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mx-1">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Vehicle Type</span>
                                                            <select name="cars" id="cars" className="reportbtn" value={WheeleType} onChange={(e) =>
                                                                setWheeleType(e.target.value)}>
                                                                <option value="">All Vehicle</option>
                                                                <option value="4WHEELER">4 Wheeler</option>
                                                                <option value="2WHEELER">2 Wheeler</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-1">
                                                            <span className="syntax"> Entry Gate</span>
                                                            {/* <select name="cars" id="cars" className="reportbtn" value={EntryGate} onChange={(e) =>
                                                        setEntryGate(e.target.value.split(","))}>
                                                        <option value="0">Select Entry Gate</option>
                                                        {
                                                            GateList ? GateList.map((item, index) => 
                                                                item?.gateType.toUpperCase() === "ENTRY" ? (
                                                                    <option key={index} value={[item?.gateId, item?.gateName]}>{item?.gateName}</option>
                                                                ) : null
                                                            ) : null
                                                        }
                                                    </select> */}
                                                            <Select
                                                                isMulti
                                                                placeholder="All Entry Gate"
                                                                options={GateList ? GateList
                                                                    .filter(item => item.gateType?.toUpperCase() === "ENTRY")
                                                                    .map(item => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName
                                                                    })) : []}
                                                                onChange={(values) => {
                                                                    setEntryGate(values && values.length > 0 ? values.map(value => value.value) : []);
                                                                }}
                                                                value={EntryGate ? GateList
                                                                    .filter(item => EntryGate.includes(item.gateId))
                                                                    .map(item => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName
                                                                    })) : []}
                                                                className="d-inline-block ml-auto w-100"
                                                                menuPlacement="auto" // Use auto or top for placement
                                                                styles={{
                                                                    menu: (provided) => ({
                                                                        ...provided,
                                                                        left: 0, // Adjust the left position as needed
                                                                        right: 'auto', // Ensure it doesn't go to the right
                                                                        zIndex: 99999
                                                                    }),
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-1" >
                                                            <span className="syntax"> Exit Gate</span>
                                                            {/* <select name="cars" id="cars" className="reportbtn" value={ExitGate} onChange={(e) =>
                                                    setExitGate(e.target.value.split(","))}>
                                                        <option value="0">Select Exit Gate</option>
                                                        {
                                                            GateList ? GateList.map((item, index) => 
                                                                item?.gateType.toUpperCase() === "EXIT" ? (
                                                                    <option key={index} value={[item?.gateId, item?.gateName]}>{item?.gateName}</option>
                                                                ) : null
                                                            ) : null
                                                        }
                                                    </select> */}
                                                            <Select
                                                                isMulti
                                                                placeholder="All Exit Gate"
                                                                options={GateList ? GateList
                                                                    .filter(item => item.gateType?.toUpperCase() === "EXIT")
                                                                    .map(item => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName
                                                                    })) : []}
                                                                onChange={(values) => {
                                                                    setExitGate(values && values.length > 0 ? values.map(value => value.value) : []);
                                                                }}
                                                                value={ExitGate ? GateList
                                                                    .filter(item => ExitGate.includes(item.gateId))
                                                                    .map(item => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName
                                                                    })) : []}
                                                                className="d-inline-block ml-auto w-100"
                                                                menuPlacement="auto" // Use auto or top for placement
                                                                styles={{
                                                                    menu: (provided) => ({
                                                                        ...provided,
                                                                        left: 0, // Adjust the left position as needed
                                                                        right: 'auto', // Ensure it doesn't go to the right
                                                                        zIndex: 99999
                                                                    }),
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-lg-1 col-md-1 col-sm-12 col-12 px-0">
                                                            <a href="#" className="reportbtn text-center" onClick={setInputValue}> Reset </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-1 col-md-1 col-sm-12 col-12 align-content-center text-right">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 pr-0">
                                                            <a className="reportrun" onClick={GetResidentReport}> Run  </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="row">
                                            <div className="col-lg-12 cl-md-12 col-sm-12 col-12 px-0">
                                            <div className="textalert">
                                                <p>
                                                    <FontAwesomeIcon icon={faExclamationTriangle} className="alertfnt" />
                                                    Please Attandance Request, Attandance Report and click run to view the report 
                                                </p>
                                            </div>
                                            </div>
                                        </div> */}
                                            <div className="row mt-3">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-right pr-0">
                                                    <div className="filterUpperTop">
                                                        <input type="text" className="onlysearch" value={SearchData} placeholder='Search' onChange={(e) => filterResidentData(e.target.value)} />
                                                        <FontAwesomeIcon icon={faSearch} className="searchico" />
                                                        <div className="dropdown">
                                                            <FontAwesomeIcon icon={faDownload} className="reportexlpdf ReportingTools dropdown-toggle float-right" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                            <ul className="dropdown-content">
                                                                <li>
                                                                    {/* <DownloadTableExcel
                                                                filename="In/Out-Report"
                                                                sheet="users"
                                                                currentTableRef={tableRef.current}
                                                            > */}

                                                                    {/* <button type="button" style={{color:'#000'}}> Export excel </button> */}
                                                                    <button type="button" style={{ color: '#000' }} onClick={handleExport}>Export Excel</button>
                                                                    {/* <ExcelFile {...excelData}>Export to Excel</ExcelFile> */}
                                                                    {/* </DownloadTableExcel> */}
                                                                    {/* <ExportToExcel data={ResidentData} /> */}
                                                                </li>
                                                                <li><button className="color" type="button" disabled={ResidentData ? false : true} onClick={() => ResidentPdfFunction()}> Download PDF</button></li>
                                                            </ul>
                                                        </div>
                                                        {/* <FontAwesomeIcon icon={faEllipsisV} className="ReportingTools reportexlpdf" /> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2" ref={tableRef}>

                                                <div className="tableFixHead">
                                                    <div className="scrolling_tbl" style={{ height: 'auto', overflow: "hidden" }} ref={targetRef}>


                                                        {/* <ExcelFile element={<button>Export to Excel</button>}>
                                                <ExcelSheet data={ResidentData} name="Report"> */}
                                                        {/* {sheetData ? */}
                                                        <Table striped responsive className="mb-0" ref={targetPDFRef} >

                                                            <thead >
                                                                {HeaderShow ?
                                                                    <>
                                                                        <tr>
                                                                            <th colspan="4" style={{ backgroundColor: "rgba(0,0,0,0)", border: 'none' }} className="p-0">
                                                                                <div className="d-flex mt-3">
                                                                                    <img src={curonext} alt="homepage" className="dark-logo" style={{ width: "140px", padding: '0px 0px 0px' }} />
                                                                                    <div className="ml-3">
                                                                                        <p className="mb-0">{UserData?.buildingName}</p>
                                                                                        <p className="mb-0" style={{ fontWeight: 400 }}>{UserData?.addressLine1} {UserData?.addressLine2}</p>
                                                                                        <p className="mb-0" style={{ fontWeight: 400 }}>{UserData?.city} , {UserData?.state}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </th>

                                                                            <th colspan="4" style={{ backgroundColor: "rgba(0,0,0,0)", border: 'none' }} className="p-0">
                                                                                <img src={"data:image/jpeg;base64," + UserData?.logo} alt="homepage" className="dark-logo mt-3" style={{ width: "44px", padding: '0px 0px 0px', float: 'right', marginRight: "15px" }} /></th>
                                                                        </tr>

                                                                        <tr>
                                                                            <th colspan="8" style={{ backgroundColor: "rgba(0,0,0,0)", border: 'none' }} className="p-0">  <p style={{ backgroundColor: "rgba(0,0,0,0)", border: 'none' }} className="text-center"> Resident Report
                                                                                <br /> <b>Criteria: </b> <span style={{ fontWeight: 400 }}> Start Date: {StartDate} </span>  <span className="ml-2" style={{ fontWeight: 400 }}> End Date: {EndDate} </span> <span className="ml-2" style={{ fontWeight: 400 }}> Vehicle Type: {WheeleType ? WheeleType : "All"} </span> <span className="ml-2" style={{ fontWeight: 400 }}> Entry Gate: {EntryGate[1] ? EntryGate[1] : "All"}  </span> <span className="ml-2" style={{ fontWeight: 400 }}> Exit Gate: {ExitGate[1] ? ExitGate[1] : "All"} </span> </p> <br />
                                                                            </th>

                                                                        </tr>
                                                                    </>
                                                                    : null}

                                                                <tr>
                                                                    <th>Resident Name</th>
                                                                    <th>Flat #</th>
                                                                    <th>Vehicle #</th>
                                                                    <th>Entry</th>
                                                                    <th>Gate</th>
                                                                    <th>Exit</th>
                                                                    <th>Gate</th>
                                                                    <th>Transit Remark</th>
                                                                </tr>

                                                            </thead>
                                                            <tbody>
                                                                {ResidentData
                                                                    ? ResidentData.map((item, index) => (
                                                                        <tr>
                                                                            <td>{item?.personName}</td>
                                                                            <td>{item?.towerName} - {item?.flatName}</td>
                                                                            <td>{item?.lpNumber}</td>
                                                                            <td>{convertISTDateTime(item?.entryDt)}</td>
                                                                            <td>{item?.entryGateName}</td>
                                                                            {item?.exitGateName ?
                                                                                <>
                                                                                    <td>{convertISTDateTime(item?.exitDt)}</td>
                                                                                    <td>{item?.exitGateName}</td>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                </>
                                                                            }
                                                                            <td>{item?.transitRemark}</td>
                                                                        </tr>)) : null}

                                                            </tbody>

                                                        </Table>
                                                        {/* :null}     */}
                                                        {/* </ExcelSheet>
                                            </ExcelFile>          */}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    {/* Visitor Report Modal */}
                    <Modal scrollable
                        fullscreen={fullscreen}
                        show={ShowVisitor}
                        onHide={() =>
                            setShowVisitor(false)}
                        dialogclassName="modal-100w clientmodal"
                        class="modal-dialog modal-fullscreen"
                    >
                        <Modal.Header className="headerMDL" closeButton>
                            <Modal.Title>Visitor In/Out Report</Modal.Title>
                        </Modal.Header>
                        <div className="textFromBehind">
                            <p> Track visitor entry and exit activities closely to boost transparency and ensure a secure, well-monitored environment for all residents.</p>
                        </div>
                        <Modal.Body>
                            <div className="row" id="validation">
                                <div className="col-12">
                                    <form
                                        action="#"
                                        className="validation-wizard wizard-circle wizard clearfix"
                                        role="application"
                                        id="steps-uid-0"
                                        novalidate="novalidate"
                                    >
                                        <div className="container-fluid mt-3">
                                            <div className="row">
                                                <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                                                    <div className="row">
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <div className="rior">
                                                                <span className="syntax"> Start Date</span>
                                                                <input type="date" className="rior__btn" value={StartDate} onChange={(e) => setStartDate(e.target.value)} id="datetime" name="birthday" />
                                                                <input type="time" className="rior__btn" id="birthday" value={StartTime} onChange={(e) => setStartTime(e.target.value)} name="birthday" />
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 ml-1">
                                                            <div className="rior">
                                                                {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                                <span className="syntax"> End Date</span>
                                                                <input type="date" className="rior__btn" value={EndDate} onChange={(e) => setEndDate(e.target.value)} id="datetime" name="birthday" />
                                                                <input type="time" className="rior__btn" id="birthday" value={EndTime} onChange={(e) => setEndTime(e.target.value)} name="birthday" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mx-1">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Vehicle Type</span>
                                                            <select name="cars" id="cars" className="reportbtn" value={WheeleType} onChange={(e) =>
                                                                setWheeleType(e.target.value)}>
                                                                <option value="">All Vehicle</option>
                                                                <option value="4WHEELER">4 Wheeler</option>
                                                                <option value="2WHEELER">2 Wheeler</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-1">
                                                            <span className="syntax"> Entry Gate</span>
                                                            {/* <select name="cars" id="cars" className="reportbtn" value={EntryGate} onChange={(e) =>
                                                            setEntryGate(e.target.value.split(","))}>
                                                            <option value="0">Select Entry Gate</option>
                                                            {
                                                                GateList ? GateList.map((item, index) => 
                                                                    item.gateType.toUpperCase() === "ENTRY" ? (
                                                                        <option key={index} value={[item?.gateId, item?.gateName]}>{item?.gateName}</option>
                                                                    ) : null
                                                                ) : null
                                                            }
                                                        </select> */}
                                                            <Select
                                                                isMulti
                                                                placeholder="All Entry Gate"
                                                                options={GateList ? GateList
                                                                    .filter(item => item.gateType?.toUpperCase() === "ENTRY")
                                                                    .map(item => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName
                                                                    })) : []}
                                                                onChange={(values) => {
                                                                    setEntryGate(values && values.length > 0 ? values.map(value => value.value) : []);
                                                                }}
                                                                value={EntryGate ? GateList
                                                                    .filter(item => EntryGate.includes(item.gateId))
                                                                    .map(item => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName
                                                                    })) : []}
                                                                className="d-inline-block ml-auto w-100"
                                                                menuPlacement="auto" // Use auto or top for placement
                                                                styles={{
                                                                    menu: (provided) => ({
                                                                        ...provided,
                                                                        left: 0, // Adjust the left position as needed
                                                                        right: 'auto', // Ensure it doesn't go to the right
                                                                        zIndex: 99999
                                                                    }),
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-1" >
                                                            <span className="syntax"> Exit Gate</span>
                                                            {/* <select name="cars" id="cars" className="reportbtn" value={ExitGate} onChange={(e) =>
                                                    setExitGate(e.target.value.split(","))}>
                                                        <option value="0">Select Exit Gate</option>
                                                        {
                                                            GateList ? GateList.map((item, index) => 
                                                                item.gateType.toUpperCase() === "EXIT" ? (
                                                                    <option key={index} value={[item?.gateId, item?.gateName]}>{item?.gateName}</option>
                                                                ) : null
                                                            ) : null
                                                        }
                                                    </select> */}
                                                            <Select
                                                                isMulti
                                                                placeholder="All Exit Gate"
                                                                options={GateList ? GateList
                                                                    .filter(item => item.gateType?.toUpperCase() === "EXIT")
                                                                    .map(item => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName
                                                                    })) : []}
                                                                onChange={(values) => {
                                                                    setExitGate(values && values.length > 0 ? values.map(value => value.value) : []);
                                                                }}
                                                                value={ExitGate ? GateList
                                                                    .filter(item => ExitGate.includes(item.gateId))
                                                                    .map(item => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName
                                                                    })) : []}
                                                                className="d-inline-block ml-auto w-100"
                                                                menuPlacement="auto" // Use auto or top for placement
                                                                styles={{
                                                                    menu: (provided) => ({
                                                                        ...provided,
                                                                        left: 0, // Adjust the left position as needed
                                                                        right: 'auto', // Ensure it doesn't go to the right
                                                                        zIndex: 99999
                                                                    }),
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-lg-1 col-md-1 col-sm-12 col-12 px-0">
                                                            <a className="reportbtn text-center" onClick={VisitorModal}> Reset </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-1 col-md-1 col-sm-12 col-12 align-content-center text-right">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 pr-0">
                                                            <a className="reportrun" onClick={GetVisitorReport}> Run  </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-right pr-0">
                                                    <div className="filterUpperTop">
                                                        <input type="text" className="onlysearch" value={SearchData} placeholder='Search' onChange={(e) => filterVisitorData(e.target.value)} />
                                                        <FontAwesomeIcon icon={faSearch} className="searchico" />
                                                        <div className="dropdown">
                                                            <FontAwesomeIcon icon={faDownload} className="reportexlpdf ReportingTools dropdown-toggle float-right" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                            <ul className="dropdown-content">
                                                                <li>
                                                                    {/* <DownloadTableExcel
                                                                filename="In/Out-Report"
                                                                sheet="users"
                                                                currentTableRef={tableRef.current}
                                                            >

                                                            <button type="button"  style={{color:'#000'}}> Export excel </button>

                                                            </DownloadTableExcel> */}
                                                                    <button type="button" style={{ color: '#000' }} onClick={handleExport}>Export Excel</button>
                                                                </li>
                                                                <li><button className="color" type="button" disabled={VisitorData ? false : true} onClick={() => VisitiorPdfFunction()}> Download PDF</button></li>
                                                            </ul>
                                                        </div>
                                                        {/* <FontAwesomeIcon icon={faEllipsisV} className="reportexlpdf ReportingTools" /> */}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mt-2" ref={tableRef}>

                                                <div className="tableFixHead">
                                                    <div className="scrolling_tbl" style={{ height: 'auto', overflow: "hidden" }} ref={targetRef}>


                                                        <Table striped responsive className="mb-0" ref={targetPDFRef} >
                                                            {/* <span > */}
                                                            <thead>
                                                                {HeaderShow ?
                                                                    <>
                                                                        <tr>
                                                                            <th colspan="4" style={{ backgroundColor: "rgba(0,0,0,0)", border: 'none' }} className="p-0">
                                                                                <div className="d-flex mt-3">
                                                                                    <img src={curonext} alt="homepage" className="dark-logo" style={{ width: "140px", padding: '0px 0px 0px' }} />
                                                                                    <div className="ml-3">
                                                                                        <p className="mb-0">{UserData?.buildingName}</p>
                                                                                        <p className="mb-0" style={{ fontWeight: 400 }}>{UserData?.addressLine1} {UserData?.addressLine2}</p>
                                                                                        <p className="mb-0" style={{ fontWeight: 400 }}>{UserData?.city} , {UserData?.state}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </th>

                                                                            <th colspan="4" style={{ backgroundColor: "rgba(0,0,0,0)", border: 'none' }} className="p-0">
                                                                                <img src={"data:image/jpeg;base64," + UserData?.logo} alt="homepage" className="dark-logo mt-3" style={{ width: "44px", padding: '0px 0px 0px', float: 'right', marginRight: "15px" }} /></th>
                                                                        </tr>

                                                                        <tr>
                                                                            <th colspan="8" style={{ backgroundColor: "rgba(0,0,0,0)", border: 'none' }} className="p-0">  <p style={{ backgroundColor: "rgba(0,0,0,0)", border: 'none' }} className="text-center"> Visitor Report
                                                                                <br /> <b>Criteria: </b> <span style={{ fontWeight: 400 }}> Start Date: {StartDate} </span>  <span className="ml-2" style={{ fontWeight: 400 }}> End Date: {EndDate} </span> <span className="ml-2" style={{ fontWeight: 400 }}> Vehicle Type: {WheeleType ? WheeleType : "All"} </span> <span className="ml-2" style={{ fontWeight: 400 }}> Entry Gate: {EntryGate[1] ? EntryGate[1] : "All"}  </span> <span className="ml-2" style={{ fontWeight: 400 }}> Exit Gate: {ExitGate[1] ? ExitGate[1] : "All"} </span> </p> <br />
                                                                            </th>

                                                                        </tr>
                                                                    </>
                                                                    : null}
                                                                <tr>
                                                                    <th>Visitor Name</th>
                                                                    <th>Visitor Type</th>
                                                                    <th>Flat #</th>
                                                                    <th>Vehicle #</th>
                                                                    <th>Entry</th>
                                                                    <th>Gate</th>
                                                                    <th>Exit</th>
                                                                    <th>Gate</th>
                                                                    <th>Duration</th>
                                                                    <th>Transit Remark</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {VisitorData
                                                                    ? VisitorData?.map((item, index) => (
                                                                        <tr>
                                                                            <td>{item?.personName}</td>
                                                                            <td>{item?.visitorType}</td>
                                                                            <td>{item?.towerName} - {item?.flatName}</td>
                                                                            <td>{item?.lpNumber}</td>
                                                                            <td>{convertISTDateTime(item?.entryDt)}</td>
                                                                            <td>{item?.entryGateName}</td>
                                                                            {item?.exitGateName ?
                                                                                <>
                                                                                    <td>{convertISTDateTime(item?.exitDt)}</td>
                                                                                    <td>{item?.exitGateName}</td>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                </>
                                                                            }
                                                                            {item?.entryDt && item?.exitDt ?
                                                                                <td>{calculateDuration(item?.entryDt, item?.exitDt)}</td>
                                                                                :
                                                                                <td></td>
                                                                            }

                                                                            <td>{item?.transitRemark}</td>
                                                                        </tr>)) : null}
                                                            </tbody>
                                                            {/* </span>     */}
                                                        </Table>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    {/* WalkIn   Report Modal */}
                    <Modal scrollable
                        fullscreen={fullscreen}
                        show={ShowWalkIn}
                        onHide={() =>
                            setShowWalkIn(false)}
                        dialogclassName="modal-100w clientmodal"
                        class="modal-dialog modal-fullscreen"
                    >
                        <Modal.Header className="headerMDL" closeButton>
                            <Modal.Title>Walk-in Visitor In/Out Report</Modal.Title>
                        </Modal.Header>
                        <div className="textFromBehind">
                            <p> Record and review walk-in visitor details thoroughly, enabling administrators to maintain a safer, more controlled environment.</p>
                        </div>
                        <Modal.Body>
                            <div className="row" id="validation">
                                <div className="col-12">
                                    <form
                                        action="#"
                                        className="validation-wizard wizard-circle wizard clearfix"
                                        role="application"
                                        id="steps-uid-0"
                                        novalidate="novalidate"
                                    >
                                        <div className="container-fluid mt-3">
                                            <div className="row">
                                                <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                                                    <div className="row">
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0">
                                                            <div className="rior">
                                                                {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                                <span className="syntax"> Start Date</span>
                                                                <input type="date" className="rior__btn" value={StartDate} onChange={(e) => setStartDate(e.target.value)} id="datetime" name="birthday" />
                                                                <input type="time" className="rior__btn" id="birthday" value={StartTime} onChange={(e) => setStartTime(e.target.value)} name="birthday" />
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mx-1">
                                                            <div className="rior">
                                                                {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                                <span className="syntax"> End Date</span>
                                                                <input type="date" className="rior__btn" value={EndDate} onChange={(e) => setEndDate(e.target.value)} id="datetime" name="birthday" />
                                                                <input type="time" className="rior__btn" id="birthday" value={EndTime} onChange={(e) => setEndTime(e.target.value)} name="birthday" />
                                                            </div>
                                                        </div>

                                                        {/* <div className="col-lg-1 col-md-1 col-sm-12 col-12 px-0">
                                                    <a href="#" className="reportbtn"> Attendance Request   </a>
                                                    <span className="syntax"> Vehicle Type</span>
                                                    <select name="cars" id="cars" className="reportbtn" value={WheeleType} onChange={(e) =>
                                                        setWheeleType(e.target.value)}>
                                                        <option value="">Select Vehicle Type</option>
                                                        <option value="4WHEELER">4 Wheeler</option>
                                                        <option value="2WHEELER">2 Wheeler</option>
                                                    </select>
                                                </div> */}
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-1">
                                                            <span className="syntax"> Entry Gate</span>
                                                            {/* <select name="cars" id="cars" className="reportbtn" value={EntryGate} onChange={(e) =>
                                                        setEntryGate(e.target.value.split(","))}>
                                                        <option value="0">Select Entry Gate</option>
                                                        {
                                                            GateList ? GateList?.map((item, index) => 
                                                                item.gateType.toUpperCase() === "ENTRY" && item.gateSubType.toUpperCase() === "WALKIN" ? (
                                                                    <option key={index} value={[item?.gateId, item?.gateName]}>{item?.gateName}</option>
                                                                ) : null
                                                            ) : null
                                                        }
                                                       
                                                    </select> */}
                                                            <Select
                                                                isMulti
                                                                placeholder="All Entry Gate"
                                                                options={GateList ? GateList
                                                                    .filter(item => item.gateType.toUpperCase() === "ENTRY" && item.gateSubType.toUpperCase() === "WALKIN")
                                                                    .map(item => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName
                                                                    })) : []}
                                                                onChange={(values) => {
                                                                    setEntryGate(values && values.length > 0 ? values.map(value => value.value) : []);
                                                                }}
                                                                value={EntryGate ? GateList
                                                                    .filter(item => EntryGate.includes(item.gateId))
                                                                    .map(item => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName
                                                                    })) : []}
                                                                className="d-inline-block ml-auto w-100"
                                                                menuPlacement="auto" // Use auto or top for placement
                                                                styles={{
                                                                    menu: (provided) => ({
                                                                        ...provided,
                                                                        left: 0, // Adjust the left position as needed
                                                                        right: 'auto', // Ensure it doesn't go to the right
                                                                        zIndex: 99999
                                                                    }),
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-1" >
                                                            <span className="syntax"> Exit Gate</span>
                                                            {/* <select name="cars" id="cars" className="reportbtn" value={ExitGate} onChange={(e) =>
                                                    setExitGate(e.target.value.split(","))}>
                                                        <option value="0">Select Exit Gate</option>
                                                        {
                                                            GateList ? GateList.map((item, index) => 
                                                                item.gateType.toUpperCase() === "EXIT" && item.gateSubType.toUpperCase() === "WALKIN" ? (
                                                                    <option key={index} value={[item?.gateId, item?.gateName]}>{item?.gateName}</option>
                                                                ) : null
                                                            ) : null
                                                        }
                                                    </select> */}
                                                            <Select
                                                                isMulti
                                                                placeholder="All Exit Gate"
                                                                options={GateList ? GateList
                                                                    .filter(item => item.gateType.toUpperCase() === "EXIT" && item.gateSubType.toUpperCase() === "WALKIN" === "EXIT")
                                                                    .map(item => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName
                                                                    })) : []}
                                                                onChange={(values) => {
                                                                    setExitGate(values && values.length > 0 ? values.map(value => value.value) : []);
                                                                }}
                                                                value={ExitGate ? GateList
                                                                    .filter(item => ExitGate.includes(item.gateId))
                                                                    .map(item => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName
                                                                    })) : []}
                                                                className="d-inline-block ml-auto w-100"
                                                                menuPlacement="auto" // Use auto or top for placement
                                                                styles={{
                                                                    menu: (provided) => ({
                                                                        ...provided,
                                                                        left: 0, // Adjust the left position as needed
                                                                        right: 'auto', // Ensure it doesn't go to the right
                                                                        zIndex: 99999
                                                                    }),
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-lg-1 col-md-1 col-sm-12 col-12 px-0">
                                                            <a className="reportbtn text-center" onClick={WalkInModal}> Reset </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-1 col-md-1 col-sm-12 col-12 align-content-center text-right">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 pr-0">
                                                            <a className="reportrun" onClick={GetWalkInReport}> Run  </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-right pr-0">
                                                    <div className="filterUpperTop">
                                                        <input type="text" className="onlysearch" value={SearchData} placeholder='Search' onChange={(e) => filterWalkinData(e.target.value)} />
                                                        <FontAwesomeIcon icon={faSearch} className="searchico" />
                                                        <div className="dropdown">
                                                            <FontAwesomeIcon icon={faDownload} className="reportexlpdf ReportingTools dropdown-toggle float-right" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                            <ul className="dropdown-content">
                                                                <li>
                                                                    {/* <DownloadTableExcel
                                                                filename="In/Out-Report"
                                                                sheet="users"
                                                                currentTableRef={tableRef.current}
                                                            >

                                                            <button type="button" style={{color:'#000'}}> Export excel </button>

                                                            </DownloadTableExcel> */}
                                                                    <button type="button" style={{ color: '#000' }} onClick={handleExport}>Export Excel</button>
                                                                </li>
                                                                <li><button className="color" type="button" disabled={WalkInData ? false : true} onClick={() => WalkinReportPdfFunction()}> Download PDF</button></li>
                                                            </ul>
                                                        </div>
                                                        {/* <FontAwesomeIcon icon={faEllipsisV} className=" reportexlpdf ReportingTools" /> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2" ref={tableRef}>

                                                <div className="tableFixHead">
                                                    <div className="scrolling_tbl" style={{ height: 'auto', overflow: "hidden" }} ref={targetRef}>

                                                        <Table striped responsive className="mb-0" ref={targetPDFRef} >
                                                            <thead>
                                                                {HeaderShow ?
                                                                    <>
                                                                        <tr>
                                                                            <th colspan="4" style={{ backgroundColor: "rgba(0,0,0,0)", border: 'none' }} className="p-0">
                                                                                <div className="d-flex mt-3">
                                                                                    <img src={curonext} alt="homepage" className="dark-logo" style={{ width: "140px", padding: '0px 0px 0px' }} />
                                                                                    <div className="ml-3">
                                                                                        <p className="mb-0">{UserData?.buildingName}</p>
                                                                                        <p className="mb-0" style={{ fontWeight: 400 }}>{UserData?.addressLine1} {UserData?.addressLine2}</p>
                                                                                        <p className="mb-0" style={{ fontWeight: 400 }}>{UserData?.city} , {UserData?.state}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </th>

                                                                            <th colspan="4" style={{ backgroundColor: "rgba(0,0,0,0)", border: 'none' }} className="p-0">
                                                                                <img src={"data:image/jpeg;base64," + UserData?.logo} alt="homepage" className="dark-logo mt-3" style={{ width: "44px", padding: '0px 0px 0px', float: 'right', marginRight: "15px" }} /></th>
                                                                        </tr>

                                                                        <tr>
                                                                            <th colspan="8" style={{ backgroundColor: "rgba(0,0,0,0)", border: 'none' }} className="p-0">  <p style={{ backgroundColor: "rgba(0,0,0,0)", border: 'none' }} className="text-center"> Walkin Report
                                                                                <br /> <b>Criteria: </b> <span style={{ fontWeight: 400 }}> Start Date: {StartDate} </span>  <span className="ml-2" style={{ fontWeight: 400 }}> End Date: {EndDate} </span> <span className="ml-2" style={{ fontWeight: 400 }}> Vehicle Type: {WheeleType ? WheeleType : "All"} </span> <span className="ml-2" style={{ fontWeight: 400 }}> Entry Gate: {EntryGate[1] ? EntryGate[1] : "All"}  </span> <span className="ml-2" style={{ fontWeight: 400 }}> Exit Gate: {ExitGate[1] ? ExitGate[1] : "All"} </span> </p> <br />
                                                                            </th>

                                                                        </tr>
                                                                    </>
                                                                    : null}
                                                                <tr>
                                                                    <th>Walk-in Visitor Name</th>
                                                                    <th>Visitor Type</th>
                                                                    <th>Flat #</th>
                                                                    <th>Entry</th>
                                                                    <th>Gate</th>
                                                                    <th>Exit</th>
                                                                    <th>Gate</th>
                                                                    <th>Transit Remark</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {WalkInData
                                                                    ? WalkInData?.map((item, index) => (
                                                                        <tr>
                                                                            <td>{item?.personName}</td>
                                                                            <td>{item?.visitorType}</td>
                                                                            <td>{item?.towerName} - {item?.flatName}</td>
                                                                            <td>{convertISTDateTime(item?.entryDt)}</td>
                                                                            <td>{item?.entryGateName}</td>
                                                                            <td>{convertISTDateTime(item?.exitDt)}</td>
                                                                            <td>{item?.exitGateName}</td>
                                                                            <td>{item?.transitRemark}</td>
                                                                        </tr>)) : null}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>


                    {/* Residing Resident Report Modal */}
                    <Modal scrollable
                        fullscreen={fullscreen}
                        show={ShowResidingResident}
                        onHide={() =>
                            setShowResidingResident(false)}
                        dialogclassName="modal-100w clientmodal"
                        class="modal-dialog modal-fullscreen"
                    >
                        <Modal.Header className="headerMDL" closeButton>
                            <Modal.Title>Residing Resident Report</Modal.Title>
                        </Modal.Header>
                        <div className="textFromBehind">
                            <p> Access a detailed, up-to-date list of all residents currently residing in the community, providing easy management for building administrators.</p>
                        </div>
                        <Modal.Body>
                            <div className="row" id="validation">
                                <div className="col-12">
                                    <form
                                        action="#"
                                        className="validation-wizard wizard-circle wizard clearfix"
                                        role="application"
                                        id="steps-uid-0"
                                        novalidate="novalidate"
                                    >
                                        <div className="container-fluid mt-3">
                                            <div className="row">
                                                <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                                                    <div className="row">
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-2">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Tower</span>
                                                            {/* <select name="cars" id="cars" className="reportbtn" value={[SelectedTower, SelectedTowerName].join(",")} onChange={(e) =>{
                                                        const [towerId, towerName] = e.target.value.split(",");
                                                        setSelectedTower(towerId); setSelectedTowerName(towerName)}}>
                                                        <option value="">All Tower</option>
                                                        {TowerList ? TowerList?.map((item, index) =>  <option key={index} value={[item?.towerId, item?.towerName].join(",")}>{item?.towerName}</option>): null}
                                                    </select> */}
                                                            <SelectSearch
                                                                isSearchable={true}
                                                                clearable={SelectedTower ? true : false}
                                                                options={
                                                                    TowerList
                                                                        ? [ ...TowerList.map(item => ({
                                                                            value: item.towerId,
                                                                            label: item.towerName,
                                                                        }))]
                                                                        : []
                                                                }
                                                                getOptionLabel={(option) => option.label}
                                                                getOptionValue={(option) => option.value}
                                                                className="sltareamodal"
                                                                placeholder="All Tower"
                                                                // style={{width: "100%", height: "40px"}}
                                                                style={{
                                                                    fontSize: '15px',
                                                                    borderColor: '#ccc',
                                                                    borderRadius: '4px',
                                                                    height: '40px',
                                                                    width: '100%',
                                                                    backgroundColor: '#fff',
                                                                    textAlign: 'left',
                                                                    marginRight: 10
                                                                }}
                                                                dropdownStyle={{
                                                                    width: '200px',
                                                                    // zIndex: 9999
                                                                }}
                                                                values={
                                                                    SelectedTower
                                                                        ? [{ value: SelectedTower, label: SelectedTowerName }]
                                                                        : []
                                                                }
                                                                onChange={(values) => {
                                                                    const sel = values?.[0];
                                                                    const towerId = sel?.value || "";
                                                                    const towerName = sel?.label || "";

                                                                    setSelectedTower(towerId);
                                                                    setSelectedTowerName(towerName);

                                                                    // Clear flat selection & list
                                                                    setSelectedFlat("");
                                                                    setSelectedFlatName("");
                                                                    setFlatList([]);
                                                                }}
                                                            />

                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Flat</span>
                                                            {/* <select name="cars" id="cars" className="reportbtn" value={[SelectedFlat, SelectedFlatName].join(",")} onChange={(e) =>{
                                                        const [flatId, flatName] = e.target.value.split(","); 
                                                        setSelectedFlat(flatId); setSelectedFlatName(flatName)}}>
                                                        <option value="">Select Flat</option>
                                                        {FlatList ? FlatList?.map((item, index) =>  <option key={index} value={[item?.flatId, item?.flatName].join(",")}>{item?.flatName}</option>): null}
                                                    </select> */}
                                                            <SelectSearch
                                                                isSearchable={true}
                                                                clearable={SelectedFlat ? true : false}
                                                                options={
                                                                    FlatList
                                                                        ? [ ...FlatList.map(item => ({
                                                                            value: item.flatId,
                                                                            label: item.flatName,
                                                                        }))]
                                                                        : []
                                                                }

                                                                className="sltareamodal"
                                                                placeholder="Select Flat"
                                                                // style={{width: "100%", height: "40px"}}
                                                                style={{
                                                                    fontSize: '15px',
                                                                    borderColor: '#ccc',
                                                                    borderRadius: '4px',
                                                                    height: '40px',
                                                                    width: '96%',
                                                                    backgroundColor: '#fff',
                                                                    textAlign: 'left',
                                                                    marginRight: 10
                                                                }}
                                                                dropdownStyle={{
                                                                    width: '200px',
                                                                    // zIndex: 9999
                                                                }}
                                                                values={
                                                                    SelectedFlat
                                                                        ? [{ value: SelectedFlat, label: SelectedFlatName }]
                                                                        : []
                                                                }
                                                                onChange={(values) => {
                                                                    const sel = values?.[0];
                                                                    const flatId = sel?.value || "";
                                                                    const flatName = sel?.label || "";

                                                                    setSelectedFlat(flatId);
                                                                    setSelectedFlatName(flatName);
                                                                }}
                                                            />
                                                        </div>

                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0" >
                                                            <div style={{ display: "flex", marginLeft: 10, marginTop: 10 }}>
                                                                <span> Include Family Member</span>
                                                                <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" checked={FamilyMember} style={{ position: "relative", opacity: 1, left: 0, marginLeft: 5 }} onChange={(e) =>
                                                                    setFamilyMember(e.target.checked)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-1 col-md-1 col-sm-12 col-12 px-0">
                                                            <a className="reportbtn text-center" onClick={ResidingResidentModal}> Reset </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-1 col-md-1 col-sm-12 col-12 align-content-center text-right">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 pr-0">
                                                            <a className="reportrun" onClick={GetResidingResident}> Run  </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-right pr-0">
                                                    <div className="filterUpperTop">
                                                        <input type="text" className="onlysearch" value={SearchData} placeholder='Search' onChange={(e) => filterReportData(e.target.value)} />
                                                        <FontAwesomeIcon icon={faSearch} className="searchico" />
                                                        <div className="dropdown">
                                                            <FontAwesomeIcon icon={faDownload} className="reportexlpdf ReportingTools dropdown-toggle float-right" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                            <ul className="dropdown-content">
                                                                <li>
                                                                    {/* <DownloadTableExcel
                                                                filename="In/Out-Report"
                                                                sheet="users"
                                                                currentTableRef={tableRef.current}
                                                            >

                                                            <button type="button" style={{color:'#000'}}> Export excel </button>

                                                            </DownloadTableExcel> */}
                                                                    <button type="button" style={{ color: '#000' }} onClick={handleExport}>Export Excel</button>
                                                                </li>
                                                                <li><button className="color" type="button" disabled={ResidentResidingData ? false : true} onClick={() => ResidingResidentPdf()}> Download PDF</button></li>
                                                            </ul>
                                                        </div>
                                                        {/* <FontAwesomeIcon icon={faEllipsisV} className=" reportexlpdf ReportingTools" /> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2" ref={tableRef}>

                                                <div className="tableFixHead">
                                                    <div className="scrolling_tbl" style={{ height: 'auto', overflow: "hidden" }} ref={targetRef}>

                                                        <Table striped responsive className="mb-0" ref={targetPDFRef} >
                                                            <thead>
                                                                <tr>
                                                                    <th>Flat Owner</th>
                                                                    <th>Flat #</th>
                                                                    <th>Primary User</th>
                                                                    <th>Mobile #</th>
                                                                    <th>Email Id</th>
                                                                    <th>Resident Type</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {ResidentResidingData
                                                                    ? ResidentResidingData?.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item?.userName}</td>
                                                                            <td>{item?.towerName} - {item?.flatName}</td>
                                                                            <td>{item?.isParent ? "Yes" : "No"}</td>
                                                                            <td>{item?.mobileNumber}</td>
                                                                            <td>{item?.emailId}</td>
                                                                            <td>{item?.roleName}</td>
                                                                        </tr>)) : null}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    {/* Owner Resident Report Modal */}
                    <Modal scrollable
                        fullscreen={fullscreen}
                        show={ShowOwnerRepot}
                        onHide={() =>
                            setShowOwnerRepot(false)}
                        dialogclassName="modal-100w clientmodal"
                        class="modal-dialog modal-fullscreen"
                    >
                        <Modal.Header className="headerMDL" closeButton>
                            <Modal.Title>Flat Owner Report</Modal.Title>
                        </Modal.Header>
                        <div className="textFromBehind">
                            <p> Get in-depth information on flat owners to streamline operations and elevate building management.</p>
                        </div>
                        <Modal.Body>
                            <div className="row" id="validation">
                                <div className="col-12">
                                    <form
                                        action="#"
                                        className="validation-wizard wizard-circle wizard clearfix"
                                        role="application"
                                        id="steps-uid-0"
                                        novalidate="novalidate"
                                    >
                                        <div className="container-fluid mt-3">
                                            <div className="row">
                                                <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                                                    <div className="row">
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-1">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Tower</span>
                                                            {/* <select name="cars" id="cars" className="reportbtn" value={[SelectedTower, SelectedTowerName].join(",")} onChange={(e) =>{
                                                        const [towerId, towerName] = e.target.value.split(",");
                                                        setSelectedTower(towerId); setSelectedTowerName(towerName)}}>
                                                        <option value="">All Tower</option>
                                                        {TowerList ? TowerList?.map((item, index) =>  <option key={index} value={[item?.towerId, item?.towerName].join(",")}>{item?.towerName}</option>): null}
                                                    </select> */}
                                                            <SelectSearch
                                                                isSearchable={true}
                                                                clearable={SelectedTower ? true : false}
                                                                options={
                                                                    TowerList
                                                                        ? [...TowerList.map(item => ({
                                                                            value: item.towerId,
                                                                            label: item.towerName,
                                                                        }))]
                                                                        : []
                                                                }
                                                                className="sltareamodal"
                                                                placeholder="All Tower"
                                                                // style={{width: "100%", height: "40px"}}
                                                                style={{
                                                                    fontSize: '15px',
                                                                    borderColor: '#ccc',
                                                                    borderRadius: '4px',
                                                                    height: '40px',
                                                                    width: '96%',
                                                                    backgroundColor: '#fff',
                                                                    textAlign: 'left',
                                                                    marginRight: 10
                                                                }}
                                                                dropdownStyle={{
                                                                    width: '200px',
                                                                    // zIndex: 9999
                                                                }}
                                                                values={
                                                                    SelectedTower
                                                                        ? [{ value: SelectedTower, label: SelectedTowerName }]
                                                                        : []
                                                                }
                                                                onChange={(values) => {
                                                                    const sel = values?.[0];
                                                                    const towerId = sel?.value || "";
                                                                    const towerName = sel?.label || "";

                                                                    setSelectedTower(towerId);
                                                                    setSelectedTowerName(towerName);

                                                                    // Clear flat selection & list
                                                                    setSelectedFlat("");
                                                                    setSelectedFlatName("");
                                                                    setFlatList([]);
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-1">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Flat</span>
                                                            <SelectSearch
                                                                isSearchable={true}
                                                                clearable={SelectedFlat ? true : false}
                                                                options={
                                                                    FlatList
                                                                        ? [ ...FlatList.map(item => ({
                                                                            value: item.flatId,
                                                                            label: item.flatName,
                                                                        }))]
                                                                        : []
                                                                }
                                                                className="sltareamodal"
                                                                placeholder="Select Flat"
                                                                // style={{width: "100%", height: "40px"}}
                                                                style={{
                                                                    fontSize: '15px',
                                                                    borderColor: '#ccc',
                                                                    borderRadius: '4px',
                                                                    height: '40px',
                                                                    width: '100%',
                                                                    backgroundColor: '#fff',
                                                                    textAlign: 'left',
                                                                    marginRight: 10
                                                                }}
                                                                dropdownStyle={{
                                                                    width: '200px',
                                                                    // zIndex: 9999
                                                                }}
                                                                values={
                                                                    SelectedFlat
                                                                        ? [{ value: SelectedFlat, label: SelectedFlatName }]
                                                                        : []
                                                                }
                                                                onChange={(values) => {
                                                                    const sel = values?.[0];
                                                                    const flatId = sel?.value || "";
                                                                    const flatName = sel?.label || "";

                                                                    setSelectedFlat(flatId);
                                                                    setSelectedFlatName(flatName);
                                                                }}
                                                            />
                                                        </div>

                                                        {/* <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0" >
                                                    <div style={{display: "flex", marginLeft: 10, marginTop: 10}}>
                                                        <span> Include Family Member</span>
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"  checked={FamilyMember} style={{position: "relative", opacity: 1, left: 0, marginLeft: 5 }} onChange={(e) =>
                                                        setFamilyMember(e.target.checked)} />
                                                    </div>    
                                                </div> */}
                                                        <div className="col-lg-1 col-md-1 col-sm-12 col-12 px-0">
                                                            <a className="reportbtn text-center" onClick={OwnerModal}> Reset </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-1 col-md-1 col-sm-12 col-12 align-content-center text-right">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 pr-0">
                                                            <a className="reportrun" onClick={GetOwnerReport}> Run  </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-right pr-0">
                                                    <div className="filterUpperTop">
                                                        <input type="text" className="onlysearch" value={SearchData} placeholder='Search' onChange={(e) => filterReportData(e.target.value)} />
                                                        <FontAwesomeIcon icon={faSearch} className="searchico" />
                                                        <div className="dropdown">
                                                            <FontAwesomeIcon icon={faDownload} className="reportexlpdf ReportingTools dropdown-toggle float-right" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                            <ul className="dropdown-content">
                                                                <li>
                                                                    {/* <DownloadTableExcel
                                                                filename="In/Out-Report"
                                                                sheet="users"
                                                                currentTableRef={tableRef.current}
                                                            >

                                                            <button type="button" style={{color:'#000'}}> Export excel </button>

                                                            </DownloadTableExcel> */}
                                                                    <button type="button" style={{ color: '#000' }} onClick={handleExport}>Export Excel</button>
                                                                </li>
                                                                <li><button className="color" type="button" disabled={ResidentResidingData ? false : true} onClick={() => OwnerResidentPdf()}> Download PDF</button></li>
                                                            </ul>
                                                        </div>
                                                        {/* <FontAwesomeIcon icon={faEllipsisV} className=" reportexlpdf ReportingTools" /> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2" ref={tableRef}>

                                                <div className="tableFixHead">
                                                    <div className="scrolling_tbl" style={{ height: 'auto', overflow: "hidden" }} ref={targetRef}>

                                                        <Table striped responsive className="mb-0" ref={targetPDFRef} >
                                                            <thead>
                                                                <tr>
                                                                    <th>Flat Owner</th>
                                                                    <th>Flat #</th>
                                                                    <th>Primary User</th>
                                                                    <th>Mobile #</th>
                                                                    <th>Email Id</th>
                                                                    <th>Resident Type</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {ResidentResidingData
                                                                    ? ResidentResidingData?.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item?.userName}</td>
                                                                            <td>{item?.towerName} - {item?.flatName}</td>
                                                                            <td>{item?.isParent ? "Yes" : "No"}</td>
                                                                            <td>{item?.mobileNumber}</td>
                                                                            <td>{item?.emailId}</td>
                                                                            <td>{item?.roleName}</td>
                                                                        </tr>)) : null}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    {/* Tenant Resident Report Modal */}
                    <Modal scrollable
                        fullscreen={fullscreen}
                        show={ShowTenantRepot}
                        onHide={() =>
                            setShowTenantRepot(false)}
                        dialogclassName="modal-100w clientmodal"
                        class="modal-dialog modal-fullscreen"
                    >
                        <Modal.Header className="headerMDL" closeButton>
                            <Modal.Title>Flat Tenant Report</Modal.Title>
                        </Modal.Header>
                        <div className="textFromBehind">
                            <p> Maintain an organized and detailed data of current tenants for accurate records and smooth communication, enhancing tenant management.</p>
                        </div>
                        <Modal.Body>
                            <div className="row" id="validation">
                                <div className="col-12">
                                    <form
                                        action="#"
                                        className="validation-wizard wizard-circle wizard clearfix"
                                        role="application"
                                        id="steps-uid-0"
                                        novalidate="novalidate"
                                    >
                                        <div className="container-fluid mt-3">
                                            <div className="row">
                                                <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                                                    <div className="row">
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-2">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Tower</span>
                                                            {/* <select name="cars" id="cars" className="reportbtn" value={[SelectedTower, SelectedTowerName].join(",")} onChange={(e) =>{
                                                        const [towerId, towerName] = e.target.value.split(",");
                                                        setSelectedTower(towerId); setSelectedTowerName(towerName)}}>
                                                        <option value="">All Tower</option>
                                                        {TowerList ? TowerList?.map((item, index) =>  <option key={index} value={[item?.towerId, item?.towerName].join(",")}>{item?.towerName}</option>): null}
                                                    </select> */}
                                                            <SelectSearch
                                                                isSearchable={true}
                                                                clearable={SelectedTower ? true : false}
                                                                options={
                                                                    TowerList
                                                                        ? [...TowerList.map(item => ({
                                                                            value: item.towerId,
                                                                            label: item.towerName,
                                                                        }))]
                                                                        : []
                                                                }
                                                                className="sltareamodal"
                                                                placeholder="All Tower"
                                                                // style={{width: "100%", height: "40px"}}
                                                                style={{
                                                                    fontSize: '15px',
                                                                    borderColor: '#ccc',
                                                                    borderRadius: '4px',
                                                                    height: '40px',
                                                                    width: '100%',
                                                                    backgroundColor: '#fff',
                                                                    textAlign: 'left',
                                                                    marginRight: 10
                                                                }}
                                                                dropdownStyle={{
                                                                    width: '200px',
                                                                    // zIndex: 9999
                                                                }}
                                                                values={
                                                                    SelectedTower
                                                                        ? [{ value: SelectedTower, label: SelectedTowerName }]
                                                                        : []
                                                                }
                                                                onChange={(values) => {
                                                                    const sel = values?.[0];
                                                                    const towerId = sel?.value || "";
                                                                    const towerName = sel?.label || "";

                                                                    setSelectedTower(towerId);
                                                                    setSelectedTowerName(towerName);

                                                                    // Clear flat selection & list
                                                                    setSelectedFlat("");
                                                                    setSelectedFlatName("");
                                                                    setFlatList([]);
                                                                }}
                                                            />

                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Flat</span>
                                                            {/* <select name="cars" id="cars" className="reportbtn" value={[SelectedFlat, SelectedFlatName].join(",")} onChange={(e) =>{
                                                        const [flatId, flatName] = e.target.value.split(","); 
                                                        setSelectedFlat(flatId); setSelectedFlatName(flatName)}}>
                                                        <option value="">Select Flat</option>
                                                        {FlatList ? FlatList?.map((item, index) =>  <option key={index} value={[item?.flatId, item?.flatName].join(",")}>{item?.flatName}</option>): null}
                                                    </select> */}
                                                            <SelectSearch
                                                                isSearchable={true}
                                                                clearable={SelectedFlat ? true : false}
                                                                options={
                                                                    FlatList
                                                                        ? [...FlatList.map(item => ({
                                                                            value: item.flatId,
                                                                            label: item.flatName,
                                                                        }))]
                                                                        : []
                                                                }
                                                                className="sltareamodal"
                                                                placeholder="Select Flat"
                                                                // style={{width: "96%", height: "40px"}}
                                                                style={{
                                                                    fontSize: '15px',
                                                                    borderColor: '#ccc',
                                                                    borderRadius: '4px',
                                                                    height: '40px',
                                                                    width: '96%',
                                                                    backgroundColor: '#fff',
                                                                    textAlign: 'left',
                                                                    marginRight: 10
                                                                }}
                                                                dropdownStyle={{
                                                                    width: '200px',
                                                                    // zIndex: 9999
                                                                }}
                                                                values={
                                                                    SelectedFlat
                                                                        ? [{ value: SelectedFlat, label: SelectedFlatName }]
                                                                        : []
                                                                }
                                                                onChange={(values) => {
                                                                    const sel = values?.[0];
                                                                    const flatId = sel?.value || "";
                                                                    const flatName = sel?.label || "";

                                                                    setSelectedFlat(flatId);
                                                                    setSelectedFlatName(flatName);
                                                                }}
                                                            />
                                                        </div>

                                                        {/* <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0" >
                                                    <div style={{display: "flex", marginLeft: 10, marginTop: 10}}>
                                                        <span> Include Family Member</span>
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"  checked={FamilyMember} style={{position: "relative", opacity: 1, left: 0, marginLeft: 5 }} onChange={(e) =>
                                                        setFamilyMember(e.target.checked)} />
                                                    </div>    
                                                </div> */}
                                                        <div className="col-lg-1 col-md-1 col-sm-12 col-12 px-0 mr-1">
                                                            <a className="reportbtn text-center" onClick={ResidingResidentModal}> Reset </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-1 col-md-1 col-sm-12 col-12 align-content-center text-right">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 pr-0">
                                                            <a className="reportrun" onClick={GetTenantReport}> Run  </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-right pr-0">
                                                    <div className="filterUpperTop">
                                                        <input type="text" className="onlysearch" value={SearchData} placeholder='Search' onChange={(e) => filterReportData(e.target.value)} />
                                                        <FontAwesomeIcon icon={faSearch} className="searchico" />
                                                        <div className="dropdown">
                                                            <FontAwesomeIcon icon={faDownload} className="reportexlpdf ReportingTools dropdown-toggle float-right" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                            <ul className="dropdown-content">
                                                                <li>
                                                                    {/* <DownloadTableExcel
                                                                filename="In/Out-Report"
                                                                sheet="users"
                                                                currentTableRef={tableRef.current}
                                                            >

                                                            <button type="button" style={{color:'#000'}}> Export excel </button>

                                                            </DownloadTableExcel> */}
                                                                    <button type="button" style={{ color: '#000' }} onClick={handleExport}>Export Excel</button>
                                                                </li>
                                                                <li><button className="color" type="button" disabled={ResidentResidingData ? false : true} onClick={() => TenantResidentPdf()}> Download PDF</button></li>
                                                            </ul>
                                                        </div>
                                                        {/* <FontAwesomeIcon icon={faEllipsisV} className=" reportexlpdf ReportingTools" /> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2" ref={tableRef}>

                                                <div className="tableFixHead">
                                                    <div className="scrolling_tbl" style={{ height: 'auto', overflow: "hidden" }} ref={targetRef}>

                                                        <Table striped responsive className="mb-0" ref={targetPDFRef} >
                                                            <thead>
                                                                <tr>
                                                                    <th>Flat Tenant</th>
                                                                    <th>Flat #</th>
                                                                    <th>Primary User</th>
                                                                    <th>Mobile #</th>
                                                                    <th>Email Id</th>
                                                                    <th>Resident Type</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {ResidentResidingData
                                                                    ? ResidentResidingData?.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item?.userName}</td>
                                                                            <td>{item?.towerName} - {item?.flatName}</td>
                                                                            <td>{item?.isParent ? "Yes" : "No"}</td>
                                                                            <td>{item?.mobileNumber}</td>
                                                                            <td>{item?.emailId}</td>
                                                                            <td>{item?.roleName}</td>
                                                                        </tr>)) : null}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>


                    {/* Vehicle Report Modal */}
                    <Modal scrollable
                        fullscreen={fullscreen}
                        show={ShowVehicleRepot}
                        onHide={() =>
                            setShowVehicleRepot(false)}
                        dialogclassName="modal-100w clientmodal"
                        class="modal-dialog modal-fullscreen"
                    >
                        <Modal.Header className="headerMDL" closeButton>
                            <Modal.Title>Vehicle Report</Modal.Title>
                        </Modal.Header>
                        <div className="textFromBehind">
                            <p> Efficiently monitor and manage all resident and visitor vehicles within the premises, providing organized vehicle tracking and better overall parking management.</p>
                        </div>
                        <Modal.Body>
                            <div className="row" id="validation">
                                <div className="col-12">
                                    <form
                                        action="#"
                                        className="validation-wizard wizard-circle wizard clearfix"
                                        role="application"
                                        id="steps-uid-0"
                                        novalidate="novalidate"
                                    >
                                        <div className="container-fluid mt-3">
                                            <div className="row">
                                                <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                                                    <div className="row">
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-2">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Tower</span>
                                                            {/* <select name="cars" id="cars" className="reportbtn" value={[SelectedTower, SelectedTowerName].join(",")} onChange={(e) =>{
                                                        const [towerId, towerName] = e.target.value.split(",");
                                                        setSelectedTower(towerId); setSelectedTowerName(towerName)}}>
                                                        <option value="">All Tower</option>
                                                        {TowerList ? TowerList?.map((item, index) =>  <option key={index} value={[item?.towerId, item?.towerName].join(",")}>{item?.towerName}</option>): null}
                                                    </select> */}
                                                            <SelectSearch
                                                            clearable={SelectedTower ? true : false}
                                                                options={
                                                                    TowerList
                                                                        ? [...TowerList.map(item => ({
                                                                            id: item.towerId,
                                                                            name: item.towerName,
                                                                        }))]
                                                                        : []
                                                                }
                                                                labelField="name"
                                                                valueField="id"
                                                                className="sltareamodal"
                                                                placeholder="All Tower"
                                                                style={{ width: "100%", height: "40px" }}
                                                                values={
                                                                    SelectedTower
                                                                        ? [{ id: SelectedTower, name: SelectedTowerName }]
                                                                        : []
                                                                }
                                                                onChange={(values) => {
                                                                    const sel = values?.[0];
                                                                    const towerId = sel?.id || "";
                                                                    const towerName = sel?.name || "";

                                                                    setSelectedTower(towerId);
                                                                    setSelectedTowerName(towerName);

                                                                    // Clear flat selection & list
                                                                    setSelectedFlat("");
                                                                    setSelectedFlatName("");
                                                                    setFlatList([]);
                                                                }}
                                                            />

                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Flat</span>
                                                            {/* <select name="cars" id="cars" className="reportbtn" value={[SelectedFlat, SelectedFlatName].join(",")} onChange={(e) =>{
                                                        const [flatId, flatName] = e.target.value.split(","); 
                                                        setSelectedFlat(flatId); setSelectedFlatName(flatName)}}>
                                                        <option value="">Select Flat</option>
                                                        {FlatList ? FlatList?.map((item, index) =>  <option key={index} value={[item?.flatId, item?.flatName].join(",")}>{item?.flatName}</option>): null}
                                                    </select> */}
                                                            <SelectSearch
                                                                options={
                                                                    FlatList
                                                                        ? [ ...FlatList.map(item => ({
                                                                            id: item.flatId,
                                                                            name: item.flatName,
                                                                        }))]
                                                                        : []
                                                                }
                                                                clearable={SelectedFlat ? true : false}
                                                                labelField="name"
                                                                valueField="id"
                                                                className="sltareamodal"
                                                                placeholder="Select Flat"
                                                                style={{ width: "96%", height: "40px" }}
                                                                values={
                                                                    SelectedFlat
                                                                        ? [{ id: SelectedFlat, name: SelectedFlatName }]
                                                                        : []
                                                                }
                                                                onChange={(values) => {
                                                                    const sel = values?.[0];
                                                                    const flatId = sel?.id || "";
                                                                    const flatName = sel?.name || "";

                                                                    setSelectedFlat(flatId);
                                                                    setSelectedFlatName(flatName);
                                                                }}
                                                            />
                                                        </div>


                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-1">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Security Lock</span>
                                                            <select name="cars" id="cars" className="reportbtn" value={SecurityLockSelect} onChange={(e) =>
                                                                setSecurityLockSelect(e.target.value)}>
                                                                <option value="">Select</option>
                                                                <option value="YES">Yes</option>
                                                                <option value="NO">No</option>
                                                            </select>
                                                        </div>

                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-1">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Vehicle Type</span>
                                                            <select name="cars" id="cars" className="reportbtn" value={VehicleTypeSelect} onChange={(e) =>
                                                                setVehicleTypeSelect(e.target.value)}>
                                                                <option value="">Select Vehicle</option>
                                                                <option value="4WHEELER">4 Wheeler</option>
                                                                <option value="2WHEELER">2 Wheeler</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-lg-1 col-md-1 col-sm-12 col-12 px-0 mr-1">
                                                            <a className="reportbtn text-center" onClick={VehicleModal}> Reset </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-1 col-md-1 col-sm-12 col-12 align-content-center text-right">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 pr-0">
                                                            <a className="reportrun" onClick={GetVehicleReport}> Run  </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-right pr-0">
                                                    <div className="filterUpperTop">
                                                        <input type="text" className="onlysearch" value={SearchData} placeholder='Search' onChange={(e) => filterVehicleReportData(e.target.value)} />
                                                        <FontAwesomeIcon icon={faSearch} className="searchico" />
                                                        <div className="dropdown">
                                                            <FontAwesomeIcon icon={faDownload} className="reportexlpdf ReportingTools dropdown-toggle float-right" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                            <ul className="dropdown-content">
                                                                <li>
                                                                    {/* <DownloadTableExcel
                                                                filename="In/Out-Report"
                                                                sheet="users"
                                                                currentTableRef={tableRef.current}
                                                            >

                                                            <button type="button" style={{color:'#000'}}> Export excel </button>

                                                            </DownloadTableExcel> */}
                                                                    <button type="button" style={{ color: '#000' }} onClick={handleExport}>Export Excel</button>
                                                                </li>
                                                                <li><button className="color" type="button" disabled={VehicleData ? false : true} onClick={() => VehiclePdf()}> Download PDF</button></li>
                                                            </ul>
                                                        </div>
                                                        {/* <FontAwesomeIcon icon={faEllipsisV} className=" reportexlpdf ReportingTools" /> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2" ref={tableRef}>

                                                <div className="tableFixHead">
                                                    <div className="scrolling_tbl" style={{ height: 'auto', overflow: "hidden" }} ref={targetRef}>

                                                        <Table striped responsive className="mb-0" ref={targetPDFRef} >
                                                            <thead>
                                                                <tr>
                                                                    <th>Resident Name</th>
                                                                    <th>Flat #</th>
                                                                    <th>Vehicle #</th>
                                                                    <th>Vehicle Type</th>
                                                                    <th>Tag Serial #</th>
                                                                    <th>Fuel Type #</th>
                                                                    <th>Brand</th>
                                                                    <th>Security Lock</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {VehicleData
                                                                    ? VehicleData?.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item?.ownerName}</td>
                                                                            <td>{item?.towerName} - {item?.flatName}</td>
                                                                            <td>{item?.lpNumber}</td>
                                                                            <td>{item?.vehicleType}</td>
                                                                            <td>{item?.tagSerialNumber}</td>
                                                                            <td>{item?.fuelType}</td>
                                                                            <td>{item?.brand}</td>
                                                                            <td>{item?.securityLock ? "Yes" : "No"}</td>
                                                                        </tr>)) : null}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    {/* Service Staff Report Modal */}
                    <Modal scrollable
                        fullscreen={fullscreen}
                        show={ShowStaffRepot}
                        onHide={() =>
                            setShowStaffRepot(false)}
                        dialogclassName="modal-100w clientmodal"
                        class="modal-dialog modal-fullscreen"
                    >
                        <Modal.Header className="headerMDL" closeButton>
                            <Modal.Title>Service Staff Report</Modal.Title>
                        </Modal.Header>
                        <div className="textFromBehind">
                            <p> Efficiently monitor and manage all service staff activities, ensuring organized task tracking and better overall staff management.</p>
                        </div>
                        <Modal.Body>
                            <div className="row" id="validation">
                                <div className="col-12">
                                    <form
                                        action="#"
                                        className="validation-wizard wizard-circle wizard clearfix"
                                        role="application"
                                        id="steps-uid-0"
                                        novalidate="novalidate"
                                    >
                                        <div className="container-fluid mt-3">
                                            <div className="row">
                                                <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                                                    <div className="row">
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-1">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Job Type</span>
                                                            <select name="cars" id="cars" className="reportbtn" value={JobType} onChange={(e) => {
                                                                setJobType(e.target.value);
                                                            }}>
                                                                <option value="">All Job Type</option>
                                                                <option value="PERMANENT" >Permanent</option>
                                                                <option value="TEMPORARY" >Temporary</option>
                                                                <option value="PROBATION" >Probation</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-1">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Department</span>
                                                            <select name="cars" id="cars" className="reportbtn" value={[DepartmentId, DepartmentName].join(",")} onChange={(e) => {
                                                                const [DepartmentId, DepartmentName] = e.target.value.split(",");
                                                                setDepartmentId(DepartmentId); setDepartmentName(DepartmentName); setRoleId(""); setRoleName("")
                                                            }}>
                                                                <option value="">All Department</option>
                                                                {DepartmentList ? DepartmentList?.map((item, index) => <option key={index} value={[item?.departmentId, item?.departmentName]}>{item?.departmentName}</option>) : null}
                                                            </select>
                                                        </div>


                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-1">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Role</span>
                                                            <select name="cars" id="cars" className="reportbtn" value={[RoleId, RoleName].join(",")} onChange={(e) => {
                                                                const [towerId, towerName] = e.target.value.split(",");
                                                                setRoleId(towerId); setRoleName(towerName)
                                                            }}>
                                                                <option value="">All Role</option>
                                                                {RoleList ? RoleList?.map((item, index) => <option key={index} value={[item?.roleId, item?.roleName]}>{item?.roleName}</option>) : null}
                                                            </select>
                                                        </div>
                                                        <div className="col-lg-1 col-md-1 col-sm-12 col-12 px-0">
                                                            <a className="reportbtn text-center" onClick={ServiceStaffModal}> Reset </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-1 col-md-1 col-sm-12 col-12 align-content-center text-right">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 pr-0">
                                                            <a className="reportrun" onClick={fetchDataServiceStaff}> Run  </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-right pr-0">
                                                    <div className="filterUpperTop">
                                                        <input type="text" className="onlysearch" value={SearchData} placeholder='Search' onChange={(e) => filterServiceStaffData(e.target.value)} />
                                                        <FontAwesomeIcon icon={faSearch} className="searchico" />
                                                        <div className="dropdown">
                                                            <FontAwesomeIcon icon={faDownload} className="reportexlpdf ReportingTools dropdown-toggle float-right" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                            <ul className="dropdown-content">
                                                                <li>
                                                                    {/* <DownloadTableExcel
                                                                filename="In/Out-Report"
                                                                sheet="users"
                                                                currentTableRef={tableRef.current}
                                                            >

                                                            <button type="button" style={{color:'#000'}}> Export excel </button>

                                                            </DownloadTableExcel> */}
                                                                    <button type="button" style={{ color: '#000' }} onClick={handleExport}>Export Excel</button>
                                                                </li>
                                                                <li><button className="color" type="button" disabled={ImageLogo ? false : true} onClick={() => ServiceStaffPdf()}> Download PDF</button></li>
                                                            </ul>
                                                        </div>
                                                        {/* <FontAwesomeIcon icon={faEllipsisV} className=" reportexlpdf ReportingTools" /> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2" ref={tableRef}>

                                                <div className="tableFixHead">
                                                    <div className="scrolling_tbl" style={{ height: 'auto', overflow: "hidden" }} ref={targetRef}>

                                                        <Table striped responsive className="mb-0" ref={targetPDFRef} >
                                                            <thead>
                                                                <tr>
                                                                    <th>Staff Name</th>
                                                                    <th>Mobile #</th>
                                                                    <th>Date of Birth</th>
                                                                    <th>Gender</th>
                                                                    <th>Father Name</th>
                                                                    <th>Department (Role)</th>
                                                                    <th>Job Type</th>
                                                                    <th>Date of Join</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {ImageLogo
                                                                    ? ImageLogo?.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item?.userName}</td>
                                                                            <td>{item?.mobileNumber}</td>
                                                                            <td>{item?.dob ? convertISTTime(item?.dob) : null}</td>
                                                                            <td>{item?.gender}</td>
                                                                            <td>{item?.fatherName}</td>
                                                                            <td>{item?.departmentName}:-{item?.roleName}   </td>
                                                                            <td>{item?.jobType}</td>
                                                                            <td>{item?.doj ? convertISTTime(item?.doj) : null}</td>
                                                                        </tr>)) : null}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    {/* HelpDesk Report Modal */}
                    <Modal scrollable
                        fullscreen={fullscreen}
                        show={ShowHelpDeskRepot}
                        onHide={() =>
                            setShowHelpDeskRepot(false)}
                        dialogclassName="modal-100w clientmodal"
                        class="modal-dialog modal-fullscreen"
                    >
                        <Modal.Header className="headerMDL" closeButton>
                            <Modal.Title>Help Desk Report</Modal.Title>
                        </Modal.Header>
                        <div className="textFromBehind">
                            <p> Effectively track and resolve all help desk queries and issues, providing streamlined reporting and enhancing overall service efficiency.</p>
                        </div>
                        <Modal.Body>
                            <div className="row" id="validation">
                                <div className="col-12">
                                    <form
                                        action="#"
                                        className="validation-wizard wizard-circle wizard clearfix"
                                        role="application"
                                        id="steps-uid-0"
                                        novalidate="novalidate"
                                    >
                                        <div className="container-fluid mt-3">
                                            <div className="row">
                                                <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                                                    <div className="row">
                                                        <div className="report__helpdesk_integration pt-0">
                                                            <div className="oneNext">
                                                                <span className="syntax" style={{ position: "static" }}> Start Date</span>
                                                                <input type="date" className="reportbtn" value={StartDate} onChange={(e) => setStartDate(e.target.value)} id="datetime" name="birthday" />
                                                            </div>
                                                            {/* <div className="col-lg-1 col-md-1 col-sm-12 col-12 px-0">
                                                    <input type="time" className="reportbtn" id="birthday" value={StartTime} onChange={(e) => setStartTime(e.target.value)} name="birthday" />
                                                </div> */}
                                                            <div className="oneNext">
                                                                {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                                <span className="syntax" style={{ position: "static" }}> End Date</span>
                                                                <input type="date" className="reportbtn" value={EndDate} onChange={(e) => setEndDate(e.target.value)} id="datetime" name="birthday" />
                                                            </div>
                                                            {/* <div className="col-lg-1 col-md-1 col-sm-12 col-12 px-0">
                                                    <input type="time" className="reportbtn" id="birthday" value={EndTime} onChange={(e) => setEndTime(e.target.value)} name="birthday" />
                                                </div> */}
                                                            <div className="oneNext">
                                                                <span className="syntax" style={{ position: "static" }}> Tower</span>
                                                                {/* <select name="cars" id="cars" className="reportbtn" value={[SelectedTower, SelectedTowerName].join(",")} onChange={(e) =>{
                                                        const [towerId, towerName] = e.target.value.split(",");
                                                        setSelectedTower(towerId); setSelectedTowerName(towerName)}}>
                                                        <option value="">All Tower</option>
                                                        {TowerList ? TowerList?.map((item, index) =>  <option key={index} value={[item?.towerId, item?.towerName].join(",")}>{item?.towerName}</option>): null}
                                                    </select> */}
                                                                <SelectSearch
                                                                    isSearchable={true}
                                                                    clearable={SelectedTower ? true : false}
                                                                    options={
                                                                        TowerList
                                                                            ? [...TowerList.map(item => ({
                                                                                value: item.towerId,
                                                                                label: item.towerName,
                                                                            }))]
                                                                            : []
                                                                    }
                                                                    // labelField="name"
                                                                    // valueField="id"
                                                                    className="sltareamodal"
                                                                    placeholder="All Tower"
                                                                    style={{
                                                                        fontSize: '15px',
                                                                        borderColor: '#ccc',
                                                                        borderRadius: '4px',
                                                                        height: '40px',
                                                                        width: '96%',
                                                                        backgroundColor: '#fff',
                                                                        textAlign: 'left',
                                                                        marginRight: 10
                                                                    }}
                                                                    dropdownStyle={{
                                                                        width: '200px',
                                                                        // zIndex: 9999
                                                                    }}
                                                                    values={
                                                                        SelectedTower
                                                                            ? [{ value: SelectedTower, label: SelectedTowerName }]
                                                                            : []
                                                                    }
                                                                    onChange={(values) => {
                                                                        const sel = values?.[0];
                                                                        const towerId = sel?.value || "";
                                                                        const towerName = sel?.label || "";

                                                                        setSelectedTower(towerId);
                                                                        setSelectedTowerName(towerName);

                                                                        // Clear flat selection & list
                                                                        setSelectedFlat("");
                                                                        setSelectedFlatName("");
                                                                        setFlatList([]);
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="oneNext">
                                                                <span className="syntax" style={{ position: "static" }}> Flat</span>
                                                                {/* <select name="cars" id="cars" className="reportbtn" value={[SelectedFlat, SelectedFlatName].join(",")} onChange={(e) =>{
                                                        const [flatId, flatName] = e.target.value.split(","); 
                                                        setSelectedFlat(flatId); setSelectedFlatName(flatName)}}>
                                                        <option value="">Select Flat</option>
                                                        {FlatList ? FlatList?.map((item, index) =>  <option key={index} value={[item?.flatId, item?.flatName].join(",")}>{item?.flatName}</option>): null}
                                                    </select> */}
                                                                <SelectSearch
                                                                    isSearchable={true}
                                                                    clearable={SelectedFlat ? true : false}
                                                                    options={
                                                                        FlatList
                                                                            ? [...FlatList.map(item => ({
                                                                                value: item.flatId,
                                                                                label: item.flatName,
                                                                            }))]
                                                                            : []
                                                                    }
                                                                    className="sltareamodal"
                                                                    placeholder="Select Flat"
                                                                    style={{
                                                                        fontSize: '15px',
                                                                        borderColor: '#ccc',
                                                                        borderRadius: '4px',
                                                                        height: '40px',
                                                                        width: '96%',
                                                                        backgroundColor: '#fff',
                                                                        textAlign: 'left',
                                                                        marginRight: 10
                                                                    }}
                                                                    dropdownStyle={{
                                                                        width: '200px',
                                                                        // zIndex: 9999
                                                                    }}
                                                                    values={
                                                                        SelectedFlat
                                                                            ? [{ value: SelectedFlat, label: SelectedFlatName }]
                                                                            : []
                                                                    }
                                                                    onChange={(values) => {
                                                                        const sel = values?.[0];
                                                                        const flatId = sel?.value || "";
                                                                        const flatName = sel?.label || "";

                                                                        setSelectedFlat(flatId);
                                                                        setSelectedFlatName(flatName);
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className="oneNext">
                                                                <span className="syntax" style={{ position: "static" }}> Urgent</span>
                                                                <select name="cars" id="cars" className="reportbtn" value={UrgentStatus} onChange={(e) =>
                                                                    setUrgentStatus(e.target.value)}>
                                                                    <option value="">Urgent</option>
                                                                    <option value={true}>Yes</option>
                                                                    <option value={false}>No</option>
                                                                </select>
                                                            </div>




                                                            <div className="oneNext">
                                                                <span className="syntax" style={{ position: "static" }} > Category </span>
                                                                <Select
                                                                    isMulti
                                                                    placeholder="Category"
                                                                    options={optionsCategory}
                                                                    onChange={handleChangeCategory}
                                                                    value={selectedCategories}
                                                                    className="d-inline-block ml-auto w-100"
                                                                />
                                                            </div>
                                                            <div className="oneNext">
                                                                <span className="syntax" style={{ position: "static" }}> Assigned </span>
                                                                <Select
                                                                    isMulti
                                                                    placeholder="Assigned to"
                                                                    options={optionsStaff}
                                                                    onChange={handleChangeStaff}
                                                                    value={selectedStaff}
                                                                    className="d-inline-block ml-auto w-100"
                                                                />
                                                            </div>
                                                            <div className="oneNext">
                                                                <span className="syntax" style={{ position: "static" }}> Status</span>
                                                                <Select
                                                                    isMulti
                                                                    placeholder="Status"
                                                                    options={options}
                                                                    onChange={handleChangeStatus}
                                                                    value={selectedOptions}
                                                                    className="d-inline-block ml-auto w-100"
                                                                />
                                                            </div>

                                                        </div>
                                                        {/* <div className="col-lg-1 col-md-1 col-sm-12 col-12 px-0">
                                                    <a className="reportbtn text-center" onClick={ServiceStaffModal}> Reset </a>
                                                </div> */}
                                                    </div>
                                                </div>
                                                <div className="col-lg-1 col-md-1 col-sm-12 col-12 align-content-center text-right">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 pr-0">
                                                            <a className="reportrun" onClick={SearchComplaint}> Run  </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="row mt-2">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-right pr-0">
                                                    <div className="filterUpperTop">
                                                        <input type="text" className="onlysearch" value={SearchData} placeholder='Search' onChange={(e) => filterHelpdeskData(e.target.value)} />
                                                        <FontAwesomeIcon icon={faSearch} className="searchico" />
                                                        <div className="dropdown">
                                                            <FontAwesomeIcon icon={faDownload} className="reportexlpdf ReportingTools dropdown-toggle float-right" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                            <ul className="dropdown-content">
                                                                <li>
                                                                    {/* <DownloadTableExcel
                                                                filename="In/Out-Report"
                                                                sheet="users"
                                                                currentTableRef={tableRef.current}
                                                            >

                                                            <button type="button" style={{color:'#000'}}> Export excel </button>

                                                            </DownloadTableExcel> */}
                                                                    <button type="button" style={{ color: '#000' }} onClick={handleExport}>Export Excel</button>
                                                                </li>
                                                                <li><button className="color" type="button" disabled={ComplainList ? false : true} onClick={() => ServiceComplaintPdf()}> Download PDF</button></li>
                                                            </ul>
                                                        </div>
                                                        {/* <FontAwesomeIcon icon={faEllipsisV} className=" reportexlpdf ReportingTools" /> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2" ref={tableRef}>

                                                <div className="tableFixHead">
                                                    <div className="" style={{ height: 'auto' }} ref={targetRef}>

                                                        <Table striped responsive className="mb-0" ref={targetPDFRef} >
                                                            <thead>
                                                                <tr>
                                                                    <th>Req#</th>
                                                                    <th>Type</th>
                                                                    <th>Category / Sub-Category</th>
                                                                    <th>Tower - Flat</th>
                                                                    <th>Urgent</th>
                                                                    <th>Created Date</th>
                                                                    <th>Closure Date</th>
                                                                    <th>Status</th>
                                                                    <th>Assigned to</th>
                                                                    <th>Aging</th>
                                                                    <th>ETA</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {ComplainList
                                                                    ? ComplainList?.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item?.complaintId}</td>
                                                                            <td>{item?.applicableLevel}</td>
                                                                            {item.subCategoryName ? <td> <p>{item.categoryName}/{item.subCategoryName}</p></td> : <td > <p>{item.categoryName}</p></td>}
                                                                            <td>{item?.towerName} - {item?.flatName}</td>
                                                                            <td>{item.isUrgent ? "Yes" : "No"}</td>
                                                                            <td>{item.createdDt ? convertISTDateTime(item.createdDt) : null}</td>
                                                                            <td>{item?.resolvedDt ? convertISTDateTime(item?.resolvedDt) : null}</td>
                                                                            <td>{item.statusName}   </td>
                                                                            <td>{item.ssName}</td>
                                                                            <td>{item.aging}</td>
                                                                            <td>{item.eta ? convertISTTime(item.eta) : null}</td>
                                                                        </tr>)) : null}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    {/* Active User Report */}
                    <Modal scrollable
                        fullscreen={fullscreen}
                        show={ActiveRepot}
                        onHide={() =>
                            setActiveRepot(false)}
                        dialogclassName="modal-100w clientmodal"
                        class="modal-dialog modal-fullscreen"
                    >
                        <Modal.Header className="headerMDL" closeButton>
                            <Modal.Title>Active User Report</Modal.Title>
                        </Modal.Header>
                        <div className="textFromBehind">
                            <p> Actively monitor and resolve help desk queries and issues in real-time, with streamlined reporting to boost service efficiency and responsiveness.</p>
                        </div>
                        <Modal.Body>
                            <div className="row" id="validation">
                                <div className="col-12">
                                    <form
                                        action="#"
                                        className="validation-wizard wizard-circle wizard clearfix"
                                        role="application"
                                        id="steps-uid-0"
                                        novalidate="novalidate"
                                    >
                                        <div className="container-fluid mt-3">
                                            <div className="row">
                                                <div className="col-lg-11 col-md-11 col-sm-12 col-12">
                                                    <div className="row">
                                                        {UserData?.roleName == "Super Admin" ?
                                                            <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-2">
                                                                {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                                <span className="syntax"> Building</span>
                                                                <SelectSearch
                                                                    isSearchable={true}
                                                                    options={
                                                                        BuildingList
                                                                            ? BuildingList.map(item => ({
                                                                                value: item.buildingId,
                                                                                label: item.buildingName,
                                                                            }))
                                                                            : []
                                                                    }
                                                                    className="sltareamodal searchDropdown"
                                                                    placeholder="Select Building"
                                                                    style={{
                                                                        fontSize: '15px',
                                                                        borderColor: '#ccc',
                                                                        borderRadius: '4px',
                                                                        height: '40px',
                                                                        width: '100%',
                                                                        backgroundColor: '#fff',
                                                                        textAlign: 'left',
                                                                        marginRight: 10,
                                                                        // whiteSpace: 'nowrap', 
                                                                        // textOverflow: "ellipsis",
                                                                        // paddingTop: 20,
                                                                        // display: "flex"
                                                                    }}
                                                                    dropdownStyle={{
                                                                        width: '150px',
                                                                        marginTop: 10,
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        zIndex: 9999
                                                                    }}
                                                                    // dropdownClassName="searchDropdown"
                                                                    values={
                                                                        BuildingId
                                                                            ? [{ value: BuildingId, label: BuildingList.find(b => b.buildingId === BuildingId)?.buildingName }]
                                                                            : []
                                                                    }
                                                                    onChange={(values) => {
                                                                        const sel = values?.[0];
                                                                        const buildingId = sel?.value || "";
                                                                        setBuildingId(buildingId);

                                                                        // Reset tower and flat selections when building changes
                                                                        setSelectedTower("");
                                                                        setSelectedTowerName("");
                                                                        setFlatList([]);
                                                                        setSelectedFlat("");
                                                                        setSelectedFlatName("");

                                                                        // Optionally, fetch towers for the selected building
                                                                        // You may need to update GetTowerList to accept buildingId as parameter
                                                                        // Example:
                                                                        // GetTowerList(buildingId);
                                                                    }}
                                                                // itemRenderer={({ item, itemIndex,methods }) => (
                                                                //    <div
                                                                //     key={itemIndex}
                                                                //     style={{
                                                                //       padding: "8px 10px",
                                                                //       overflow: "hidden",
                                                                //       textOverflow: "ellipsis",
                                                                //       whiteSpace: "nowrap",
                                                                //       cursor: "pointer", // optional: indicates it's clickable
                                                                //       zIndex: 999,
                                                                //     }}
                                                                //     title={item.label}
                                                                //     onClick={() => methods.addItem(item)} // ✅ This line makes it selectable
                                                                //   >
                                                                //     {item.label}
                                                                //   </div>
                                                                //                                                         )}
                                                                />

                                                            </div>
                                                            : null}
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0 mr-2">
                                                            {/* <a href="#" className="reportbtn"> Attendance Request   </a> */}
                                                            <span className="syntax"> Tower</span>
                                                            <SelectSearch
                                                                isSearchable={true}
                                                                clearable={SelectedTower ? true : false}
                                                                options={
                                                                    TowerList
                                                                        ? [...TowerList.map(item => ({
                                                                            value: item.towerId,
                                                                            label: item.towerName,
                                                                        }))]
                                                                        : []
                                                                }
                                                                className="sltareamodal"
                                                                placeholder="All Tower"
                                                                // style={{width: "100%", height: "40px"}}
                                                                style={{
                                                                    fontSize: '15px',
                                                                    borderColor: '#ccc',
                                                                    borderRadius: '4px',
                                                                    height: '40px',
                                                                    width: '100%',
                                                                    backgroundColor: '#fff',
                                                                    textAlign: 'left',
                                                                    marginRight: 10
                                                                }}
                                                                dropdownStyle={{
                                                                    width: '200px',
                                                                    // zIndex: 9999
                                                                }}
                                                                values={
                                                                    SelectedTower
                                                                        ? [{ value: SelectedTower, label: SelectedTowerName }]
                                                                        : []
                                                                }
                                                                onChange={(values) => {
                                                                    const sel = values?.[0];
                                                                    const towerId = sel?.value || "";
                                                                    const towerName = sel?.label || "";

                                                                    setSelectedTower(towerId);
                                                                    setSelectedTowerName(towerName);

                                                                    // Clear flat selection & list
                                                                    setSelectedFlat("");
                                                                    setSelectedFlatName("");
                                                                    setFlatList([]);
                                                                }}
                                                            />

                                                        </div>
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0">
                                                            <span className="syntax"> Flat</span>
                                                            <SelectSearch
                                                                isSearchable={true}
                                                                clearable={SelectedFlat ? true : false}
                                                                options={
                                                                    FlatList
                                                                        ? FlatList.map(item => ({
                                                                            value: item.flatId,
                                                                            label: item.flatName,
                                                                        }))
                                                                        : []
                                                                }
                                                                className="sltareamodal"
                                                                placeholder="Select Flat"
                                                                // style={{width: "100%", height: "40px"}}
                                                                style={{
                                                                    fontSize: '15px',
                                                                    borderColor: '#ccc',
                                                                    borderRadius: '4px',
                                                                    height: '40px',
                                                                    width: '100%',
                                                                    backgroundColor: '#fff',
                                                                    textAlign: 'left',
                                                                    marginRight: 10
                                                                }}
                                                                dropdownStyle={{
                                                                    width: '200px',
                                                                    // zIndex: 9999
                                                                }}
                                                                values={
                                                                    SelectedFlat
                                                                        ? [{ value: SelectedFlat, label: SelectedFlatName }]
                                                                        : []
                                                                }
                                                                onChange={(values) => {
                                                                    const sel = values?.[0];
                                                                    const flatId = sel?.value || "";
                                                                    const flatName = sel?.label || "";

                                                                    setSelectedFlat(flatId);
                                                                    setSelectedFlatName(flatName);
                                                                }}
                                                            />
                                                        </div>

                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 px-0" >
                                                            <div style={{ display: "flex", marginLeft: 10, marginTop: 10 }}>
                                                                <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" checked={IsResiding} style={{ position: "relative", opacity: 1, left: 0, marginLeft: 5, marginRight: 5 }} onChange={(e) =>
                                                                    setIsResiding(e.target.checked)} />
                                                                <span> Is Residing</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-1 col-md-1 col-sm-12 col-12 px-0">
                                                            <a className="reportbtn text-center" onClick={ResetActiveUserModal}> Reset </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-1 col-md-1 col-sm-12 col-12 align-content-center text-right">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 pr-0">
                                                            <a className="reportrun" onClick={getActiveNextAppUser}> Run  </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-right pr-0">
                                                    <div className="filterUpperTop">
                                                        <input type="text" className="onlysearch" value={SearchData} placeholder='Search' onChange={(e) => filterActiveUserData(e.target.value)} />
                                                        <FontAwesomeIcon icon={faSearch} className="searchico" />
                                                        <div className="dropdown">
                                                            <FontAwesomeIcon icon={faDownload} className="reportexlpdf ReportingTools dropdown-toggle float-right" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                            <ul className="dropdown-content">
                                                                <li>
                                                                    {/* <DownloadTableExcel
                                                                filename="In/Out-Report"
                                                                sheet="users"
                                                                currentTableRef={tableRef.current}
                                                            >

                                                            <button type="button" style={{color:'#000'}}> Export excel </button>

                                                            </DownloadTableExcel> */}
                                                                    <button type="button" style={{ color: '#000' }} onClick={handleExport}>Export Excel</button>
                                                                </li>
                                                                <li><button className="color" type="button" disabled={GetActiveUser ? false : true} onClick={() => ActiveUserPdf()}> Download PDF</button></li>
                                                            </ul>
                                                        </div>
                                                        {/* <FontAwesomeIcon icon={faEllipsisV} className=" reportexlpdf ReportingTools" /> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2" ref={tableRef}>

                                                <div className="tableFixHead">
                                                    <div className="scrolling_tbl" style={{ height: 'auto', overflow: "hidden" }} ref={targetRef}>

                                                        <Table striped responsive className="mb-0" ref={targetPDFRef}>
                                                            <thead>
                                                                <tr>
                                                                    <th>User Name</th>
                                                                    <th>Mobile #</th>
                                                                    <th>Email Id</th>
                                                                    <th>Tower - Flat #</th>
                                                                    <th>Role</th>
                                                                    <th>Parent User</th>
                                                                    <th>Residing</th>
                                                                    <th>Current Status</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {GetActiveUser?.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>{item?.userName}</td>
                                                                        <td>{item?.mobileNumber}</td>
                                                                        <td>{item?.emailId}</td>
                                                                        <td>{item?.towerName} - {item?.flatName}</td>
                                                                        <td>{item?.roleName}</td>
                                                                        <td>{item?.isParent == true ? "Yes" : "No"}</td>
                                                                        <td>{item?.isResiding == true ? "Yes" : "No"}</td>
                                                                        <td>{item?.currentStatus}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    {/* / Add the Resident Scheduling Report modal with fixed table */}
                    <>
                        {/* Resident Scheduling Report Modal */}
                        <Modal
                            show={showResidentSchedulingReport}
                            fullscreen={fullscreen}
                            onHide={() => {
                                setShowResidentSchedulingReport(false);
                                setEditingRow(null);
                            }}
                            aria-labelledby="resident-scheduling-report-modal"
                            centered
                            size="xl"
                        >
                            <Modal.Header closeButton className="headerMDL">
                                <Modal.Title id="resident-scheduling-report-modal">
                                    Report Scheduling
                                </Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                {/* Add Report Master Link */}
                                <div className="mb-3 text-end">
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowAddReportMasterModal(true);
                                        }}
                                        style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer" }}
                                    >
                                        <FontAwesomeIcon icon={faPlus} className="me-2" />
                                        Add Report
                                    </a>
                                </div>

                                {scheduleLoading && (
                                    <div className="text-center py-3">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                )}

                                {scheduleError && (
                                    <div className="alert alert-danger" role="alert">
                                        {scheduleError}
                                    </div>
                                )}

                                {!scheduleLoading && !scheduleError && (
                                    <div style={{ overflowX: "auto" }}>
                                        <Table striped bordered hover responsive className="compact-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "20%" }}>Report Name</th>
                                                    <th style={{ width: "25%" }}>Frequency</th>
                                                    <th style={{ width: "30%" }}>Report Recipients</th>
                                                    <th style={{ width: "10%" }}>Action</th>
                                                    <th style={{ width: "15%" }}>Run Manually</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {residentSchedulingData.map((data, index) => {
                                                    const selectedScheduling = schedulingSelections[data.reportName] || [];
                                                    const recipients = reportRecipients[data.reportName] || "";
                                                    const period = runManuallyPeriods[data.reportName] || "";
                                                    const recipientCount = recipients
                                                        ? recipients.split(",").filter((r) => r.trim()).length
                                                        : 0;
                                                    const isRunning = runningRows[data.reportName] || false;
                                                    const isEditing = editingRow === data.reportName;
                                                    const hasData = selectedScheduling.length > 0 || recipients.trim() !== "";

                                                    return (
                                                        <tr key={index}>
                                                            {/* Report Name Column */}
                                                            <td>
                                                                <div
                                                                    style={{
                                                                        fontWeight: "600",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                    }}
                                                                >
                                                                    {data.reportName}
                                                                </div>
                                                            </td>

                                                            {/* Scheduling Column */}
                                                            <td>
                                                                {isEditing ? (
                                                                    <CustomMultiSelect
                                                                        options={schedulingOptions}
                                                                        selected={selectedScheduling}
                                                                        onChange={(selected) =>
                                                                            setSchedulingSelections((prev) => ({
                                                                                ...prev,
                                                                                [data.reportName]: selected,
                                                                            }))
                                                                        }
                                                                        reportName={data.reportName}
                                                                    />
                                                                ) : (
                                                                    <div style={{ padding: "8px 0" }}>
                                                                        {selectedScheduling.length > 0
                                                                            ? selectedScheduling.join(", ")
                                                                            : "No Scheduling"}
                                                                    </div>
                                                                )}
                                                            </td>

                                                            {/* Report Recipients Column */}
                                                            <td>
                                                                {isEditing ? (
                                                                    <div>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Enter emails (comma-separated)"
                                                                            value={recipients}
                                                                            onChange={(e) =>
                                                                                setReportRecipients((prev) => ({
                                                                                    ...prev,
                                                                                    [data.reportName]: e.target.value,
                                                                                }))
                                                                            }
                                                                        />
                                                                        {/* {recipientCount > 0 && (
                                                        <small className="text-muted">
                                                        {recipientCount} recipient{recipientCount > 1 ? "s" : ""}
                                                        </small>
                                                    )} */}
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        style={{
                                                                            padding: "8px 0",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            whiteSpace: "nowrap",
                                                                        }}
                                                                        title={recipients}
                                                                    >
                                                                        {recipients || "No Report Recipients"}
                                                                    </div>
                                                                )}
                                                            </td>

                                                            {/* Action Column (Edit + Delete) */}
                                                            <td>
                                                                <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                                                                    {/* Edit/Save Button */}
                                                                    {isEditing ? (
                                                                        <button
                                                                            className="btn btn-sm btn-success"
                                                                            onClick={() => handleSaveReportSchedule(data)}
                                                                            disabled={isRunning}
                                                                            title="Save"
                                                                            style={{ width: "32px", height: "32px" }}
                                                                        >
                                                                            <FontAwesomeIcon icon={faCheck} />
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            className="btn btn-sm btn-primary"
                                                                            onClick={() => setEditingRow(data.reportName)}
                                                                            disabled={isRunning}
                                                                            title="Edit"
                                                                            style={{ width: "32px", height: "32px" }}
                                                                        >
                                                                            <FontAwesomeIcon icon={faPenToSquare} />
                                                                        </button>
                                                                    )}

                                                                    {/* Delete Button */}
                                                                    <button
                                                                        className="btn btn-sm btn-danger"
                                                                        onClick={() => handleDeleteReportClick(data.reportName, data.scheduleId)}
                                                                        disabled={isRunning || !data.scheduleId}
                                                                        title="Delete"
                                                                        style={{ width: "32px", height: "32px" }}
                                                                    >
                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                    </button>
                                                                </div>
                                                            </td>

                                                            {/* Run Manually Column (Period Dropdown + Run Button) */}
                                                            <td>
                                                                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                                                    {/* Period Dropdown */}
                                                                    <select
                                                                        className="form-select form-select-sm"
                                                                        value={period}
                                                                        onChange={(e) =>
                                                                            setRunManuallyPeriods((prev) => ({
                                                                                ...prev,
                                                                                [data.reportName]: e.target.value,
                                                                            }))
                                                                        }
                                                                        style={{ fontSize: "13px", flex: 1 }}
                                                                        disabled={isRunning}
                                                                    >
                                                                        <option value="">Select Period</option>
                                                                        {periodOptions.map((option) => (
                                                                            <option key={option} value={option}>
                                                                                {option}
                                                                            </option>
                                                                        ))}
                                                                    </select>

                                                                    {/* Run Button */}
                                                                    <button
                                                                        className="btn btn-sm btn-success"
                                                                        onClick={() => handleRunManually(data)}
                                                                        disabled={isRunning || !hasData || !period}
                                                                        style={{ fontSize: "12px", minWidth: "50px", padding: "4px 8px" }}
                                                                        title="Run report with selected period"
                                                                    >
                                                                        {isRunning ? (
                                                                            <span
                                                                                className="spinner-border spinner-border-sm"
                                                                                role="status"
                                                                                aria-hidden="true"
                                                                                style={{ width: "12px", height: "12px" }}
                                                                            ></span>
                                                                        ) : (
                                                                            "Run"
                                                                        )}
                                                                    </button>
                                                                </div>
                                                            </td>


                                                        </tr>
                                                    );
                                                })}
                                            </tbody>

                                        </Table>
                                    </div>
                                )}

                                {!scheduleLoading && !scheduleError && residentSchedulingData.length === 0 && (
                                    <div className="text-center py-5 text-muted">No reports available</div>
                                )}
                            </Modal.Body>

                            <Modal.Footer style={{ display: "flex", justifyContent: "space-between" }}>
                                {/* <button
                                className="btn btn-secondary"
                                onClick={() => clearFilter("residentScheduling")}
                                disabled={scheduleLoading}
                                >
                                Clear Filter
                                </button> */}

                                <button
                                    className="btn btn-light"
                                    onClick={() => {
                                        setShowResidentSchedulingReport(false);
                                        setEditingRow(null);
                                    }}
                                    disabled={scheduleLoading}
                                >
                                    Close
                                </button>
                            </Modal.Footer>
                        </Modal>

                    </>

                    {/* Add Report Master Modal - Half Screen */}
                    <Modal
                        show={showAddReportMasterModal}
                        onHide={() => {
                            setShowAddReportMasterModal(false);
                            setNewReportMaster({ reportName: "", reportShortName: "" });
                            setEditingReportMaster(null);
                        }}
                        centered
                        size="lg"
                        dialogClassName="modal-50h"
                    >
                        <Modal.Header closeButton className="headerMDL">
                            <Modal.Title>Master Report</Modal.Title>
                        </Modal.Header>

                        <Modal.Body style={{ maxHeight: "50vh", overflowY: "auto" }}>


                            {/* Report Master List as Tiles */}
                            {reportMasterLoading && (
                                <div className="text-center py-3">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            )}

                            {!reportMasterLoading && reportMasterList.length === 0 && (
                                <div className="text-center py-5 text-muted">No report masters available</div>
                            )}

                            {!reportMasterLoading && reportMasterList.length > 0 && (
                                <div className="row">
                                    {reportMasterList.map((master, index) => (
                                        <div key={index} className="col-md-6 mb-3">
                                            <div
                                                className="card h-100 shadow-sm"
                                                style={{
                                                    borderLeft: "4px solid #0d6efd",
                                                    transition: "transform 0.2s",
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = "translateY(-3px)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = "translateY(0)";
                                                }}
                                            >
                                                <div className="card-body p-0">
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <div style={{ flex: 1 }}>
                                                            <h6 className="card-title mb-2" style={{ fontWeight: "600" }}>
                                                                {master.reportName}
                                                            </h6>
                                                            <p className="card-text text-muted mb-0" style={{ fontSize: "14px" }}>
                                                                <strong>Short Name:</strong> {master.reportShortName}
                                                            </p>
                                                        </div>
                                                        <div style={{ display: "flex", gap: "5px" }}>
                                                            {/* Edit Button */}
                                                            <button
                                                                className="btn btn-sm btn-outline-primary"
                                                                onClick={() => {
                                                                    setEditingReportMaster(master);
                                                                    setNewReportMaster({
                                                                        reportName: master.reportName,
                                                                        reportShortName: master.reportShortName,
                                                                    });
                                                                }}
                                                                title="Edit"
                                                                style={{ width: "32px", height: "32px" }}
                                                            >
                                                                <FontAwesomeIcon icon={faPenToSquare} />
                                                            </button>

                                                            {/* Delete Button - Change onClick */}
                                                            <button
                                                                className="btn btn-sm btn-outline-danger"
                                                                onClick={() =>
                                                                    handleDeleteReportMasterClick(master.reportMasterId, master.reportName)
                                                                }
                                                                title="Delete"
                                                                style={{ width: "32px", height: "32px" }}
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {/* Add/Edit Form */}
                            <div className="mb-4 p-3 border rounded bg-light">
                                {/* <h6 className="mb-3">
                            {editingReportMaster ? "Edit Report Master" : "Add New Report Master"}
                        </h6> */}
                                <div className="row">
                                    <div className="col-md-5 mb-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Report Name"
                                            value={newReportMaster.reportName}
                                            onChange={(e) =>
                                                setNewReportMaster((prev) => ({
                                                    ...prev,
                                                    reportName: e.target.value,
                                                }))
                                            }
                                        />
                                    </div>
                                    <div className="col-md-5 mb-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Report Short Name"
                                            value={newReportMaster.reportShortName}
                                            onChange={(e) =>
                                                setNewReportMaster((prev) => ({
                                                    ...prev,
                                                    reportShortName: e.target.value,
                                                }))
                                            }
                                        />
                                    </div>
                                    <div className="col-md-2 mb-2">
                                        {editingReportMaster ? (
                                            <div style={{ display: "flex", gap: "5px" }}>
                                                <button
                                                    className="btn btn-success btn-sm"
                                                    onClick={() => handleUpdateReportMaster(editingReportMaster.reportMasterId)}
                                                    disabled={reportMasterLoading}
                                                >
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </button>
                                                <button
                                                    className="btn btn-secondary btn-sm"
                                                    onClick={() => {
                                                        setEditingReportMaster(null);
                                                        setNewReportMaster({ reportName: "", reportShortName: "" });
                                                    }}
                                                    disabled={reportMasterLoading}
                                                >
                                                    <FontAwesomeIcon icon={faTimes} />
                                                </button>
                                            </div>
                                        ) : (
                                            <button
                                                className="btn btn-primary btn-sm w-100"
                                                onClick={handleAddReportMaster}
                                                disabled={reportMasterLoading}
                                            >
                                                <FontAwesomeIcon icon={faPlus} className="me-1" />
                                                Add
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <button
                                className="btn btn-secondary"
                                onClick={() => {
                                    setShowAddReportMasterModal(false);
                                    setNewReportMaster({ reportName: "", reportShortName: "" });
                                    setEditingReportMaster(null);
                                }}
                                disabled={reportMasterLoading}
                            >
                                Close
                            </button>
                        </Modal.Footer>
                    </Modal>




                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 mb-5">
                            <div className="UpperReportHeading">
                                <h3> Resident </h3>
                            </div>
                            <div className="LHSReport" style={{ height: 740 }}>
                                <ul>
                                    <li onClick={() => setInputValue()} style={{ cursor: "pointer", display: UserData?.roleName == "Society HelpDesk" ? "none" : "inline-masonry" }}><Link>Resident In/Out Report</Link> <br />
                                        <span>  Efficiently track and review the entry and exit activities of residents, ensuring comprehensive monitoring of daily movements within the building.</span>
                                    </li>
                                    <li onClick={() => ResidingResidentModal()} style={{ cursor: "pointer", display: UserData?.roleName == "Society HelpDesk" ? "none" : "inline-masonry" }}> <Link>Residing Resident Report</Link> <br />
                                        <span>  Access a detailed, up-to-date list of all residents currently residing in the community, providing easy management for building administrators.</span>
                                    </li>
                                    <li onClick={() => OwnerModal()} style={{ cursor: "pointer", display: UserData?.roleName == "Society HelpDesk" ? "none" : "inline-masonry" }}> <Link>Flat Owner Report</Link>  <br />
                                        <span>  Get in-depth information on flat owners to streamline operations and elevate building management.</span>
                                    </li>
                                    <li onClick={() => TenantModal()} style={{ cursor: "pointer", display: UserData?.roleName == "Society HelpDesk" ? "none" : "inline-masonry" }}> <Link>Flat Tenant Report</Link>  <br />
                                        <span>  Maintain an organized and detailed data of current tenants for accurate records and smooth communication, enhancing tenant management.</span>
                                    </li>
                                    <li onClick={() => HelpDeskModal()} style={{ cursor: "pointer" }}> <Link>Help Desk Report</Link>  <br />
                                        <span>  Effectively track and resolve all help desk queries and issues, providing streamlined reporting and enhancing overall service efficiency.</span>
                                    </li>
                                    <li onClick={() => ActiveUserModal()} style={{ cursor: "pointer", display: UserData?.roleName == "Society HelpDesk" ? "none" : "inline-masonry" }}> <Link>Active User Report</Link>  <br />
                                        <span>  Actively monitor and resolve help desk queries and issues in real-time, with streamlined reporting to boost service efficiency and responsiveness.</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12" style={{display: UserData?.roleName == "Society HelpDesk" ? "none" : "block"}}>
                            <div className="UpperReportHeading">
                                <h3> Visitor </h3>
                            </div>
                            <div className="RHSReport" style={{ height: 500 }}>
                                <ul>
                                    <li onClick={() => VisitorModal()}><Link style={{ cursor: "pointer" }}> Visitor In/Out Report</Link><br />
                                        <span>  Track visitor entry and exit activities closely to boost transparency and ensure a secure, well-monitored environment for all residents.</span>
                                    </li>
                                    <li onClick={() => WalkInModal()} style={{ cursor: "pointer" }}><Link> Walk-in Visitor In/Out Report </Link><br />
                                        <span>  Record and review walk-in visitor details thoroughly, enabling administrators to maintain a safer, more controlled environment.</span>
                                    </li>
                                    <li onClick={() => VehicleModal()}><Link>Vehicle Report</Link>  <br />

                                        <span>  Efficiently monitor and manage all resident and visitor vehicles within the premises, providing organized vehicle tracking and better overall parking management.</span>
                                    </li>
                                    <li onClick={() => ServiceStaffModal()}><Link>Service Staff</Link>  <br />

                                        <span>  Efficiently monitor and manage all service staff activities, ensuring organized task tracking and better overall staff management.</span>
                                    </li>
                                    <li onClick={ServiceStaffInOutModal}>
    <Link>Service Staff In/Out</Link>
    <br />

    <span>
        Efficiently monitor and track service staff entry and exit activities,
        providing organized attendance monitoring and better overall staff movement management.
    </span>
</li>

                                    
                                </ul>
                            </div>
                        </div>
                        {/* <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="UpperReportHeading">
                                <h3> Master </h3>
                            </div>
                            <div className="RHSReport" style={{height: 450}}>
                                <ul>
                                <li onClick={() => setShowTowerReport(true)}><Link  style={{cursor:"pointer"}}> Tower Report</Link><br/>  
                                    <span>  Track visitor entry and exit activities closely to boost transparency and ensure a secure, well-monitored environment for all residents.</span>
                                </li>
                                <li onClick={() => WalkInModal()} style={{cursor: "pointer"}}><Link> Flat Report </Link><br/>  
                                    <span>  Record and review walk-in visitor details thoroughly, enabling administrators to maintain a safer, more controlled environment.</span>
                                </li>
                                <li onClick={() => VehicleModal()}><Link>Vehicle Report</Link>  <br/>  
                                    
                                    <span>  Efficiently monitor and manage all resident and visitor vehicles within the premises, providing organized vehicle tracking and better overall parking management.</span>
                                </li>
                                <li onClick={() => ServiceStaffModal()}><Link>Service Staff</Link>  <br/>  
                                    
                                    <span>  Efficiently monitor and manage all service staff activities, ensuring organized task tracking and better overall staff management.</span>
                                </li>
                                
                                </ul>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>
            {/* Tower Report Modal Component */}
            <TowerReport
                show={ShowTowerReport}
                onHide={() => setShowTowerReport(false)}
                fullscreen={fullscreen}
            />

            {/* Delete Confirmation Modal */}
            <Modal
                centered
                show={DeleteShow}
                onHide={() => {
                    setDeleteShow(false);
                    setDeleteTarget(null);
                }}
                dialogClassName="modal-100w"
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Body className="p-0" style={{ borderRadius: "10px", overflow: "hidden" }}>
                    <div className="row px-3" id="validation">
                        <div className="col-12 bg-white pt-3 pb-2">
                            <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                <div className="FnFtxt">
                                    <h2>
                                        {deleteType === "reportSchedule"
                                            ? "Delete Report Schedule"
                                            : "Delete Report Master"}
                                    </h2>
                                    <h3>
                                        {deleteType === "reportSchedule"
                                            ? `Are you sure you want to delete "${deleteTarget?.reportName}" schedule?`
                                            : `Are you sure you want to delete "${deleteTarget?.reportName}"?`}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="confirmation_btn pb-4 pt-3 px-3"
                        style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}
                    >
                        <div className="both_ConfrmBTN col-6" onClick={handleConfirmDelete}>
                            <Button variant="danger">Delete</Button>
                        </div>
                        <div
                            className="both_ConfrmBTN col-6"
                            onClick={() => {
                                setDeleteShow(false);
                                setDeleteTarget(null);
                            }}
                        >
                            <Button variant="light">Cancel</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
          <ServiceStaffInOutReport
    show={showServiceStaffInOutReport}
    onHide={() => setShowServiceStaffInOutReport(false)}
    UserData={UserData}
/>

        </>
    );
}
export default Report;
